{
  "menu": {
    "category": {
      "userManagement": "User Management",
      "settings": "Settings",
      "securityCompliance": "Security & Compliance",
      "adminTools": "Admin Tools",
      "internalAdminTools": "Internal Tools",
      "system": "System",
      "orgAdmin": "Org Admin",
      "communication": "Communication",
      "widget": "Widget",
      "feature": "Feature",
      "admin": "Admin",
      "sidecar": "Mobile",
      "auth": "Authentication",
      "crm": "CRM",
      "tuvis-mobile": "Tuvis Remote Sync",
      "tuvis-desktop": "Tuvis Desktop App",
      "integrations": "Integrations",
      "integrationsChannels": "Channels",
      "other": "Channels",
      "platforms": "Platforms",
      "archive": "Archive",
      "notifications": "Notifications",
      "tuvisAdmin": "Tuvis Admin"
    }
  },
  "bot_builder": {
    "title": "Bot Builder",
    "variable_name_required": "Variable name is required",
    "variable_name_reserved_prefix": "Variable names cannot start with $ (reserved for built-in functions)",
    "nav_flows": "Flows",
    "nav_analytics": "Analytics",
    "nav_credentials": "Credentials",
    "nav_sessions": "Sessions",
    "nav_triggers": "Triggers",
    "nav_settings": "Settings",
    "sessions": {
      "title": "Sessions",
      "sender": "Sender",
      "flow": "Flow",
      "status": "Status",
      "started_at": "Started",
      "last_activity": "Last Activity",
      "duration": "Duration",
      "current_node": "Current Node",
      "flow_version": "Flow Version",
      "all_flows": "All Flows",
      "all_statuses": "All Statuses",
      "no_sessions": "No sessions found",
      "event_timeline": "Event Timeline",
      "event_type": "Event",
      "event_node": "Node",
      "event_time": "Time",
      "event_error": "Error",
      "no_events": "No events recorded for this session",
      "debug_title": "Session Debug",
      "back_to_sessions": "Back to Sessions",
      "stop": "Stop",
      "stop_confirm_title": "Stop session?",
      "stop_confirm_body": "This will end the session immediately. The user's next message will start a new session.",
      "handoff": "Handoff",
      "status_labels": {
        "active": "Active",
        "waiting_input": "Waiting for input",
        "handoff": "Handoff",
        "completed": "Completed",
        "expired": "Expired",
        "error": "Error",
        "stopped": "Stopped",
        "replaced": "Replaced"
      },
      "refresh": "Refresh",
      "back_to_session": "Back to session",
      "activity": {
        "title": "Session activity at this node",
        "visits": "Visits",
        "errors": "Errors",
        "no_activity": "This node has not been visited in this session"
      },
      "event_data": {
        "sender": "Sender",
        "phone_id": "Phone ID",
        "type": "Type",
        "text": "Text",
        "template": "Template",
        "params": "Params",
        "flow_id": "Flow ID",
        "cta": "CTA",
        "input": "Input",
        "variable": "Variable",
        "request": "Request",
        "status": "Status",
        "duration": "Duration",
        "error": "Error",
        "response_body": "Response body",
        "model": "Model",
        "input_tokens": "Input tokens",
        "output_tokens": "Output tokens",
        "response": "Response",
        "reason": "Reason",
        "message": "Message",
        "empty_value": "(empty)"
      },
      "source": "Source",
      "triggered_by": "Triggered By",
      "trigger_batch": "Trigger Batch",
      "replaced_by": "Replaced By",
      "all_sources": "All Sources",
      "source_labels": {
        "message": "Message",
        "ui": "UI",
        "api": "API"
      }
    },
    "analytics": {
      "select_flow": "Select a flow",
      "select_flow_hint": "Select a flow to view analytics",
      "date_range": "Date Range",
      "total_sessions": "Total Sessions",
      "completed_sessions": "Completed Sessions",
      "completion_rate": "Completion Rate",
      "handoffs": "Handoffs",
      "handoff_rate": "Handoff Rate",
      "errors": "Errors",
      "expired_sessions": "Expired Sessions",
      "active_sessions": "Active Sessions",
      "sessions_over_time": "Sessions Over Time",
      "load_error": "Failed to load"
    },
    "palette": {
      "title": "Building Blocks",
      "ai_no_providers": "Connect an AI provider in integrations to use this node",
      "transcribe_no_providers": "Connect an audio transcribe provider in integrations to use this node"
    },
    "create_flow": "+ Create Flow",
    "assign_to_phone": "Assign to phone",
    "edit_flow": "Edit Flow",
    "edit_flow_metadata": "Edit Name & Description",
    "update_flow_success": "Flow updated successfully",
    "update_flow_failure": "Failed to update flow",
    "delete_flow": "Delete Flow",
    "publish_flow": "Publish Flow",
    "publish_latest_version": "Publish Latest Version",
    "unpublish_flow": "Unpublish Flow",
    "archive_flow": "Archive Flow",
    "name": "Name",
    "channel": "Channel",
    "description": "Description",
    "status": "Status",
    "status_draft": "Draft",
    "status_published": "Published",
    "status_archived": "Archived",
    "version": "Latest Version",
    "published_version": "Published Version",
    "published_at": "Published At",
    "updated_at": "Updated At",
    "created_at": "Created At",
    "create_flow_success": "Flow created successfully",
    "create_flow_failure": "Failed to create flow",
    "save_flow_success": "Flow saved successfully",
    "save_flow_failure": "Failed to save flow",
    "publish_flow_success": "Flow published successfully",
    "publish_flow_failure": "Failed to publish flow",
    "validation_errors": {
      "flow_missing_start_node": "Flow must have a start node",
      "start_node_no_outgoing": "Start node must have at least one outgoing connection",
      "edge_invalid_source": "An edge references a non-existent source node",
      "edge_invalid_target": "An edge references a non-existent target node",
      "wait_reply_missing_variable": "Wait for Reply node must have a variable name",
      "send_message_missing_content": "Send Message node must have content",
      "send_message_missing_text": "Send Message node must have a text message",
      "template_missing_name": "Send Message node must have a template selected",
      "interactive_flow_missing_flow": "Send Message node must have a WhatsApp Flow selected",
      "api_call_missing_url": "API Call node must have a URL",
      "api_call_missing_method": "API Call node must have an HTTP method",
      "send_message_missing_message_type": "Send Message node must have a message type",
      "duplicate_variable_name": "Variable name is already used by another node",
      "interactive_flow_missing_body": "WhatsApp Flow node must have a message body",
      "interactive_flow_missing_cta": "WhatsApp Flow node must have a button text",
      "interactive_flow_missing_screen": "WhatsApp Flow node must have a starting screen selected",
      "ai_missing_prompt": "AI node must have a prompt",
      "ai_missing_response_variable": "AI node must have a response variable",
      "variable_name_reserved_prefix": "Variable names cannot start with $ (reserved for built-in functions)",
      "variable_name_no_spaces": "Variable names cannot contain spaces",
      "set_variable_missing_assignments": "Set Variable node must have at least one assignment",
      "set_variable_missing_target": "Set Variable assignment must have a variable name",
      "flow_variable_missing_name": "Flow variable must have a name",
      "transcribe_missing_source_variable": "Missing source variable",
      "transcribe_missing_response_variable": "Missing response variable"
    },
    "unpublish_flow_success": "Flow reverted to draft",
    "unpublish_flow_failure": "Failed to unpublish flow",
    "delete_flow_success": "Flow deleted successfully",
    "delete_flow_failure": "Failed to delete flow",
    "clone_flow": "Clone flow",
    "clone_flow_success": "Flow cloned",
    "clone_flow_failure": "Failed to clone flow",
    "clone_modal": {
      "title": "Clone bot flow",
      "name_label": "New flow name",
      "scope_label": "What to copy",
      "scope_all": "All versions",
      "scope_latest": "Latest version only",
      "submit": "Clone"
    },
    "compare": {
      "title": "Compare v{{left}} vs v{{right}}",
      "version_x": "Version {{version}}",
      "fields_diff": "Settings & variables",
      "fields_no_changes": "No changes in settings or variables",
      "minutes_value": "{{count}} min",
      "variable_label_plural": "Variables",
      "variable_required": "required",
      "variable_field_required": "Required",
      "variable_field_defaultValue": "Default",
      "variable_field_description": "Description",
      "select_two": "Select exactly two versions to compare",
      "compare_button": "Compare selected",
      "start_compare": "Compare versions",
      "cancel_compare": "Cancel",
      "summary_modified": "{{count}} modified",
      "summary_added": "{{count}} added",
      "summary_removed": "{{count}} removed",
      "legend_added": "Added",
      "legend_removed": "Removed",
      "legend_modified": "Modified",
      "legend_unchanged": "Unchanged",
      "changes_panel_title": "Changes",
      "changes_section_added": "Added",
      "changes_section_modified": "Modified",
      "changes_section_removed": "Removed",
      "changes_empty": "No changes",
      "mode_side_by_side": "Side-by-side",
      "mode_overlay": "Overlay",
      "drilldown_title": "Field changes",
      "drilldown_no_data_changes": "Only metadata changed (position, label, etc.)",
      "page_title": "Compare v{{left}} vs v{{right}}",
      "invalid_range": "Invalid version range",
      "back": "Back to flow"
    },
    "assign_phones_success": "Phone numbers assigned successfully",
    "assign_phones_failure": "Failed to assign phone numbers",
    "confirm_publish_title": "Publish Flow",
    "confirm_publish_body": "This flow will be activated and start handling conversations. Are you sure?",
    "confirm_unpublish_title": "Unpublish Flow",
    "confirm_unpublish_body": "This flow will be reverted to draft and stop handling conversations. Are you sure?",
    "confirm_delete_title": "Delete Flow",
    "confirm_delete_body": "This flow will be permanently deleted and cannot be recovered. Are you sure?",
    "unsaved_confirm_title": "Unsaved changes",
    "unsaved_confirm_body": "You have unsaved changes. Are you sure you want to leave?",
    "settings": {
      "title": "Bot Settings",
      "session_history_retention": "Session History Retention",
      "session_history_retention_description": "How long to keep completed session data for debugging and analytics.",
      "retention_days": "{{days}} days",
      "retention_saved": "Retention setting saved",
      "retention_save_failed": "Failed to save retention setting",
      "save": "Save"
    },
    "test": "Test",
    "save": "Save",
    "publish": "Publish",
    "test_chat": {
      "title": "Test Chat",
      "start": "Start Test",
      "reset": "Reset",
      "send": "Send",
      "empty_state": "Test your flow by simulating a conversation. Messages won't be sent to WhatsApp.",
      "type_message": "Type a message...",
      "waiting": "Bot is processing...",
      "session_ended": "Session ended",
      "session_handoff": "Transferred to agent",
      "variables": "Variables",
      "text_mode": "Text",
      "flow_reply_mode": "Flow Reply"
    },
    "unsaved": "Unsaved",
    "unpublished_changes": "Unpublished changes",
    "versions": "Versions",
    "version_history": "Version History",
    "version_x": "Version {{version}}",
    "current": "Current",
    "no_versions": "No published versions yet",
    "viewing_version": "Viewing version {{version}}",
    "back_to_draft": "Back to draft",
    "publish_this_version": "Publish this version",
    "was_published": "Previously published",
    "save_modal": {
      "title": "Save Changes",
      "subtitle": "This will create a new version of your flow.",
      "description_placeholder": "Describe what changed (optional)"
    },
    "publish_modal": {
      "title": "Publish Flow",
      "body": "Are you sure you want to publish version {{version}}? This will make it live for all assigned phone numbers."
    },
    "flow_settings_title": "Flow Settings",
    "session_duration_label": "Session Duration (minutes)",
    "session_duration_placeholder": "No timeout",
    "session_duration_hint": "Leave empty or 0 for no session timeout.",
    "session_expired_message_label": "Session Expired Message",
    "session_expired_message_placeholder": "Your session has expired. Please send a message to start again.",
    "session_expired_message_hint": "Sent when the session expires. Use {{variable}} to insert values, or {{variable|default}} to provide a fallback if the variable is not set.",
    "inactivity_timeout_label": "Inactivity Timeout (minutes)",
    "inactivity_timeout_placeholder": "No timeout",
    "inactivity_timeout_hint": "Session expires if the user doesn't respond within this time. Resets on each message.",
    "inactivity_timeout_message_label": "Inactivity Timeout Message",
    "inactivity_timeout_message_placeholder": "We haven't heard from you in a while. Your session has ended.",
    "inactivity_timeout_message_hint": "Sent when the session expires due to inactivity. Use {{variable}} to insert values, or {{variable|default}} to provide a fallback if the variable is not set.",
    "unsaved_confirm_leave": "Leave",
    "unsaved_confirm_stay": "Stay",
    "modal": {
      "create_title": "Create Flow",
      "edit_title": "Edit Flow",
      "edit_subtitle": "Update the flow name and description. This won't affect any versions.",
      "name_label": "Flow Name",
      "name_placeholder": "Enter flow name",
      "description_label": "Description",
      "description_placeholder": "Enter flow description"
    },
    "flow_type_label": "Flow type",
    "flow_type_sms": "SMS",
    "flow_type_whatsapp": "WhatsApp",
    "flow_type_help": "SMS flows can only send free text. WhatsApp flows can send free text or templates.",
    "flow_type_locked_template": "Cannot change flow type while any Send Message node uses a template. Remove or change those nodes first.",
    "filter_modal": {
      "title": "Set up a filter",
      "close": "Close",
      "label": "Label",
      "label_placeholder": "e.g. success path",
      "label_max": "Must be at most 120 characters long.",
      "condition": "Condition",
      "no_condition_hint": "No condition = this path is used when no other edge matches (fallback).",
      "all_rules_and": "All rules (AND)",
      "any_rule_or": "Any rule (OR)",
      "add_and_rule": "Add AND rule",
      "add_or_rule": "Add OR rule",
      "add_rule": "Add rule",
      "value_placeholder": "Value",
      "variables": "Variables",
      "flow_variables": "Flow Variables",
      "fallback_description": "Set the route as a fallback. A fallback route is a backup route that is used if the source data didn't go through any other route. One node can have only one fallback route.",
      "fallback_confirm_title": "Replace fallback route",
      "fallback_confirm_body": "Another edge from this node is already set as the fallback route. Only one fallback route is allowed per node. Do you want to replace it?",
      "yes": "Yes",
      "no": "No",
      "order": "Order",
      "order_of": "{{current}} of {{total}}",
      "move_up": "Move up",
      "move_down": "Move down",
      "delete_edge": "Delete edge",
      "operator_equals": "Text: Equal to",
      "operator_not_equals": "Text: Not equal to",
      "operator_contains": "Text: Contains",
      "operator_not_contains": "Text: Does not contain",
      "operator_starts_with": "Text: Starts with",
      "operator_ends_with": "Text: Ends with",
      "operator_regex": "Text: Matches regex",
      "operator_greater_than": "Numeric: Greater than",
      "operator_less_than": "Numeric: Less than",
      "operator_is_empty": "Existence: Is empty",
      "operator_is_not_empty": "Existence: Is not empty",
      "trigger_sources_label": "Active for trigger sources",
      "trigger_sources_hint": "This edge only fires if the session was triggered by one of the selected sources. Uncheck to restrict."
    },
    "assign_modal": {
      "title": "Assign Bot to Phone Number",
      "phone_label": "Phone Number",
      "phone_placeholder": "Select WABA phone",
      "trigger_all_messages": "Trigger on all messages",
      "trigger_new_conversations_only": "Trigger only in new conversations",
      "trigger_keywords_label": "Trigger Keywords (comma-separated)",
      "trigger_keywords_placeholder": "hello, start, menu",
      "current_assignments": "Current Assignments",
      "remove": "Remove",
      "assign_success": "Bot assigned to phone number",
      "assign_failure": "Failed to assign bot",
      "fill_required": "Please fill in all required fields"
    },
    "node_config": {
      "configure_node": "Configure Node",
      "close": "Close",
      "label": "Label",
      "label_placeholder": "Node label",
      "type_start": "Start",
      "type_send_message": "Send Message",
      "type_wait_for_reply": "Wait for Reply",
      "type_api_call": "API Call",
      "type_human_handoff": "Human Handoff",
      "type_ai": "AI",
      "type_transcribe": "Transcribe",
      "type_set_variable": "Set Variable",
      "set_variable_hint": "Assign one or more variables. Each value can mix static text, existing variables {{var}}, and built-in functions {{$uuid}}, {{$sessionId}}, {{$random:1:100}}, {{$randomFloat:0:1}}, {{$timestamp}}, {{$now}}.",
      "set_variable_target": "Variable Name",
      "set_variable_target_placeholder": "e.g. orderId",
      "set_variable_value": "Value",
      "set_variable_value_placeholder": "e.g. order-{{$uuid}}",
      "set_variable_add_assignment": "+ Add assignment",
      "set_variable_functions_group": "Functions",
      "delete_node": "Delete Node",
      "unknown_node_type": "Unknown node type",
      "captures": "Captures",
      "all_messages": "All messages",
      "no_content": "No content",
      "trigger_keywords": "Trigger Keywords (comma-separated)",
      "text": "Text",
      "free_text": "Text",
      "template": "Template",
      "message_type": "Message Type",
      "message_text": "Message Text",
      "message_text_hint": "Use {{variable}} to insert values, or {{variable|default}} for a fallback. e.g. Hello {{userName|there}}!",
      "message_separator": "Message separator",
      "message_separator_hint": "Optional, max 32 characters. When set, the text is split into multiple WhatsApp messages wherever this string appears on its own line (e.g. ---). Leave empty to send as a single message.",
      "media_url": "Media URL",
      "media_type": "Media Type",
      "image": "Image",
      "video": "Video",
      "audio": "Audio",
      "document": "Document",
      "template_name": "Template Name",
      "language": "Language",
      "select_template": "Select a template",
      "no_templates_available": "No templates available",
      "no_templates_hint": "Go to WhatsApp Business settings to create and publish templates.",
      "header_params": "Header Parameters",
      "body_params": "Body Parameters",
      "button_params": "Button",
      "template_preview": "Template Preview",
      "template_params_hint": "Use {{variable}} to insert session values. e.g. {{userReply.text}}",
      "offer_code": "Offer Code",
      "whatsapp_flow": "WhatsApp Flow",
      "flow_name": "Flow",
      "flow_cta": "Button text",
      "flow_cta_placeholder": "Continue",
      "flow_body": "Message body",
      "flow_header": "Header (optional)",
      "flow_footer": "Footer (optional)",
      "no_flows_available": "No WhatsApp Flows available",
      "select_flow": "Select a flow",
      "flow_screen": "Starting screen",
      "select_screen": "Select a screen",
      "no_screens_available": "No screens available",
      "select_flow_first": "Select a flow first",
      "refresh_templates": "Reload templates",
      "refresh_flows": "Reload flows",
      "interactive_type": "Interactive Type",
      "buttons_up_to_3": "Buttons (up to 3)",
      "list": "List",
      "body_text": "Body Text",
      "header_optional": "Header (optional)",
      "footer_optional": "Footer (optional)",
      "buttons": "Buttons",
      "add_button": "Add Button",
      "list_button_text": "List Button Text",
      "list_rows": "List Rows",
      "add_row": "Add Row",
      "store_reply_variable": "Store reply in variable",
      "expected_message_types": "Accepted message types",
      "expected_message_types_hint": "Only accept these message types. Leave empty to accept all types. If the user sends a different type, the invalid message is sent and the node keeps waiting.",
      "expected_types_placeholder": "All types accepted",
      "max_file_size_label": "Max file size (MB)",
      "max_file_size_hint": "Maximum file size in MB (1-16). Defaults to 16 MB.",
      "body_variable_hint": "Type {{ to insert a variable",
      "expected_type_text": "Text",
      "expected_type_interactive": "Interactive (WhatsApp Flow)",
      "expected_type_button": "Button",
      "expected_type_image": "Image",
      "expected_type_document": "Document",
      "expected_type_audio": "Audio",
      "expected_type_video": "Video",
      "timeout_seconds": "Timeout (seconds)",
      "on_timeout_go_to": "On timeout go to",
      "select_node": "Select node",
      "validation_regex": "Validation Regex",
      "invalid_input_message": "Invalid Input Message",
      "invalid_input_message_placeholder": "Please provide a valid response.",
      "authentication_type": "Authentication type *",
      "auth_none": "None",
      "auth_bearer": "Bearer Token",
      "auth_basic": "Basic Auth",
      "auth_api_key": "API Key",
      "auth_hint": "Select the authentication type for an API call or authenticated webhook.",
      "bearer_token_label": "Bearer Token",
      "username": "Username",
      "password": "Password",
      "header_name": "Header name",
      "value": "Value",
      "url_label": "URL *",
      "url_hint": "Enter the URL of an API endpoint (including the base URL), beginning with https://.",
      "method_label": "Method *",
      "method_hint": "Select the HTTP request method.",
      "headers": "Headers",
      "headers_hint": "Add custom headers for the request.",
      "name_placeholder": "Name",
      "value_placeholder": "Value",
      "add_header": "+ Add a header",
      "query_parameters": "Query parameters",
      "query_parameters_hint": "Add parameters for GET and DELETE methods.",
      "add_parameter": "+ Add a parameter",
      "body_content": "Body content",
      "body_content_hint": "Select the format for the body. Used mainly for POST, PUT, and PATCH.",
      "body_json": "JSON",
      "body_form_urlencoded": "application/x-www-form-urlencoded",
      "body_multipart": "multipart/form-data (supports file uploads)",
      "body_raw": "Raw",
      "add_field": "+ Add a field",
      "parse_response": "Parse response",
      "yes": "Yes",
      "no": "No",
      "parse_response_hint": "Structure the output so it can be used in variables. Run the flow once to map results.",
      "pagination_type": "Pagination type",
      "pagination_offset": "Offset",
      "pagination_cursor": "Cursor",
      "pagination_page_number": "Page number",
      "pagination_hint": "Use if the API returns results split across multiple pages.",
      "select_pagination_type": "Select pagination type",
      "response_variable": "Response variable",
      "response_variable_hint": "Variable name to store the response (e.g. for conditions or messages).",
      "retry": "Retry",
      "retry_count": "Retry count",
      "retry_delay": "Retry delay (ms)",
      "retry_hint": "Retries only on network errors, timeouts, or connection failures. HTTP responses (including 4xx/5xx) are not retried — they are stored in the response variable for condition evaluation.",
      "request_timeout": "Request Timeout",
      "request_timeout_seconds": "Timeout (seconds)",
      "request_timeout_hint": "Maximum time to wait for a response. Default is 10 seconds, maximum is 120 seconds.",
      "file_attachment": "File Attachment",
      "file_variable": "File variable",
      "file_field_name": "Form field name",
      "file_attachment_hint": "Variable containing the file (e.g. userReply). The file from S3 will be streamed as multipart. For JSON body, use {{userReply.filePath}} — it auto-resolves to a download URL.",
      "debounce_label": "Message debounce",
      "debounce_hint": "Wait for additional messages before processing. Useful when users split input across multiple messages.",
      "debounce_unit_ms": "ms",
      "debounce_unit_sec": "sec",
      "debounce_unit_min": "min",
      "handoff_reason": "Handoff Reason",
      "handoff_reason_placeholder": "User requested agent",
      "handoff_message": "Handoff Message",
      "handoff_message_placeholder": "Transferring you to an agent...",
      "ai_model": "Model",
      "ai_model_default": "Default",
      "ai_system_prompt": "System Prompt",
      "ai_system_prompt_placeholder": "Set the AI's role and behavior...",
      "ai_prompt": "Prompt",
      "ai_prompt_placeholder": "Enter the prompt for the AI...",
      "ai_response_variable": "Response Variable",
      "ai_temperature": "Temperature",
      "ai_max_tokens": "Max Output Tokens",
      "ai_improve_prompt": "Improve prompt",
      "ai_context_instructions": "Context Instructions",
      "ai_context_instructions_placeholder": "Define the AI's role, personality, and knowledge...",
      "ai_context_instructions_hint": "Sets the AI's behavior and background knowledge for this node",
      "ai_include_history": "Include conversation history",
      "ai_max_history_turns": "Max history turns",
      "ai_max_history_turns_hint": "Number of recent message pairs to include (1-50)",
      "ai_history_enabled": "History enabled",
      "ai_improving_prompt": "Improving...",
      "ai_prompt_strength_weak": "Weak prompt",
      "ai_prompt_strength_medium": "Medium prompt",
      "ai_prompt_strength_strong": "Strong prompt",
      "ai_advanced": "Advanced Settings",
      "target_agent_id": "Target Agent ID",
      "auth_oauth2_mtls": "OAuth2 mTLS",
      "credential_label": "API Credential",
      "select_credential": "Select credential",
      "credential_hint": "Select an OAuth2 mTLS credential to use for authentication with the API endpoint.",
      "credential_hint_oauth2": "Select an OAuth2 credential to authenticate with the API endpoint",
      "credential_hint_mtls": "Select an OAuth2 mTLS credential to authenticate with the API endpoint",
      "auth_oauth2": "OAuth2",
      "transcribe_source_variable": "Source variable",
      "transcribe_source_variable_hint": "Variable from a preceding step that captured a voice message (e.g. \"userReply\"). The node reads <variable>.filePath.",
      "transcribe_response_variable": "Response variable",
      "transcribe_response_variable_hint": "Stores the transcribed text at <variable>.text and provider name at <variable>.provider. Set to true at <variable>.skipped when the audio exceeds the size limit.",
      "transcribe_from": "from",
      "transcribe_to": "to",
      "add_credential": "+ Add Credential"
    },
    "credentials": {
      "title": "API Credentials",
      "manage": "Manage Credentials",
      "create": "Create",
      "create_title": "Create Credential",
      "edit": "Edit",
      "edit_title": "Edit Credential",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "delete_confirm": "Are you sure you want to delete this credential?",
      "name": "Name",
      "description": "Description",
      "token_endpoint": "Token Endpoint",
      "client_id": "Client ID",
      "client_secret": "Client Secret",
      "grant_type": "Grant Type",
      "scope": "Scope",
      "client_cert": "Client Certificate",
      "client_key": "Client Key",
      "actions": "Actions",
      "create_success": "Credential created successfully",
      "create_failure": "Failed to create credential",
      "save_success": "Credential updated successfully",
      "save_failure": "Failed to update credential",
      "delete_success": "Credential deleted successfully",
      "delete_failure": "Failed to delete credential",
      "delete_confirm_title": "Delete Credential",
      "type": "Type",
      "verify": "Verify",
      "verify_success": "Credential verified successfully",
      "verify_failure": "Credential verification failed"
    },
    "trigger": {
      "settings_title": "Trigger Settings",
      "modes_label": "Trigger Modes",
      "modes_hint": "Select how this flow can be triggered. At least one mode must be checked.",
      "mode_message": "Message",
      "mode_ui": "UI",
      "mode_api": "API",
      "collision_policy_label": "Collision Policy",
      "collision_reject": "Reject",
      "collision_reject_hint": "if the recipient already has an active session for this flow, reject the new trigger and leave the existing session running.",
      "collision_replace": "Replace",
      "collision_replace_hint": "if the recipient already has an active session for this flow, expire it and start a fresh session for the new trigger.",
      "required_variables": "Required Variables",
      "curl_snippet_label": "cURL Snippet (API trigger)",
      "trigger_action": "Trigger",
      "modal_title": "Trigger flow",
      "tab_single": "Single recipient",
      "tab_csv": "CSV upload",
      "phone_number": "Phone number",
      "phone_number_placeholder": "Select a phone number",
      "recipient_phone": "Recipient phone",
      "collision_override": "Collision override",
      "collision_use_default": "Use flow default",
      "variable_placeholder": "Enter value",
      "variables_label": "Flow Variables",
      "variables_hint": "Declare variables this flow accepts. Callers (UI, CSV, API) supply values for them when triggering. Variables without a default are required.",
      "variable_default_title": "Variable {{idx}}",
      "variable_name_label": "Name",
      "variable_default_label": "Default value",
      "variable_description_label": "Description",
      "variable_name_placeholder": "name",
      "variable_default_placeholder": "(optional)",
      "variable_description_placeholder": "(optional)",
      "variable_add": "+ Add variable",
      "variable_remove": "Remove",
      "variable_required": "Required",
      "variable_optional": "Optional",
      "variable_duplicate": "Duplicate variable name.",
      "variable_node_conflict": "Name conflicts with a variable declared by a node in this flow.",
      "send": "Send",
      "accepted": "Accepted",
      "rejected": "Rejected",
      "trigger_sent": "Trigger sent.",
      "view_batch": "View batch",
      "errors": {
        "flow_not_found": "Flow not found.",
        "flow_not_published": "This flow isn't published. Publish a version before triggering.",
        "mode_not_allowed": "This flow doesn't allow this trigger source. Open the flow's trigger settings to enable it.",
        "no_send_message_node": "This flow has no send-message node, so there's nothing to send when triggered.",
        "first_send_must_be_template": "Outbound flows must start with a WhatsApp template. Set the first send-message node to use an approved template before triggering.",
        "sessionBusy": "Recipient already has an active session for this flow.",
        "recipientInAttendance": "Recipient is currently in attendance with an agent.",
        "duplicate_in_batch": "Duplicate recipient in this batch — only the first row was processed.",
        "invalidPhone": "Invalid phone number.",
        "missingVariables": "One or more required variables are missing."
      },
      "list_title": "Trigger Batches",
      "list_no_batches": "No trigger batches found.",
      "csv_modal_text": "Create a CSV file: Ensure your CSV file includes the following columns:",
      "csv_template_button": "Download CSV template",
      "required": "required",
      "csv_dragger": "Click or drag a .csv file here to upload",
      "csv_format_hint": "First column must be \"to\". Other columns map to flow variables.",
      "csv_missing_to": "CSV must have a \"to\" column as the first column.",
      "csv_missing_vars": "CSV is missing required variable columns",
      "csv_row_count": "{{count}} rows",
      "csv_large_file": "{{count}} rows — this is a large batch and may take a while.",
      "batch_title": "Trigger Batch",
      "batch_id": "Batch ID",
      "batch_created_at": "Created at",
      "batch_created_by": "Created by",
      "batch_total": "Total",
      "batch_accepted": "Accepted",
      "batch_rejected": "Rejected",
      "batch_completed": "Completed",
      "batch_failed": "Failed",
      "batch_col_to": "To",
      "batch_col_accepted": "Accepted",
      "batch_col_session": "Session",
      "batch_col_session_status": "Session Status",
      "batch_col_variables": "Variables",
      "batch_col_rejection_reason": "Rejection Reason",
      "batch_col_error": "Error",
      "batch_col_updated_at": "Updated",
      "batch_filter_all": "All",
      "batch_filter_all_accepted": "All accepted",
      "batch_filter_all_statuses": "All statuses",
      "batch_filter_rejected": "Rejected",
      "batch_search_phone": "Search phone...",
      "batch_yes": "Yes",
      "batch_no": "No",
      "batch_no_items": "No items found.",
      "batch_load_more": "Load more",
      "batch_loading": "Loading..."
    }
  },
  "org_explorer": {
    "title": "Organization Explorer",
    "placeholder": "Select or search a feature flag",
    "flag_label": "Flag:",
    "results_count": "{{count}} orgs found",
    "showing_count": "Showing {{shown}} of {{total}} orgs",
    "empty_state": "Select a feature flag to see which orgs have it enabled.",
    "no_results": "No orgs found for this flag.",
    "no_flag_matches": "No flags match your search",
    "copy_all": "Copy all IDs",
    "export_csv": "Export CSV",
    "clear": "Clear",
    "run_query": "Run Query",
    "filters_label": "Filters",
    "helper_text": "Find organizations that match the given conditions.",
    "preview_label": "Preview:",
    "preview_placeholder": "Add conditions to see a preview of your query.",
    "clear_all": "Clear all",
    "searching": "Searching…",
    "conditions_label": "Conditions:",
    "conditions_count": "{{count}} conditions",
    "connector_and": "AND",
    "connector_or": "OR",
    "add_condition": "Add condition",
    "remove_condition": "Remove",
    "collapse_filters": "Collapse filters",
    "expand_filters": "Expand filters",
    "condition_flag_placeholder": "Select a flag",
    "condition_value_placeholder": "Enter value",
    "operator_is": "is",
    "operator_is_not": "is not",
    "operator_eq": "Equal to",
    "operator_ne": "Not equal to",
    "operator_gt": "Greater than",
    "operator_gte": "Greater than or equal to",
    "operator_lt": "Less than",
    "operator_lte": "Less than or equal to",
    "operator_contains": "Contains",
    "operator_not_contains": "Does not contain",
    "operator_starts_with": "Starts with",
    "operator_between": "Between",
    "operator_includes_all": "Includes all of",
    "operator_includes_any": "Includes any of",
    "operator_excludes_all": "Excludes all",
    "operator_greater_than": "Greater than",
    "operator_less_than": "Less than",
    "operator_is_exactly": "Is exactly",
    "operator_before": "Before",
    "operator_after": "After",
    "operator_exactly": "Exactly",
    "value_true": "True",
    "value_false": "False",
    "value_enabled": "Enabled",
    "value_disabled": "Disabled",
    "validation_value_required": "Value is required",
    "type_label": "Type",
    "type_boolean": "Boolean",
    "type_number": "Number",
    "type_string": "Text",
    "type_select": "Select",
    "type_multi": "Multi-select",
    "type_date": "Date",
    "copy_org_id": "Copy org ID",
    "toast_copied": "Copied",
    "table": {
      "org_name": "Org Name",
      "org_id": "Org ID",
      "description": "Description",
      "actions": "Actions",
      "open_org": "Open org",
      "integrations": "Integrations"
    },
    "errors": {
      "failed_load": "Failed to load organizations. Please try again."
    },
    "source_config": "Feature Flag",
    "source_computed": "User Metric",
    "source_integration": "Integration",
    "condition_computed_placeholder": "Select a metric",
    "condition_integration_placeholder": "Select an integration",
    "category_placeholder": "Select a filter category...",
    "category_group_metrics": "Metrics",
    "category_group_configuration": "Configuration",
    "category_integrations": "Integrations",
    "category_feature_flags": "Feature Flags",
    "category_metrics": "Metrics",
    "no_category_matches": "No categories match your search",
    "select_integrations_placeholder": "Select integrations...",
    "select_flag_placeholder": "Select a flag...",
    "select_flag_first": "Select a flag first",
    "select_metric_placeholder": "Select a metric...",
    "select_metric_first": "Select a metric first",
    "enter_number_placeholder": "Enter number",
    "min_placeholder": "Min",
    "max_placeholder": "Max",
    "and": "and",
    "has": "Has",
    "does_not_have": "Does not have",
    "has_integration": "Has integration",
    "does_not_have_integration": "Does not have integration",
    "computed_fields": {
      "total_users": "Total Users",
      "total_users_help": "Count of all users in organization",
      "active_users": "Active Users",
      "active_users_help": "Count of users with active status",
      "sidecar_users": "Sidecar Users",
      "sidecar_users_help": "Count of users with sidecar enabled",
      "desktop_users": "Desktop Users",
      "desktop_users_help": "Count of users with desktop app",
      "last_activity": "Last Activity",
      "last_activity_help": "Most recent user login in organization"
    }
  },
  "common": {
    "hide": "Hide",
    "show": "Show",
    "copy": "Copy",
    "copied_to_clipboard": "Copied to clipboard"
  },
  "chat_now_modal": {
    "search_no_resoults_found": "No results found. Please try another search.",
    "start_chat": "Start Chat"
  },
  "settings": "Settings",
  "back": "Back",
  "next": "Next",
  "save_changes": "Save Changes",
  "support": "Support",
  "tuvis_platform": "Tuvis Platform",
  "error_try_again": "Please try again later",
  "minimum_letters": "Minimum {{minimumLettersToSearch}} letters",
  "login": {
    "login_failed": "Login failed",
    "no_sufficient_permissions": "No sufficient permissions"
  },
  "coming_soon": "Coming Soon",
  "status": "Status",
  "home": {
    "title": "Home",
    "banner": {
      "title": "Update!",
      "learn_more": "Learn More"
    },
    "welcome": {
      "title": "Welcome to Tuvis Platform",
      "description": "Your secure, compliant, and productive journey starts here. Manage communications, users, channels, and systems all in one place. Experience seamless integration across your workflow while maintaining the highest standards of data protection and team efficiency.",
      "greeting": "Welcome Back, <bold>{{name}}</bold>!"
    },
    "quick_actions": {
      "title": "Quick Actions",
      "edit": "Edit",
      "done": "Done",
      "drag_to_reorder": "Drag to reorder",
      "click_to_hide": "Click to remove",
      "add_action": "Add Quick Action",
      "add_action_desc": "Pin any page for quick access",
      "add_action_modal_title": "Add Quick Action",
      "search_pages": "Search pages...",
      "no_pages_found": "No pages found"
    }
  },
  "org_overview": {
    "title": "Org Overview"
  },
  "analytics": {
    "title": "Analytics"
  },
  "analytics_dashboard": {
    "title": "Dashboard"
  },
  "cyber_insights": {
    "title": "Security & Incidents",
    "total_incidents": "Total incidents",
    "count": "Count",
    "violated_dlp": "Violated DLP policies",
    "min": "Minutes",
    "time_to_resolve": "Average time to resolve an incident in minutes",
    "time_to_resolve_chart_label": "Time to resolve",
    "daily_incidents": "Incidents daily",
    "daily_incidents_chart_label": "Incidents",
    "incidents_per_user": "Incidents per user",
    "incidents_per_severity": "Incidents per severity",
    "export_incidents": "Incidents",
    "export_average_time_to_resolve": "Average time to resolve",
    "day": "Day",
    "time_to_response": "Average minutes to response",
    "number_of_incidents": "Number of incidents",
    "created_by": "Created by"
  },
  "compliance_insights": {
    "title": "Compliance"
  },
  "surveillance_insights": {
    "title": "Surveillance & Incidents",
    "total_incidents": "Total incidents",
    "violated_policies": "Top Surveillance Policies violated",
    "daily_incidents": "Incidents daily",
    "incidents_per_user": "Incidents per user",
    "incidents_per_severity": "Incidents per severity",
    "export_incidents": "Incidents",
    "export_violated_policies": "Violated Surveillance Policies",
    "export_daily_incidents": "Daily Incidents",
    "export_incidents_per_user": "Incidents per user"
  },
  "call_recordings_insights": {
    "title": "Call Recordings insights",
    "export_call_recordings": "Call Recordings",
    "total_call_recordings": "Total call recordings",
    "outgoing": "Outgoing",
    "incoming": "Incoming",
    "count": "Count",
    "call_recordings_per_user": "Call Recordings per user",
    "number_of_call_recordings": "Number of call recordings"
  },
  "user_analytics": {
    "title": "User Analytics",
    "subtitle": "Detailed response time analytics for each user in your organization (Last 3 months)",
    "search_placeholder": "Search by name, Tuvis user ID, or CRM user ID...",
    "search_name_placeholder": "Search by user name...",
    "edit_columns": "Edit Columns",
    "no_data": "No user analytics data available",
    "edit_columns_modal": {
      "title": "Customize Table Columns",
      "description": "Choose which metrics to display in the user analytics table. You can show or hide columns based on your analysis needs."
    },
    "column_groups": {
      "basic": "Basic Information",
      "response_times": "Response Time Metrics",
      "time_distribution": "Time Distribution Analysis"
    },
    "columns": {
      "user_id": "User ID",
      "engagement_user_id": "CRM / analytics user ID",
      "user_name": "User Name",
      "isOnline": "Online Status",
      "online_source": "Online Source",
      "total_responses": "Total Responses",
      "total_duration": "Online Duration",
      "median_response_minutes": "Median Response Time",
      "average_response_minutes": "Average Response Time",
      "min_response_minutes": "Min Response Time",
      "max_response_minutes": "Max Response Time",
      "p90_response_minutes": "90th Percentile Response",
      "p95_response_minutes": "95th Percentile Response",
      "stddev_response_minutes": "Response Time Std Dev",
      "responses_within_5min": "Responses Within 5 Min",
      "responses_within_15min": "Responses Within 15 Min",
      "responses_within_1hour": "Responses Within 1 Hour",
      "responses_over_1hour": "Responses Over 1 Hour",
      "business_hours_responses": "Business Hours Responses",
      "after_hours_responses": "After Hours Responses",
      "weekend_responses": "Weekend Responses",
      "weekday_responses": "Weekday Responses",
      "pct_within_5min": "% Within 5 Min",
      "pct_within_15min": "% Within 15 Min",
      "pct_within_1hour": "% Within 1 Hour",
      "pct_over_1hour": "% Over 1 Hour",
      "pct_business_hours": "% Business Hours",
      "pct_after_hours": "% After Hours",
      "pct_weekend": "% Weekend",
      "pct_weekday": "% Weekday"
    },
    "date_filter": "FILTER DATE"
  },
  "custom_filters": {
    "title": "Custom Filters",
    "create_new": "New Filter",
    "create_first": "Create Your First Filter",
    "empty_state": "No custom filters yet. Create one to filter conversations by Salesforce report results.",
    "no_assignments": "Not assigned",
    "users": "users",
    "groups": "groups",
    "columns": {
      "name": "Name",
      "description": "Description",
      "reports": "Reports",
      "assigned": "Assigned To",
      "last_updated": "Last Updated",
      "actions": "Actions"
    },
    "actions": {
      "settings": "Settings",
      "delete": "Delete"
    },
    "deleteModal": {
      "title": "Delete Custom Filter",
      "description": "Are you sure you want to delete \"{{name}}\"?",
      "submit": "Delete"
    },
    "errors": {
      "failedDelete": "Failed to delete custom filter",
      "loadFailed": "Failed to load custom filters"
    },
    "modal": {
      "title": "Create Custom Filter",
      "edit_title": "Edit Custom Filter",
      "name_label": "Filter Name",
      "description_label": "Description",
      "users_label": "Users",
      "groups_label": "Groups",
      "reports_placeholder": "Select Salesforce reports...",
      "submit_create": "Create",
      "submit_save": "Save",
      "errors": {
        "name_required": "Filter name is required",
        "name_too_short": "Filter name must be at least 3 characters",
        "create_failed": "Failed to create custom filter. Please try again.",
        "update_failed": "Failed to update custom filter. Please try again."
      }
    }
  },
  "dashboards": {
    "title": "Custom View",
    "subtitle": "Create and manage custom views with CRM data for your team",
    "create_new": "New Custom View",
    "create_first": "Create Your First Custom View",
    "empty_state": "No custom views yet. Create your first custom view to get started!",
    "home_badge": "Home",
    "no_assignments": "Not assigned",
    "users": "users",
    "groups": "groups",
    "confirm_delete": "Are you sure you want to delete \"{{name}}\"? All widgets will be permanently removed.",
    "addWidget": "Add Widget",
    "addFirstWidgetButton": "+ Add Your First Widget",
    "editWidget": "Edit Widget",
    "widgetTitle": "Widget Title",
    "widgetTitlePlaceholder": "e.g., Total Sales, Open Cases",
    "widgetDescription": "Widget Description",
    "widgetDescriptionPlaceholder": "e.g., Displays total sales for this quarter",
    "report": "Report",
    "displayAs": "Display As",
    "yAxis": "Y-Axis",
    "xAxis": "X-Axis",
    "measure": "Measure",
    "selectGroupingField": "Select grouping field...",
    "selectMeasure": "Select measure...",
    "preview": "Preview",
    "selectReportToPreview": "Select a report to preview the widget",
    "selectDisplayTypeToPreview": "Select a display type to see preview",
    "recordCount": "Record Count",
    "add": "Add",
    "update": "Update",
    "widgets": {
      "loading": "Loading...",
      "noDataAvailable": "No data available",
      "noDataToDisplay": "No data to display",
      "viewReport": "View report",
      "noReportConfigured": "No Salesforce report configured",
      "failedLoadReportData": "Failed to load report data",
      "failedLoadWidgetData": "Failed to load widget data",
      "unsupportedWidgetType": "Unsupported widget type: {{type}}",
      "item": "Item",
      "noGroupedDataAvailable": "No grouped data available",
      "noNumericValuesFound": "No numeric values found in report",
      "tryDifferentReport": "This report may not have aggregate/summary values. Try a different report or widget type.",
      "reportMayNotHaveAggregates": "This report may not have aggregate/summary values.",
      "values": "Values",
      "noDetailDataAvailable": "No detail data available",
      "showingRowsOfTotal": "Showing {{shown}} of {{total}} rows"
    },
    "widgetTypes": {
      "kpiCard": "KPI Card",
      "barChart": "Bar Chart",
      "pieChart": "Pie Chart",
      "lineChart": "Line Chart"
    },
    "validation": {
      "selectReport": "Please select a Salesforce report",
      "selectWidgetType": "Please select a widget type",
      "widgetTitleRequired": "Widget title is required"
    },
    "errors": {
      "failedCreateWidget": "Failed to create widget",
      "failedUpdateWidget": "Failed to update widget",
      "failedReorderWidgets": "Failed to reorder widgets",
      "failedDeleteWidget": "Failed to delete widget"
    },
    "deleteWidget": "Delete Widget",
    "confirmDeleteWidget": "Are you sure you want to delete \"{{title}}\"?",
    "deleteWidgetModal": {
      "title": "Delete Widget",
      "description": "Are you sure you want to delete \"{{title}}\"? This action cannot be undone.",
      "submit": "Delete"
    },
    "columns": {
      "name": "Name",
      "description": "Description",
      "widgets": "Widgets",
      "assigned_users": "Assigned To",
      "last_updated": "Last Updated",
      "actions": "Actions"
    },
    "actions": {
      "edit": "Edit",
      "settings": "Settings",
      "builder": "Edit Widgets",
      "preview": "Preview",
      "delete": "Delete"
    },
    "deleteDashboardModal": {
      "title": "Delete Custom View",
      "description": "Are you sure you want to delete \"{{name}}\"? All widgets will be permanently removed.",
      "submit": "Delete"
    },
    "modal": {
      "title": "Create New Custom View",
      "edit_title": "Edit Custom View Settings",
      "name_label": "Custom View Name",
      "name_placeholder": "e.g., Sales Overview, Manager Overview",
      "description_label": "Description",
      "description_placeholder": "Brief description of what this custom view shows",
      "assign_to": "Assign Custom View To",
      "users_label": "Users",
      "users_placeholder": "Select users who can view this custom view",
      "groups_label": "Groups",
      "groups_placeholder": "Select groups who can view this custom view",
      "is_home_default_label": "Set as Home Custom View",
      "is_home_default_help": "When enabled, this custom view will replace the WhatsApp home screen for assigned users",
      "create_button": "Create Custom View",
      "errors": {
        "name_required": "Custom view name is required",
        "name_too_short": "Custom view name must be at least 3 characters",
        "create_failed": "Failed to create custom view. Please try again.",
        "update_failed": "Failed to update custom view. Please try again."
      }
    }
  },
  "users_conversations_status": {
    "title": "Users Conversations Status",
    "subtitle": "Real-time WhatsApp conversation status for each user - unread messages, awaiting replies, and messages needing replies.",
    "empty_state": "No data available yet. Data will appear once users with the tracking feature enabled use the desktop app.",
    "columns": {
      "user_name": "User Name",
      "unread": "Unread",
      "awaiting_reply": "Awaiting Reply",
      "need_reply": "Need Reply",
      "last_updated": "Last Updated"
    }
  },
  "user_management": {
    "cols": {
      "avatar": "Avatar",
      "online_tooltip": "User is online",
      "offline_tooltip": "User is offline",
      "name": "Name",
      "orgId": "Organization ID",
      "status": "Status",
      "paidLicences": "Paid Licenses",
      "auto_sync_person": "Auto Sync (Person)",
      "auto_sync_group": "Auto Sync (Group)",
      "sync_back_days": "Sync Back Days",
      "active_tuvis": "Active in Tuvis",
      "groups": "Groups",
      "last_login": "Last Login",
      "last_login_platform": "Last Login (Platform)",
      "last_login_desktop": "Last Login (Desktop)",
      "last_login_extension": "Last Login (Extension)",
      "last_login_mobile": "Last Login (Mobile)",
      "last_login_tooltip": "This shows the last time the user signed in successfully or was refreshed during auto refresh - not when they were last active/online.",
      "desktop_version": "Desktop Version",
      "extension_version": "Extension Version",
      "mobile_version": "Mobile Version"
    },
    "status": {
      "active": "Active",
      "disabled": "Disabled"
    },
    "sync_back_days_inherit": "Inherit from organization ({{days}} days)",
    "sync_back_days_tooltip_user": "Configure how many days of historical messages will be synchronized. Leave empty to inherit from the organization or group level.",
    "sync_back_days_tooltip_group": "Configure how many days of historical messages will be synchronized. Leave empty to inherit from the organization level.",
    "sync_back_days_helper_user": "Leave empty to inherit from organization or group. This setting controls how far back messages are synced when auto-sync is enabled.",
    "sync_back_days_helper_group": "Leave empty to inherit from organization. This setting controls how far back messages are synced when auto-sync is enabled.",
    "reset_to_default": "Reset to default",
    "invite_user_modal": {
      "new_org": "New Organization",
      "org_name": "Organization Name",
      "server_location": "Server Location",
      "org_language": "Organization Language",
      "org_type": "Organization Type",
      "available_crm": "Available CRM",
      "comment": "Comment",
      "comment_placeholder": "Optional comment about this organization..."
    }
  },
  "engagement": {
    "select": "Select",
    "select_columns": "Select columns",
    "export_pdf": "Export PDF",
    "analytics_counters": "Analytics counters",
    "email": "Email",
    "name": "Name",
    "date": "Date",
    "sent_messages": "Sent messages",
    "received_messages": "Received messages",
    "export": "Export",
    "title": "Conversations",
    "total_messages": "Total messages",
    "total_messages_tooltip": "Total amount of messages processed by Tuvis",
    "response_time": "Response Time (Median)",
    "minutes": "Minutes",
    "messages_over_time": "Messages exchanged over time",
    "messages_over_time_per_user": "Messages exchanged over time per user",
    "messages_over_time_chart_label": "Messages",
    "messages_over_time_tooltip": "Messages exchanged between users over time",
    "direction": "Direction",
    "top_engaged": "Top engaged Leads / Contacts / Person accounts",
    "files_exchanged": "Files exchanged",
    "files_exchanged_tooltip": "Files exchanged between users",
    "engaged_by_type": "Engaged by type",
    "unknown_engaged": "Unknown people",
    "leads": "Leads",
    "contacts": "Contacts",
    "person_accounts": "Person accounts",
    "accounts": "Business accounts",
    "engaged_people": "Engaged people",
    "sent": "Sent",
    "received": "Received",
    "count": "Count",
    "file_types": {
      "image_one": "One Image",
      "image_other": "{{amount}} Images",
      "audio_one": "One Audio File",
      "audio_other": "{{amount}} Audio Files",
      "video_one": "One Video",
      "video_other": "{{amount}} Videos",
      "pdf_one": "One PDF FIle",
      "pdf_other": "{{amount}} PDF Files",
      "spreadsheet_one": "One Excel Sheet",
      "spreadsheet_other": "{{amount}} Excel Sheets",
      "document_one": "One Document",
      "document_other": "{{amount}} Documents",
      "presentation_one": "One Presentation",
      "presentation_other": "{{amount}} Presentations",
      "other_one": "One Other File",
      "other_other": "{{amount}} Other Files"
    }
  },
  "revenue": {
    "title": "Revenue analyzer",
    "top_engaging_users": "Top engaging users",
    "top_engaging_groups": "Top Engaging User Groups",
    "record_created": "Record created",
    "activities": "Activities",
    "leads": "Leads",
    "contacts": "Contacts",
    "tasks": "Tasks",
    "cases": "Cases",
    "emails": "Emails",
    "events": "Events",
    "person_accounts": "Person accounts",
    "accounts": "Business accounts",
    "unknown_engagement": "Unknown people",
    "total_engaging_people": "Engaged people",
    "break_down": "Breakdown",
    "messages": "Messages",
    "others": "Others",
    "record_created_tooltip": "New records created through Tuvis",
    "top_engaging_users_tooltip": "Users engaging with people over instance messaging",
    "top_engaging_groups_tooltip": "Showing the top engaging user groups",
    "opportunities_analyzer": {
      "title": "Opportunities analyzer",
      "account": "Account",
      "opportunity": "Opportunity",
      "stage": "Stage",
      "amount": "Amount",
      "users": "Users",
      "persons": "People",
      "messages": "Messages",
      "files": "Files"
    }
  },
  "adoption": {
    "title": "Tuvis adoption",
    "most_active_users": "Most active users",
    "total_users": "Total users",
    "adoption_over_time": "Adoption over time",
    "time_spent_on_engagement": "Time spent on engagement",
    "chat_now": "Chat now",
    "use_template": "Templates used",
    "currently_active": "Currently active",
    "active_users": "Active users",
    "actions_used": "Actions used",
    "most_active_users_tooltip": "Total number of times that Tuvis was proactively used by users",
    "adoption_over_time_tooltip": "The total number of Tuvis users in your account, and usage by date.",
    "time_spent_on_engagement_tooltip": "Time spent on WhatsApp vs. Salesforce. With Tuvis, your teams spend less time on doing repetitive and manual tasks and more time on engaging with customers over WhatsApp.",
    "chat_now_tooltip": "How many times users clicked the Chat Now button, in Salesforce or within the top search bar.",
    "use_template_tooltip": "How many times users used dynamic message templates",
    "time_spent_month": "Month",
    "time_spent_active_users": "Users",
    "time_spent_active_users_usage": "All Active Users",
    "time_spent_new_users_breakdown": "New Users",
    "time_spent_avrage": "Average",
    "time_spent_new_users": "Users",
    "time_spent_month_avg": "Month Avg.",
    "time_spent_tooltip_header": "Time Spent on WhatsApp",
    "time_spent_tooltip_content": "On average, out of these {{users}} users, approximately {{percent}}% of their time was spent using WhatsApp.",
    "actions": {
      "show_more": "Show more",
      "show_less": "Show less",
      "chat_now": "Chat now",
      "use-template": "Templates used",
      "create-activity-task-case": "Create Activity/Task/Case",
      "create-task": "Create Task",
      "create-lead-contact": "Create Lead/Contact",
      "create-activity": "Create Activity",
      "create-contact": "Create Contact",
      "create-lead": "Create Lead",
      "create-case": "Create Case",
      "create-custom-object": "Create Custom object",
      "view-in-crm": "View in CRM",
      "add_to_phone": "Add to Phone",
      "schedule-event": "Schedule Event",
      "send-email": "Send Email",
      "add-mobile-contact": "Add to Mobile Contacts",
      "call-contact": "Call contact",
      "start_meeting": "Start meeting",
      "find-on-linkedin": "Find on LinkedIn",
      "find-on-facebook": "Find on Facebook",
      "find-on-google": "Search on Google",
      "chat-on-messenger": "Chat on Messenger",
      "chat-on-messanger": "Chat on Messenger"
    }
  },
  "sidecars": {
    "disconnections_over_time": {
      "title": "Disconnected users over time",
      "date": "Date",
      "channel": "Channel",
      "unique_users": "Disconnected users",
      "events": "Disconnection events"
    },
    "email": "Email",
    "no_sidecars_desc": "Currently, you don't have any devices, but this is the ideal moment to create your first one.",
    "manual": "Enter manually",
    "upload_csv": "Upload CSV",
    "scan_qr": "<0>Don't</0> scan the QR Code with your Camera App, <1>scan it through {{channelName}}</1>",
    "scan_qr_instructions": {
      "whatsapp": {
        "android": "<0>To scan:</0> Open WhatsApp → Three-dot menu → Connected Devices → Connect Devices",
        "ios": "<0>To scan:</0> Open WhatsApp → Settings → Connected Devices → Connect Devices"
      },
      "telegram": "<0>To scan:</0> Open Telegram → Settings → Devices → Link Device → Scan QR Code",
      "line": "<0>To scan:</0> Open LINE → Settings → Devices → Scan QR Code",
      "signal": "<0>To scan:</0> Open Signal → Settings → Linked Devices → Scan QR Code"
    },
    "scan_qr_auth_code": "Enter this code in the {{channelName}} app to connect with Tuvis",
    "pairing_timeout": "The QRCode time limit was reached or a failure occurred during pairing.",
    "pairing_phone_mismatch": "The WhatsApp number you tried to connect is not registered to your device.",
    "pairing_error_generic": "Something went wrong during pairing. Please try again later.",
    "pairing_error_title": "Connection failed",
    "what_to_do_now": "What to do now?",
    "generate_new_qr_code": "Generate new QR Code",
    "pairing_timeout_step_1_title": "Check the WhatsApp version",
    "pairing_timeout_step_1_body": "Go to your phone's app store and check for available updates for WhatsApp. If there are any, update the app.",
    "pairing_timeout_step_2_title": "Clear disconnected devices",
    "pairing_timeout_step_2_body": "Before trying to connect again, delete all old connections from the \"Disconnected Devices\" menu in WhatsApp.",
    "pairing_timeout_step_3_title": "Test the WhatsApp backup",
    "pairing_timeout_step_3_body": "Check if you can perform a backup. If you cannot due to full storage, this could be the cause of the disconnection. Clear storage space before trying again.",
    "pairing_phone_mismatch_step_1_title": "Check the invitation:",
    "pairing_phone_mismatch_step_1_body": "The email you received to pair the device shows the expected WhatsApp number.",
    "pairing_phone_mismatch_step_2_title": "Correct your registration:",
    "pairing_phone_mismatch_step_2_body": "If the invitation number is incorrect, contact your Tuvis admin group to update it.",
    "invite_user": "User",
    "invite_phone": "Expected phone number",
    "should_notify": "Notify me when the device is paired or disconnected",
    "auto_reinvite": "Auto-reinvite on disconnection",
    "periodic_reinvite": "Auto-reinvite every day until paired",
    "sidecar_created": "A new device has been created",
    "invitation_sent": "Invitation sent",
    "share_invite_link": "Share invite link:",
    "next": "Next",
    "invite": "Invite",
    "pair": "Pair With Tuvis",
    "pair_description_1": "You have been invited to pair your {{channelName}} account with Tuvis",
    "pair_description_2": "Click the button below to start the pairing process.",
    "pair_button": "Pair with Tuvis",
    "pairing_success": "Pairing successful",
    "pairing_success_description_1": "Your {{channelName}} account is now connected to Tuvis.",
    "pairing_success_description_2": "You can now start using Tuvis to engage with your customers over {{channelName}}.",
    "pairing_boot_sentences_length": "7",
    "pairing_boot_sentences_0": "Tuvis is starting a QR code on the cloud for you…",
    "pairing_boot_sentences_1": "Setting up your QR code might take a few minutes…",
    "pairing_boot_sentences_2": "Please wait, QR code is being created…",
    "pairing_boot_sentences_3": "Once the QR code is ready, you will be able to pair your {{channelName}} account with Tuvis…",
    "pairing_boot_sentences_4": "Oh, this is taking longer than expected.",
    "pairing_boot_sentences_5": "We are getting there, just a few more seconds",
    "pairing_boot_sentences_6": "We apologize for the delay. We are working hard to get you up and running",
    "pairing_boot_sentences_connect_phone_number_0": "Tuvis is setting up a connection on the cloud for you…",
    "pairing_boot_sentences_connect_phone_number_1": "Setting up your connection might take a few minutes…",
    "pairing_boot_sentences_connect_phone_number_2": "Please wait, while your connection is being created…",
    "pairing_boot_sentences_connect_phone_number_3": "Once the connection is ready, you will be able to pair your {{channelName}} account with Tuvis…",
    "pairing_boot_sentences_connect_phone_number_4": "Oh, this is taking longer than expected.",
    "pairing_boot_sentences_connect_phone_number_5": "We are getting there, just a few more seconds",
    "pairing_boot_sentences_connect_phone_number_6": "We apologize for the delay. We are working hard to get you up and running",
    "link_is_invalid": "This link is no longer valid.",
    "contact_admin": "Contact your admin for assistance.",
    "create_sidecar": "Assign Device",
    "phone": "Phone",
    "user": "User",
    "manager": "Manager",
    "paired_devices": "Paired Devices",
    "runner": "Runner",
    "runnerChannel": "Channel",
    "counters": {
      "total": "Remote Sync Users",
      "connected": "Connected",
      "disconnected": "Disconnected",
      "new": "Pending Invitations",
      "licenses": "Max Devices"
    },
    "statuses": {
      "invited": "Invited",
      "booting": "Booting",
      "running": "Syncing now",
      "idle": "Pending sync",
      "pairing": "Pairing",
      "error": "Error",
      "not_paired": "Disconnected",
      "connected": "Connected",
      "new": "New",
      "disconnected_by_user": "Disconnected by user"
    },
    "status": "Status",
    "created_at": "Created At",
    "last_update": "Last Update",
    "start_sidecar": "Start device",
    "debug_sidecar": "Debug device",
    "clear_query_cache": "Clear Query Cache",
    "reload_sidecars": "Reload devices",
    "filter_sidecars": "Filter devices",
    "sidecar_messages": "Device Messages",
    "send_invitation": "Send Invitation",
    "sidecar_settings": "Device Settings",
    "delete_sidecar": "Delete device",
    "delete_sidecar_modal_message": "Are you sure you want to delete this device?",
    "pair_sidecar": "Pair device",
    "frequency": "Frequency",
    "log": "Log",
    "alt_login": {
      "invalid_code": "Invalid code",
      "verify_phone_code": "Verify",
      "send_login_code": "We've sent the code to the {{channelName}} app on your other device.",
      "link_phone": "Linking {{channelName}} phone",
      "link_with_qr": "Link with QR code",
      "link_with_phone": "Link with your {{channelName}} number",
      "get_code": "Get Code",
      "edit_phone": "Edit Phone",
      "enter_phone_number": "Enter phone number with country code",
      "enter_code": "Enter code on phone"
    },
    "pairing_steps": {
      "first": "1. Open WhatsApp on your phone.",
      "second": {
        "on_android": "2. On Android, tap Menu",
        "on_iphone": "or on iPhone, tap Settings"
      },
      "third": "3. Select \"Linked devices\" and then \"Link a device.\"",
      "fourth": "4. Click on \"Connect with phone number.\"",
      "fifth": "5. Some devices may require manually typing the link code."
    },
    "addSidecar": "Assign Remote Device",
    "maxSidecarsReached": "You have reached the maximum number of remote devices",
    "disconnected_at": "Disconnected At",
    "send_invites": "Send Invites",
    "sidecars": "Devices",
    "bulk_reinvite": {
      "success": "Successfully sent invites to {{count}} devices",
      "partial_failure": "Failed to send invites to {{count}} devices",
      "failed": "Failed to send bulk invites"
    },
    "bulk_delete": {
      "action_label": "Delete Selected",
      "confirm_title": "Delete Devices",
      "confirm_message": "Are you sure you want to delete {{count}} device(s)? This action cannot be undone.",
      "progress": "Deleting {{current}} of {{total}}...",
      "success": "Successfully deleted {{count}} device(s)",
      "partial_success": "Deleted {{successCount}} device(s). Failed to delete {{failCount}} device(s).",
      "failed": "Failed to delete devices"
    }
  },
  "filters": {
    "timeComparisonDays": "from previous {{count}} days",
    "timeComparisonMonths": "from previous {{count}} months",
    "filters": "Filters",
    "last_month": "Last 30 days",
    "last_60_days": "Last 60 days",
    "last_90_days": "Last 90 days",
    "last_year": "Last year",
    "users": "Users",
    "assignee": "Assignee",
    "created_by": "Created by",
    "no_assignee": "No Assignee",
    "groups": "Groups",
    "phones": "User Phones",
    "error_no_phones": "No phones found",
    "reset_filters": "Reset filters",
    "apply_filters": "Apply filters",
    "clear_all": "Clear all",
    "filter_analytics": "Filter Analytics",
    "search": "Search",
    "search_no_results_title": "We didn't find anything",
    "search_no_results_description": "Try different keywords or make sure everything is spelled correctly.",
    "error_no_users": "No users found",
    "error_no_users_description": "Please try again later",
    "show": "Show",
    "top": "Top",
    "filter_audit_logs": "Filter Audit Logs",
    "sent_or_received_by": "Sent or received by",
    "severity": "Severity",
    "policy": "Policy",
    "table": "Filter Table"
  },
  "edit_columns": {
    "edit_columns": "Edit Columns",
    "select_all": "Select all",
    "deselect_all": "Deselect all",
    "search_columns": "Search columns",
    "reset_to_default": "Reset to default",
    "no_columns_found": "No columns found",
    "selected": "Selected",
    "select": "Select"
  },
  "footer": {
    "rights_reserved": "© 2026 Tuvis All rights reserved.",
    "privacy_policy": "Privacy Policy",
    "terms_conditions": "Terms & Conditions"
  },
  "search_orgs": {
    "invite_to_platform": "Provision new organization",
    "search_orgs": "Search organizations",
    "change_organization_name": "Change organization name",
    "would_you_like_to_change_organization_name": "Would you like to change organization name?",
    "edit_organization_identity_section": "Organization identity",
    "organization_name": "Organization name",
    "change": "Change",
    "cancel": "Cancel",
    "organization_name_updated": "Organization name updated",
    "organization_description": "Description",
    "failed_to_update_organization_name": "Failed to update organization name",
    "organization_description_updated": "Organization description updated",
    "failed_to_update_organization_description": "Failed to update organization description"
  },
  "users_page": {
    "user_not_found": "User not found",
    "title": "Users",
    "add_phone": "Add a Phone",
    "toasts": {
      "invite_failed_user_exists": "Email address already exist, resend invitation instead"
    },
    "actions": {
      "name": "Users",
      "resend_invite": "Resend invite",
      "enable_desktop": "Enable WhatsApp (Tuvis desktop App)",
      "disable_desktop": "Disable WhatsApp (Tuvis desktop App)",
      "disable": "Disable user",
      "reactive": "Reactive user",
      "sidecar_settings": "Change device settings"
    }
  },
  "notifications_settings_page": {
    "title": "Notifications"
  },
  "super_admin_page": {
    "title": "Super Admin",
    "subHeader": "Manage Organization Settings",
    "saved_successfully": "Organization settings were successfully saved",
    "saved_failed": "Organization settings failed to save"
  },
  "whatsapp_business_api_agent_page": {
    "title": "Agent",
    "react": "React",
    "reply": "Reply"
  },
  "channels": {
    "title": "Remote Sync",
    "all_remote_devices": "All Remote Devices",
    "enable": "Enable",
    "disable": "Disable",
    "confirm_disable_modal_text": "Are you sure you want to disable the {{channel}} channel?",
    "confirm_enable_modal_text": "Are you sure you want to enable the {{channel}} channel?",
    "confirm_button": "Confirm",
    "desktop": "WhatsApp (Tuvis desktop App)",
    "tuvis_desktop_app": "Tuvis Desktop App",
    "whatsapp": "WhatsApp",
    "mobile_call_recording": "Mobile call recording",
    "imessage": "iMessage",
    "telegram": "Telegram",
    "unavailable": {
      "title": "Channel unavailable",
      "message": "{{channel}} isn’t included in your current plan. Contact our Sales team to enable it."
    },
    "analytics": {
      "device_connected_rate": "Device connected rate",
      "device_connected_rate_tooltip": "Percentage of Remote Sync devices invited in the selected date range that are currently connected.",
      "device_connected_rate_subtext": "{{connected}} / {{total}} devices",
      "average_time_to_pair": "Average time to pair",
      "average_time_to_pair_tooltip": "Average hours from the last invite before a user's first successful device pairing. Based on devices that paired within the selected date range.",
      "average_time_to_pair_value": "{{hours}} hrs",
      "average_time_to_pair_subtext": "{{count}} devices paired"
    }
  },
  "twilio_settings_page": {
    "title": "Tuvis Call Recording",
    "add_account": "Add account",
    "add_phone": "Purchase phone number",
    "reload": "Reload",
    "connect_button": "Connect",
    "need_to_connect": "To enhance your experience and unlock advanced features, you need to connect to Tuvis Call Recording",
    "empty_state_no_phones_text": "No phone numbers have been added yet.",
    "no_address_error_message": "For the selected country, you must have an address to complete this purchase",
    "close_account": "Close account",
    "create_account_loading": "Creating account...",
    "create_account_error": "Failed to create account",
    "close_account_loading": "Closing account...",
    "close_account_error": "Failed to close account",
    "close_account_modal": {
      "title": "Close account",
      "description": "Are you sure you want to close this account?",
      "may_result_1": "Closing the account will remove it from Tuvis Call Recording account.",
      "may_result_2": "- Tuvis call recording will release all phone numbers in the subaccount.",
      "may_result_3": "- Tuvis call recording account will not be able to make and receive phone calls or send and receive SMS messages",
      "may_result_4": "- Tuvis call recording account cannot be opened again",
      "may_result_5": "- Tuvis call recording will delete all data 30 days after closure"
    },
    "tabs": {
      "phones": "PHONES",
      "settings": "SETTINGS"
    },
    "connect_to_tuvis_call_recording_modal": {
      "title": "Connect to Tuvis Call Recording",
      "description": "Please contact your Tuvis account manager to connect to Tuvis call recording"
    },
    "cols": {
      "name": "Name",
      "account_sid": "ACCOUNT SID",
      "api_sid": "API SID",
      "api_secret": "API SECRET",
      "auth_token": "AUTH TOKEN",
      "sms": "SMS",
      "voice": "Voice",
      "capabilities": "Capabilities",
      "status": "Status",
      "phone": "Phone",
      "accountName": "Account Name",
      "accountSid": "Account SID",
      "type": "Type",
      "price": "Price"
    },
    "status": {
      "connected": "Connected",
      "pending_connection": "Pending Connection"
    },
    "actions_phone_table": {
      "assign_users": "Assign users",
      "rename_phone": "Rename phone",
      "connect_phone": "Connect phone",
      "assign_phone": "Assign phone",
      "release_phone": "Release phone"
    },
    "purchase_phone": {
      "country": "Country:",
      "account": "Account:",
      "purchase": "Purchase",
      "confirm_purchase": "Are You Sure?",
      "confirm_purchase_body": "Are you sure you want to purchase a new phone number?",
      "phone_purchased_successfully": "Phone purchased successfully",
      "phone_purchased_failed": "Phone purchase failed: {{error}}",
      "confirm_release": "Are You Sure?",
      "confirm_release_body": "Are you sure you want to release this phone number? The phone number will be released from your Twilio account and will no longer be available for use. This action cannot be undone without the assistance of Twilio support."
    }
  },
  "slack_settings_page": {
    "title": "Tuvis Slack Integration",
    "fleet": {
      "title": "Additional Slack apps",
      "description": "Install additional Tuvis worker apps to increase Slack messaging capacity. Each app adds its own rate-limit budget.",
      "install": "Install",
      "uninstall": "Uninstall",
      "installed": "Installed"
    },
    "need_to_connect": "Install the Tuvis Slack app to get started. Click the button below to install the app and connect your Slack workspace for seamless instant messaging.",
    "connect_button": "Install Slack App",
    "disconnect_button": "Uninstall App",
    "configure_shortcuts_button": "Configure Shortcuts",
    "connecting": "Installing...",
    "connection_failed": "Failed to install Slack app",
    "connected_success": "Slack app installed successfully",
    "popup_blocked": "Popup blocked by browser",
    "oauth_cancelled": "OAuth cancelled by user",
    "installed": {
      "title": "Tuvis Slack App is installed on {{workspaceName}} ({{workspaceId}})",
      "description": "You can now start instant messaging with your Slack workspace."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Please note:",
      "description": "You need to configure the template shortcut trigger."
    },
    "configure_shortcut_modal": {
      "title": "Configure WhatsApp Template Shortcut",
      "shortcut_url_label": "Slack Shortcut URL",
      "invalid_url": "Invalid URL format. Expected format: https://slack.com/shortcuts/{ID}/{KEY}",
      "save": "Save Configuration",
      "success": "Shortcut configured successfully",
      "error": "Failed to configure shortcut"
    },
    "uninstall_modal": {
      "title": "Uninstall Tuvis Slack App",
      "description": "Are you sure you want to uninstall the Tuvis Slack app?",
      "description_with_workspace": "Are you sure you want to uninstall the Tuvis Slack app from {{workspaceName}}?",
      "warning": "This action cannot be undone. All Slack integration settings will be removed.",
      "confirm": "Uninstall App",
      "cancel": "Cancel",
      "success": "Slack app uninstalled successfully",
      "error": "Failed to uninstall Slack app"
    },
    "workflow_api_key": {
      "title": "Workflow API Key",
      "description": "Use this key to configure the Tuvis Slack Workflow app. Keep it secure and do not share it publicly."
    }
  },
  "teams_settings_page": {
    "title": "Tuvis Teams Integration",
    "need_to_connect": "Install the Tuvis Teams app to get started. Click the button below to install the app and connect your Teams workspace for seamless instant messaging.",
    "connect_button": "Connect Teams",
    "disconnect_button": "Uninstall App",
    "configure_shortcuts_button": "Configure Shortcuts",
    "connecting": "Connecting...",
    "connection_failed": "Failed to connect Teams app",
    "connected_success": "Teams app connected successfully",
    "popup_blocked": "Popup blocked by browser",
    "oauth_cancelled": "OAuth cancelled by user",
    "certificate_auth_description": "Connect your Microsoft Teams tenant using certificate-based authentication for secure server-to-server communication.",
    "step1_certificate": "Step 1: Download Certificate",
    "step1_description": "Download a certificate that will be used to authenticate with Microsoft Azure. Upload it to your Azure App Registration.",
    "download_certificate": "Download Certificate",
    "download_certificate_failed": "Failed to download certificate",
    "step2_azure_config": "Step 2: Azure Configuration",
    "step2_description": "Enter your Azure App Registration details. You can find these in the Azure Portal under App Registrations.",
    "client_id": "Application (Client) ID",
    "client_id_placeholder": "Enter your Azure Application (Client) ID",
    "tenant_id": "Directory (Tenant) ID",
    "tenant_id_placeholder": "Enter your Azure Directory (Tenant) ID",
    "dummy_user_id": "Service Account ID",
    "dummy_user_id_placeholder": "Enter the Azure AD Object ID of the service account",
    "certificate_required": "Please generate a certificate first",
    "test_connection_failed": "Failed to test connection with Azure",
    "installed": {
      "title": "Tuvis Teams App is installed on {{workspaceName}} ({{workspaceId}})",
      "description": "You can now start instant messaging with your Teams workspace."
    },
    "shortcut_trigger_missing_banner": {
      "title": "Please note:",
      "description": "You need to configure the template shortcut trigger."
    },
    "configure_shortcut_modal": {
      "title": "Configure WhatsApp Template Shortcut",
      "guide_title": "How to Get Your Shortcut URL:",
      "step_1": "In the left side menu, click on \"More\" and then \"Tools\". Inside tools, pick \"Workflows\", click on the \"New\" button on the right and pick \"Build Workflow\"",
      "step_2": "You will be redirected to the new workflow page. Click on \"Choose an event\", pick \"From a link in Teams\" and finally click \"Continue\"",
      "step_3": "Click on \"Add steps\". On the dialog opened, use the \"Search steps\" input on the left top side and search for \"Send Template\" by Tuvis. Then, on the \"Channel Id\" input pick the first option: \"Channel where the workflow was used\" and click \"Save\"",
      "step_4": "Click on the \"Finish Up\" button on the top right of the page. You will be asked to set a name for the workflow - we recommend setting \"Whatsapp Templates\" as the name. After you did that, click on the \"Publish\" button",
      "step_5": "Great! All you need to do now is to copy the \"Starts from a link in Teams\" link displayed in the modal and paste it here down below",
      "shortcut_url_label": "Teams Shortcut URL",
      "invalid_url": "Invalid URL format. Expected format: https://teams.com/shortcuts/{ID}/{KEY}",
      "save": "Save Configuration",
      "success": "Shortcut configured successfully",
      "error": "Failed to configure shortcut"
    },
    "uninstall_modal": {
      "title": "Uninstall Tuvis Teams App",
      "description": "Are you sure you want to uninstall the Tuvis Teams app?",
      "description_with_workspace": "Are you sure you want to uninstall the Tuvis Teams app from {{workspaceName}}?",
      "warning": "This action cannot be undone. All Teams integration settings will be removed.",
      "confirm": "Uninstall App",
      "cancel": "Cancel",
      "success": "Teams app uninstalled successfully",
      "error": "Failed to uninstall Teams app"
    }
  },
  "archive_teams_settings_page": {
    "title": "Archive Teams Messages",
    "description": "Connect your Microsoft Teams tenant to archive all chat messages. Messages will be captured in real-time via Microsoft Graph subscriptions.",
    "connect_button": "Enable Archive",
    "disconnect_button": "Disable Archive",
    "connecting": "Connecting...",
    "connection_failed": "Failed to enable Teams archive",
    "connected_success": "Teams archive enabled successfully",
    "certificate_required": "Please generate a certificate first",
    "download_certificate_failed": "Failed to download certificate",
    "step1_certificate": "Step 1: Download Certificate",
    "step1_description": "Download a certificate for secure authentication with Microsoft Azure. Upload it to your Azure App Registration under Certificates & Secrets. Ensure the app has Chat.Read.All application permission with admin consent.",
    "download_certificate": "Download Certificate",
    "step2_azure_config": "Step 2: Azure Configuration",
    "step2_description": "Enter your Azure App Registration details. The application must have Chat.Read.All permission granted with admin consent.",
    "client_id": "Application (Client) ID",
    "client_id_placeholder": "Enter your Azure Application (Client) ID",
    "tenant_id": "Directory (Tenant) ID",
    "tenant_id_placeholder": "Enter your Azure Directory (Tenant) ID",
    "installed": {
      "title": "Teams Archive is Active",
      "description": "Your Teams chat messages are being archived in real-time.",
      "subscription_expires": "Subscription auto-renews (current expiry: {{date}})"
    },
    "uninstall_modal": {
      "title": "Disable Teams Archive",
      "description": "Are you sure you want to disable Teams message archiving? This will remove the webhook subscription and stop capturing messages.",
      "warning": "Archived messages will be preserved, but no new messages will be captured.",
      "confirm": "Disable Archive",
      "cancel": "Cancel",
      "success": "Teams archive disabled successfully",
      "error": "Failed to disable Teams archive"
    }
  },
  "archive_discord_settings_page": {
    "title": "Archive Discord Messages",
    "description": "Connect your Discord app to archive server and channel messages via Discord bot events.",
    "connect_button": "Enable Archive",
    "disconnect_button": "Disable Archive",
    "select_servers_button": "Select servers to archive",
    "add_server_button": "Add Server",
    "connecting": "Connecting...",
    "connection_failed": "Failed to enable Discord archive",
    "connected_success": "Discord archive enabled successfully",
    "step1_discord_config": "Step 1: Discord Bot Configuration",
    "step1_description": "Enter your Discord application id and bot token. Ensure the bot is installed in your server with message read permissions and MESSAGE CONTENT intent enabled.",
    "application_id": "Application ID",
    "application_id_placeholder": "Enter your Discord Application ID",
    "bot_token": "Bot Token",
    "bot_token_placeholder": "Enter your Discord Bot Token",
    "installed": {
      "title": "Discord Archive is Active",
      "description": "Your Discord messages are being archived in real-time."
    },
    "uninstall_modal": {
      "title": "Disable Discord Archive",
      "description": "Are you sure you want to disable Discord message archiving? This will stop capturing new Discord messages.",
      "warning": "Archived messages will be preserved, but no new messages will be captured.",
      "confirm": "Disable Archive",
      "cancel": "Cancel",
      "success": "Discord archive disabled successfully",
      "error": "Failed to disable Discord archive"
    }
  },
  "elite_token_page": {
    "title": "Elite Security Token",
    "disclaimer": "This token is sensitive security data. Once generated, you are solely responsible for storing and managing it securely. Tuvis does not retain a copy of this token.",
    "token_label": "Security Token",
    "token_subtitle": "One credential per organization. Rotate it any time.",
    "status_active": "Active",
    "status_not_set": "Not set",
    "user_agent_header_description": "Include the security token in the user-agent header sent by Tuvis client apps so your security stack can identify authorized traffic.",
    "no_token_placeholder": "No token generated yet",
    "generate_button": "Generate Token",
    "show": "Show token",
    "hide": "Hide token",
    "copy": "Copy token",
    "user_agent_header": "Add elite token to user agent",
    "generate_error": "Failed to generate token",
    "update_error": "Failed to update setting",
    "save_button": "Save Token",
    "save_success": "Token saved successfully",
    "save_error": "Failed to save token",
    "generate_confirm_title": "Warning: Critical Action",
    "generate_confirm_body": "Generating a new security token will immediately invalidate your current one. This will break the application's connection to your server until you update the new token in your security stack. Are you sure you want to proceed?",
    "generate_confirm_ok": "Confirm & Generate",
    "generate_confirm_cancel": "Cancel",
    "save_confirm_title": "Warning: Critical Action",
    "save_confirm_body": "Saving this token will immediately replace your current one. This will break the application's connection to your server until your security stack is updated with the new token. Are you sure you want to proceed?",
    "save_confirm_ok": "Confirm & Save",
    "save_confirm_cancel": "Cancel"
  },
  "api_docs_settings_page": {
    "title": "API Documentation"
  },
  "api_keys_settings_page": {
    "title": "Api Keys",
    "reload": "Reload",
    "revoke": "Revoke",
    "close": "Close",
    "never_access": "Never Access",
    "create_api_key_desc": "Make sure you copy your new API secret now. You won't be able to see this API secret again",
    "add_api_key": "Add Api Key",
    "api_key": "Api Key",
    "base_url": "Base Url",
    "api_key_name": "Api Key Name",
    "api_secret": "Api Secret",
    "scopes": "Scopes",
    "name": "Name",
    "cols": {
      "name": "NAME",
      "api_key": "API KEY",
      "last_accessed": "Last Accessed",
      "type": "TYPE",
      "identifier": "ID"
    },
    "oauth_clients_title": "OAuth Clients",
    "oauth_client_id": "Client ID",
    "oauth_client_secret": "Client Secret",
    "oauth_auth_method": "Auth Method",
    "oauth_clients_cert_registered": "Your TLS client certificate has been registered successfully.",
    "drop_client_cert": "Drop your .pem certificate here or click to upload",
    "create_credential": "Create Credential",
    "add_credential": "Add",
    "view_docs": "API Documentation",
    "credential_type": "Type",
    "type_api_key": "API Key",
    "type_oauth_client": "OAuth Client",
    "auth_method_client_secret": "Client Secret",
    "auth_method_tls": "Client Certificate (mTLS)",
    "edit_scopes": "Edit scopes",
    "all_scopes": "All",
    "revoke_confirm_title": "Revoke credential",
    "revoke_confirm_body": "This permanently revokes the credential and any application using it will stop working. This cannot be undone."
  },
  "add_oauth_client": "Add OAuth Client",
  "phone_blocklist_settings_page": {
    "title": "Private Phone Numbers",
    "search": "Search phone numbers",
    "add_phones_modal": {
      "trigger": "Add phone numbers",
      "title": "Add phone numbers to private list",
      "description": "Use the text area below to add phone numbers to the private phone numbers list. You can add multiple phone numbers by separating them with a new line.",
      "placeholder": "Enter phone numbers separated new line",
      "submit": "Add"
    },
    "cols": {
      "phone": "Phone Number"
    },
    "import_phones_modal": {
      "trigger": "Import",
      "title": "Import phone numbers",
      "description": "Choose a CSV file to import private phone numbers. Ensure your CSV file only has one column \"Phone\" with phone numbers.",
      "confirm": "{{fileName}} was successfully processed. We found {{count}} phone numbers. Would you like to add them to the private phone numbers list?",
      "submit": "Import",
      "loading_message": "Importing phone numbers...",
      "success_message": "{{count}} phone numbers imported successfully",
      "failed_message": "Failed to import phone numbers"
    },
    "delete_phone_modal": {
      "trigger": "Delete Phone",
      "title": "Delete phone from private list",
      "description": "Are you sure you want to delete this phone from the private phone numbers list?",
      "description_multiple": "Are you sure you want to delete {{count}} phones from the private phone numbers list?",
      "submit": "Delete",
      "loading_message": "Deleting phone from private phone numbers list...",
      "success_message": "Phone deleted successfully",
      "failed_message": "Failed to delete phone"
    }
  },
  "blocked_phones_settings_page": {
    "title": "Blocked Phone Numbers",
    "search": "Search phone numbers",
    "add_phones_modal": {
      "trigger": "Add phone numbers",
      "title": "Add phone numbers to blocked list",
      "description": "Use the text area below to add phone numbers to block. Add multiple numbers by separating them with a new line.",
      "placeholder": "Enter phone numbers separated new line",
      "submit": "Add"
    },
    "cols": { "phone": "Phone Number" },
    "import_phones_modal": {
      "trigger": "Import",
      "title": "Import phone numbers",
      "description": "Choose a CSV file to import blocked phone numbers. Ensure your CSV file only has one column \"Phone\" with phone numbers.",
      "confirm": "{{fileName}} was successfully processed. We found {{count}} phone numbers. Would you like to add them to the blocked list?",
      "submit": "Import",
      "loading_message": "Importing phone numbers...",
      "success_message": "{{count}} phone numbers imported successfully",
      "failed_message": "Failed to import phone numbers"
    },
    "delete_phone_modal": {
      "trigger": "Delete Phone",
      "title": "Delete phone from blocked list",
      "description": "Are you sure you want to delete this phone from the blocked list?",
      "description_multiple": "Are you sure you want to delete {{count}} phones from the blocked list?",
      "submit": "Delete",
      "loading_message": "Deleting phone from blocked list...",
      "success_message": "Phone deleted successfully",
      "failed_message": "Failed to delete phone"
    }
  },
  "fraud_detection_page": {
    "title": "Fraud Detection",
    "description": "Manage malicious file hash and URL blocklists to protect against known threats",
    "search": "Search",
    "tabs": {
      "hashes": "File Hashes",
      "urls": "Blocked URLs",
      "incidents": "Incidents"
    },
    "add_hash_modal": {
      "trigger": "Add Hash",
      "title": "Add malicious file hash",
      "description": "Enter a SHA256/MD5 hash to add to the blocklist. Messages containing files with matching hashes will be blocked.",
      "hash_label": "SHA256/MD5 Hash",
      "hash_placeholder": "Enter SHA256/MD5 hash",
      "description_label": "Description (optional)",
      "description_placeholder": "Enter a description for this hash",
      "submit": "Add",
      "invalid_hash": "Invalid SHA256/MD5 hash format.",
      "loading_message": "Adding hash...",
      "success_message": "Hash added successfully",
      "failed_message": "Failed to add hash"
    },
    "add_url_modal": {
      "trigger": "Add URL",
      "title": "Add malicious URL",
      "description": "Enter a URL to add to the blocklist. Messages containing this URL will be blocked.",
      "url_label": "URL",
      "url_placeholder": "Enter URL (e.g., https://malicious-site.com)",
      "description_label": "Description (optional)",
      "description_placeholder": "Enter a description for this URL",
      "submit": "Add",
      "invalid_url": "Invalid URL format.",
      "loading_message": "Adding URL...",
      "success_message": "URL added successfully",
      "failed_message": "Failed to add URL"
    },
    "cols": {
      "hash": "Hash",
      "hash_type": "Type",
      "url": "URL",
      "description": "Description",
      "created_at": "Created At"
    },
    "import_hashes_modal": {
      "trigger": "Import CSV",
      "title": "Import malicious file hashes",
      "description": "Choose a CSV file to import malicious file hashes. The CSV should have columns: 'hash' (required) and 'description' (optional).",
      "download_template": "Download CSV template",
      "confirm": "{{fileName}} was successfully processed. We found {{count}} hashes. Would you like to add them to the blocklist?",
      "submit": "Import",
      "loading_message": "Importing hashes...",
      "success_message": "{{count}} hashes imported successfully",
      "failed_message": "Failed to import hashes",
      "csv_errors": {
        "empty_file": "The CSV file is empty",
        "missing_hash_column": "Missing required 'hash' column",
        "invalid_headers": "Invalid headers found: {{invalidHeaders}}"
      }
    },
    "import_urls_modal": {
      "trigger": "Import CSV",
      "title": "Import malicious URLs",
      "description": "Choose a CSV file to import malicious URLs. The CSV should have columns: 'url' (required) and 'description' (optional).",
      "download_template": "Download CSV template",
      "confirm": "{{fileName}} was successfully processed. We found {{count}} URLs. Would you like to add them to the blocklist?",
      "submit": "Import",
      "loading_message": "Importing URLs...",
      "success_message": "{{count}} URLs imported successfully",
      "failed_message": "Failed to import URLs",
      "csv_errors": {
        "empty_file": "The CSV file is empty",
        "missing_url_column": "Missing required 'url' column",
        "invalid_headers": "Invalid headers found: {{invalidHeaders}}"
      }
    },
    "delete_hash_modal": {
      "trigger": "Delete Hash",
      "title": "Delete hash from blocklist",
      "description": "Are you sure you want to delete this hash from the blocklist?",
      "description_multiple": "Are you sure you want to delete {{count}} hashes from the blocklist?",
      "submit": "Delete",
      "loading_message": "Deleting hash from blocklist...",
      "success_message": "Hash deleted successfully",
      "failed_message": "Failed to delete hash"
    },
    "delete_url_modal": {
      "trigger": "Delete URL",
      "title": "Delete URL from blocklist",
      "description": "Are you sure you want to delete this URL from the blocklist?",
      "description_multiple": "Are you sure you want to delete {{count}} URLs from the blocklist?",
      "submit": "Delete",
      "loading_message": "Deleting URL from blocklist...",
      "success_message": "URL deleted successfully",
      "failed_message": "Failed to delete URL"
    },
    "incidents": {
      "columns": {
        "created_at": "Created At",
        "threat_type": "Threat Type",
        "matches": "Matches",
        "sender": "Sender",
        "recipient": "Recipient",
        "channel": "Channel",
        "is_group": "Group",
        "status": "Status"
      },
      "threat_types": {
        "all": "All types",
        "url": "URL",
        "file_hash": "File Hash"
      },
      "statuses": {
        "new": "New",
        "resolved": "Resolved",
        "dismissed": "Dismissed"
      },
      "filters": {
        "title": "Filter Incidents",
        "all_statuses": "All statuses",
        "all_types": "All types"
      },
      "detail": {
        "header": "Incident Details",
        "back_to_list": "Back to incidents",
        "threat_type": "Threat Type",
        "content": "Content",
        "matches": "Matches",
        "hash_type": "Hash Type",
        "sender": "Sender",
        "recipient": "Recipient",
        "channel": "Channel",
        "is_group": "Group Chat",
        "status": "Status",
        "created_at": "Created At",
        "incident_id": "Incident ID"
      },
      "yes": "Yes",
      "no": "No",
      "more_matches": "and {{count}} more"
    },
    "create_incident": "Create an incident",
    "notification_recipients": "Custom notification recipients",
    "notification_recipients_placeholder": "Search users..."
  },
  "phone_whitelist_settings_page": {
    "title": "Allowed Phone Numbers",
    "search": "Search phone numbers",
    "add_phones_modal": {
      "trigger": "Add phone numbers",
      "title": "Add phone numbers to allowed list",
      "description": "Use the text area below to add phone numbers to the allowed list. You can add multiple phone numbers by separating them with a new line.",
      "placeholder": "Enter phone numbers separated new line",
      "submit": "Add",
      "loading_message": "Adding phone numbers...",
      "success_message": "{{count}} phone numbers added successfully",
      "failed_message": "Failed to add phone numbers"
    },
    "cols": {
      "phone": "Phone Number"
    },
    "import_phones_modal": {
      "trigger": "Import",
      "title": "Import phone numbers",
      "description": "Choose a CSV file to import allowed phone numbers. Ensure your CSV file only has one column \"Phone\" with phone numbers.",
      "confirm": "{{fileName}} was successfully processed. We found {{count}} phone numbers. Would you like to add them to the allowed list?",
      "submit": "Import",
      "loading_message": "Importing phone numbers...",
      "success_message": "{{count}} phone numbers imported successfully",
      "failed_message": "Failed to import phone numbers"
    },
    "delete_phone_modal": {
      "trigger": "Delete Phone",
      "title": "Delete phone number",
      "description": "Are you sure you want to delete this phone number from the allowed list?",
      "description_multiple": "Are you sure you want to delete {{count}} phone numbers from the allowed list?",
      "submit": "Yes, Delete",
      "loading_message": "Deleting...",
      "success_message": "Phone number deleted successfully",
      "failed_message": "Failed to delete phone number"
    }
  },
  "whatsapp_business_api_settings_page": {
    "add_phone_successfully_toast": "New phone added successfully",
    "add_phone_failed_toast": "Failed to add phone number",
    "code_sent_successfully_toast": "Code sent successfully",
    "code_sent_failed_toast": "Code request failed",
    "phone_verified_successfully_toast": "Phone verified successfully",
    "phone_verified_failed_toast": "Failed to verify number, please try again",
    "verifyMethodModal": {
      "title": "Choose verify method",
      "submit_button": "Next",
      "text": "Choose how you would like to verify your number:",
      "desc": "If you are using a landline number, choose phone call."
    },
    "verifyModal": {
      "title": "Verify phone number",
      "text": "We sent a verification code to {{phone}}. To verify your number, enter the 6-digit code."
    },
    "verifyMethod": {
      "sms": "Text message",
      "voice": "Phone call"
    },
    "addPhoneNumberModal": {
      "title": "Add a phone number for WhatsApp",
      "phone_number_field_title": "Phone number",
      "phone_number_field_sub_title": "This is the number people will see when they chat with you.",
      "phone_number_field_sub_title_link": "Learn how to use a number that's already on WhatsApp.",
      "name_field_title": "WhatsApp Business display name",
      "name_field_sub_title": "Your display name should match your business name and adhere to WhatsApp Business display name guidelines.",
      "name_field_sub_title_link": "Learn more about display name guidelines.",
      "select_account_placeholder": "Please select a WhatsApp account"
    },
    "title": "WhatsApp Business API",
    "need_to_connect": "To enhance your experience and unlock advanced features, you need to connect to the WhatsApp Business API",
    "connect_button": "Connect",
    "disconnect_button": "Disconnect",
    "disconnect_modal_title": "Disconnect WhatsApp Business API",
    "disconnect_modal_message": "Are you sure you want to disconnect '{{wabaName}}'?",
    "reload": "Reload",
    "settings_saved_successfully": "Settings were successfully saved",
    "settings_saved_failed": "Settings failed to save",
    "code_status": {
      "NOT_VERIFIED": "Not Verified",
      "VERIFIED": "Verified",
      "NONE": "None",
      "EXPIRED": "Expired"
    },
    "name_status": {
      "APPROVED": "Approved",
      "AVAILABLE_WITHOUT_REVIEW": "Available",
      "DECLINED": "Declined",
      "EXPIRED": "Expired",
      "PENDING_REVIEW": "Pending Review",
      "NONE": "None"
    },
    "template_status": {
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "PENDING": "Pending",
      "NONE": "None"
    },
    "cols": {
      "phone": "Phone",
      "phone_id": "Phone ID",
      "display_name": "Display Name",
      "name_status": "Display Name Status",
      "code_status": "Code Status",
      "businessName": "Business Name",
      "wabaName": "WhatsApp Business Account",
      "businessStatus": "Business Status",
      "smartersStatus": "Smarters Status",
      "templateName": "Template Name",
      "languages": "Languages",
      "status": "Status",
      "template_available": "Template Available",
      "user_groups": "User Groups",
      "purpose": "Purpose"
    },
    "purpose": {
      "all": "All",
      "opt-in": "Opt-In",
      "campaign": "Campaign"
    },
    "preview_template": {
      "title": "{{name}}",
      "action": "Preview"
    },
    "edit_template": {
      "title": "Edit Template Groups",
      "user_groups_label": "User Groups",
      "all_users": "All Users",
      "save_success": "Template updated successfully",
      "save_error": "Failed to update template",
      "purpose_title": "Edit Template Purpose",
      "purpose_label": "Purpose",
      "purpose_opt_in": "Opt-In",
      "purpose_campaign": "Campaign"
    },
    "actions_phone_table": {
      "set_smarters_token": "Set Smarters token",
      "delete_smarters_token": "Delete Smarters token",
      "update_smarters_token": "Update Smarters token",
      "assign_users": "Assign users",
      "verify_number": "Verify number"
    },
    "smarters_modal": {
      "placeholder": "Enter Smarters Token",
      "delete_token_message": "Are you sure you want to delete Smarters token of phone number: {{phoneNumber}}"
    },
    "empty_state_no_phones_text": "No phone numbers have been added yet.",
    "empty_state_no_phones_button": "Add new number",
    "empty_state_no_template_message": "To get started, create your first WhatsApp Business API template",
    "empty_state_no_template_button": "Add template",
    "failed_to_disconnect": "Failed to disconnect WhatsApp Business API. Please try again.",
    "failed_to_connect": "Failed to connect WhatsApp Business API. Please try again.",
    "tabs": {
      "phones": "PHONES",
      "settings": "SETTINGS",
      "templates": "TEMPLATES"
    },
    "create_template": "Create template",
    "create_template_loading_toast": "Creating template...",
    "create_template_success_toast": "Template submitted for approval",
    "create_template_failed_toast": "Failed to create template",
    "createTemplateModal": {
      "title": "Create WhatsApp Template",
      "template_name": "Template Name",
      "template_name_tooltip": "Name must be lowercase and contain no spaces or special characters (use underscores instead).",
      "template_name_placeholder": "e.g. order_confirmation",
      "waba_account": "WhatsApp Business Account",
      "category": "Category",
      "language": "Language",
      "header_type": "Header",
      "header_text_placeholder": "Header text (max 60 characters)",
      "body": "Body",
      "body_placeholder": "Enter message body. Use {{1}}, {{2}} for dynamic parameters.",
      "body_helper": "To add a variable, use {{#}} where # is the variable index starting from 1.",
      "parameter_sample": "Sample for {{param}}",
      "parameter_sample_placeholder": "Enter sample value",
      "footer": "Footer",
      "footer_placeholder": "Footer text (max 60 characters)",
      "buttons": "Buttons",
      "add_button": "+ Add Button",
      "button_text_placeholder": "Button text",
      "button_text_too_long": "Button text can't have more than {{max}} characters",
      "button_url_placeholder": "https://example.com",
      "max_buttons_reached": "Maximum 3 buttons",
      "submit": "Create Template",
      "category_utility": "Utility",
      "category_marketing": "Marketing",
      "header_none": "None",
      "header_text": "Text",
      "button_quick_reply": "Quick Reply",
      "button_url": "URL",
      "template_preview_placeholder": "Template preview will appear here",
      "no_buttons_text": "No buttons added. Click + to add up to 3 buttons.",
      "header_image": "Image",
      "header_video": "Video",
      "header_document": "Document",
      "header_media_upload": "Upload sample media",
      "header_media_uploading": "Uploading...",
      "header_media_uploaded": "Media uploaded",
      "header_media_upload_failed": "Failed to upload media"
    },
    "add_waba_account": "Add account",
    "add_waba_phone": "Add phone number",
    "business_status_tag": {
      "rejected": "Rejected",
      "verified": "Verified",
      "pending": "Pending",
      "not_verified": "Not Verified",
      "pending_submission": "Pending Submission",
      "auth_error": "Reconnect required"
    }
  },
  "sidecars_page": {
    "title_short": "Remote Sync",
    "title": "Tuvis Remote Sync"
  },
  "all_users": {
    "title": "All Tuvis Users"
  },
  "internal_admin_tools": {
    "global_user_search": "All Users",
    "org_explorer": "Org Explorer"
  },
  "user_groups": {
    "headers": {
      "group_details": "Group Details"
    },
    "remove_user_from_group": "Remove user from group",
    "disabled_edit_name_tooltip": "This group name cannot be edited as\nit's synced from external system",
    "disabled_add_user_tooltip": "You cannot add users to this group because it's synced from an external system",
    "title": "User Groups",
    "add_group": "Add Group",
    "add_user": "Add User",
    "remove_user": "Remove User {{userName}}",
    "remove_group": "Remove Group",
    "update_group": "Update Group",
    "name": "Name",
    "type": "Type",
    "users": "Users",
    "external_scim": "SSO",
    "external_sfdc": "Salesforce profile",
    "confirm_delete_group": "Are you sure you want to delete this group?",
    "confirm_remove_user": "Are you sure you want to remove this user from the group?",
    "errors": {
      "default": "An error occurred while processing your request",
      "duplicate_key": "A group with this name already exists",
      "license_limit_reached": "License limit reached. Enabling this channel would exceed your available seats.",
      "load_failed": "Failed to load user groups"
    },
    "configs": {
      "activities_create": "Activities Create",
      "activities_display": "Activities Display",
      "show_chat_now_action": "Show Chat Now Action",
      "cases_create": "Cases Create",
      "cases_display": "Cases Display",
      "auto_sync_activities_limit": "Auto Sync Activities Limit",
      "contacts_create": "Contacts Create",
      "contacts_display": "Contacts Display",
      "create_person_account": "Create person accounts",
      "auto_sync_cases_limit": "Auto Sync Cases Limit",
      "leads_create": "Leads Create",
      "leads_display": "Leads Display",
      "opps_display": "Opportunities Display",
      "show_person_account": "Display person accounts",
      "tasks_create": "Tasks Create",
      "tasks_display": "Tasks Display",
      "filter_analytics_by_profile": "Filter Analytics By Profile",
      "show_edit_layout": "Show Edit Layout",
      "block_unknown_person": "Block Unknown Person",
      "show_auto_sync_button": "Show Auto Sync Button",
      "show_global_search": "Show Global Search",
      "show_new_event_action": "Show New Event Action",
      "show_add_to_phone_action": "Show Add To Phone Action",
      "show_calendar": "Show Calendar",
      "hide_all_create_actions": "Hide All Create Actions",
      "periodic_auto_sync": "Periodically sync all messages",
      "show_whatsapp_calls": "Show WhatsApp Calls"
    }
  },
  "users_lists": {
    "load_failed": "Failed to load users list"
  },
  "group_metadata": {
    "title": "WhatsApp Groups",
    "details_title": "WhatsApp Group Details",
    "subject": "Group Name",
    "no_subject": "N/A",
    "group_id": "Group ID",
    "source_phone": "Source Phone",
    "participants": "Participants",
    "participants_count": "{{count}} participants",
    "creation_date": "Creation Date",
    "last_message_date": "Last Message",
    "member_add_mode": "Member Add Mode",
    "restrict": "Restricted",
    "participant_name": "Name",
    "participant_phone": "Phone Number",
    "is_admin": "Admin",
    "no_name": "N/A",
    "no_participants": "No participants",
    "not_found": "Group not found",
    "filter_by_user_placeholder": "Filter by user",
    "show_only_disabled_users": "Show only disabled users",
    "participant_type": "User Type",
    "org_user": "Org User",
    "external_user": "External",
    "member_add_mode_all_members": "All members",
    "member_add_mode_only_admin": "Only admin",
    "search_empty": {
      "no_results": "No WhatsApp groups have been synced yet"
    },
    "search_placeholder": "Search groups by name...",
    "view_logs": "View Logs",
    "logs_modal": {
      "title": "Group Activity Logs",
      "event_type": "Event Type",
      "performed_by": "Performed By",
      "affected": "Affected",
      "date_time": "Date & Time",
      "no_events": "No activity logs found"
    },
    "event_type": {
      "subject": "Name Changed",
      "add": "User Added",
      "remove": "User Removed",
      "leave": "User Left",
      "create": "Group Created",
      "restrict": "Edit Info Permission Changed",
      "restrict_on": "Edit Info: Admins Only",
      "restrict_off": "Edit Info: All Members",
      "announce": "Messaging Permission Changed",
      "announce_on": "Messaging: Admins Only",
      "announce_off": "Messaging: All Members",
      "member_add_mode": "Member Add Mode Changed",
      "member_add_mode_on": "Member Add Mode: Admins Only",
      "member_add_mode_off": "Member Add Mode: All Members"
    }
  },
  "audit_log": {
    "filters": "Filters",
    "title": "Audit Log",
    "unknown_user": "Unknown User",
    "reason": "reason",
    "from": "from",
    "to": "to",
    "header": {
      "type": "Type",
      "event": "Event",
      "time": "Time",
      "description": "Description"
    },
    "namespaces": {
      "sidecars": "Tuvis Remote Sync",
      "integrations": "Integrations",
      "users": "Users",
      "userGroups": "Groups",
      "settings": "Settings",
      "waba": "WhatsApp Business API",
      "twilio": "Tuvis Call Recording",
      "auth": "Authentication",
      "dlp": "Data Loss Protection",
      "surveillance": "Surveillance",
      "incident": "Incidents",
      "urlPolicies": "Desktop Policies",
      "email": "Email",
      "keywordInsights": "Keyword Insights",
      "phonesWhitelist": "Phone Allowlist",
      "phonesBlocklist": "Private Phone Numbers",
      "blockedPhones": "Blocked Phones (chat)",
      "tuvisContacts": "Tuvis Contacts",
      "fraudDetection": "Fraud Detection",
      "dashboards": "Custom View",
      "customFilters": "Custom Filters",
      "accounts": "Accounts",
      "archive": "Archive",
      "platforms": "Platforms",
      "saml": "SAML",
      "botFlows": "Bot Flows"
    },
    "descriptions": {
      "dashboard_created": {
        "event_name": "Dashboard Created",
        "description": "Dashboard \"{{metadata.name}}\" was created by {{metadata.userName}}"
      },
      "dashboard_updated": {
        "event_name": "Dashboard Updated",
        "description": "Dashboard \"{{metadata.name}}\" was updated by {{metadata.userName}}"
      },
      "dashboard_deleted": {
        "event_name": "Dashboard Deleted",
        "description": "Dashboard \"{{metadata.name}}\" was deleted by {{metadata.userName}}"
      },
      "widget_created": {
        "event_name": "Widget Created",
        "description": "Widget \"{{metadata.title}}\" was added to dashboard by {{metadata.userName}}"
      },
      "widget_deleted": {
        "event_name": "Widget Deleted",
        "description": "Widget \"{{metadata.title}}\" was removed from dashboard by {{metadata.userName}}"
      },
      "incident_summary_reported": {
        "event_name": "Summary Reported",
        "description": "Incident Summary Report Sent To Email"
      },
      "incident_reported": {
        "event_name": "Incident Reported",
        "description": "Incident created by '{{metadata.userName}}'"
      },
      "new_url_policy": {
        "event_name": "New Url Policy Created",
        "description": "Url policy created by '{{metadata.userName}}'"
      },
      "update_url_policy": {
        "event_name": "Url Policy Updated",
        "description": "Url policy updated by '{{metadata.userName}}'"
      },
      "delete_url_policy": {
        "event_name": "Url Policy Deleted",
        "description": "Url policy deleted by '{{metadata.userName}}'"
      },
      "new_surveillance_policy": {
        "event_name": "New Surveillance Policy Created",
        "description": "Surveillance policy created by '{{metadata.userName}}'"
      },
      "update_surveillance_policy": {
        "event_name": "Surveillance Policy Updated",
        "description": "Surveillance policy updated by '{{metadata.userName}}'"
      },
      "delete_surveillance_policy": {
        "event_name": "Surveillance Policy Deleted",
        "description": "Surveillance policy deleted by '{{metadata.userName}}'"
      },
      "new_surveillance_rule": {
        "event_name": "New Surveillance Rule Created",
        "description": "Surveillance rule created by '{{metadata.userName}}'"
      },
      "update_surveillance_rule": {
        "event_name": "Surveillance Rule Updated",
        "description": "Surveillance rule updated by '{{metadata.userName}}'"
      },
      "delete_surveillance_rule": {
        "event_name": "Surveillance Rule Deleted",
        "description": "Surveillance rule deleted by '{{metadata.userName}}'"
      },
      "new_incident": {
        "event_name": "New Incident Created",
        "description": "Incident created by '{{metadata.userName}}'"
      },
      "update_incident_status": {
        "event_name": "Incident Status Updated",
        "description": "Incident status changed to '{{metadata.status}}' by '{{metadata.userName}}'"
      },
      "update_surveillance_incident_status": {
        "event_name": "Surveillance Incident Status Updated",
        "description": "Surveillance incident status changed to '{{metadata.status}}' by '{{metadata.userName}}'"
      },
      "surveillance_incident_reported": {
        "event_name": "Surveillance Incident Reported",
        "description": "Surveillance incident reported by '{{metadata.userName}}'"
      },
      "update_incident_assignee": {
        "event_name": "Incident Assignee Updated",
        "description": "Incident assignee updated to '{{metadata.assigneeName}}' by '{{metadata.userName}}'"
      },
      "create_policy": {
        "event_name": "DLP Policy Created",
        "description": "User {{metadata.userName}} create policy - {{metadata.policy.name}}"
      },
      "update_policy": {
        "event_name": "DLP Policy Updated",
        "description": "User {{metadata.userName}} update policy - {{metadata.policy.name}}"
      },
      "delete_policy": {
        "event_name": "DLP Policy Deleted",
        "description": "User {{metadata.userName}} delete policy - {{metadata.policyName}}"
      },
      "create_rule": {
        "event_name": "DLP Rule Created",
        "description": "User {{metadata.userName}} create rule - {{metadata.rule.name}}"
      },
      "update_rule": {
        "event_name": "DLP Rule Updated",
        "description": "User {{metadata.userName}} update rule - {{metadata.rule.name}}"
      },
      "delete_rule": {
        "event_name": "DLP Rule Deleted",
        "description": "User {{metadata.userName}} delete rule - {{metadata.ruleName}}"
      },
      "disconnected": {
        "event_name": "Device Disconnected",
        "description": "{{channel}} device disconnected - {{sidecarName}}"
      },
      "run_completed": {
        "event_name": "Device Sync Completed",
        "description": "Device sync completed - {{sidecarName}}"
      },
      "run_failed": {
        "event_name": "Device Sync Failed",
        "description": "Device sync errored - {{sidecarName}}"
      },
      "pairing_phone_mismatch": {
        "event_name": "Device Number Conflict",
        "description": "{{channel}} device pairing failed due to phone mismatch - {{sidecarName}}"
      },
      "pairing_success": {
        "event_name": "Device Pairing Successful",
        "description": "{{channel}} device paired successfully - {{sidecarName}}"
      },
      "pairing_failed": {
        "event_name": "Device Pairing Failed",
        "description": "{{channel}} device paired failed - {{sidecarName}}"
      },
      "created": {
        "event_name": "Device Created",
        "description": "Device created by {{metadata.inviter}} - {{sidecarName}}"
      },
      "invited": {
        "event_name": "User Invited to Pair",
        "description": "{{metadata.senderUserName}} invited {{metadata.recipientName}} ({{metadata.email}}) to pair with Tuvis"
      },
      "auto_invited": {
        "event_name": "User Auto-Invited to Pair",
        "description": "Automatically invited {{metadata.email}} to pair with Tuvis"
      },
      "update_settings": {
        "event_name": "Device Settings Updated",
        "description": "Device settings updated by {{userName}}{{sidecarName}}"
      },
      "started": {
        "event_name": "Device Sync Started",
        "description": "Device Sync started - {{sidecarName}}"
      },
      "started_pairing": {
        "event_name": "Device Pairing Started",
        "description": "Device Pairing started - {{sidecarName}}"
      },
      "deleted": {
        "event_name": "Device Deleted",
        "description": "Device{{sidecarName}} deleted by {{userName}}"
      },
      "connect": {
        "event_name": "Integration Connected",
        "description": "{{metadata.type}} integration connected"
      },
      "disconnect": {
        "event_name": "Integration Disconnected",
        "description": "{{metadata.type}} integration disconnected"
      },
      "update": {
        "event_name": "Integration Updated",
        "description": "{{metadata.type}} integration updated"
      },
      "clear_query_cache": {
        "event_name": "SFDC Query Cache Cleared",
        "description": "SFDC Query cache cleared"
      },
      "login": {
        "event_name": "User Login",
        "description": "User {{name}} has login successfully to {{platform}} with {{crmAuthProvider}}"
      },
      "update_permissions": {
        "event_name": "User Permissions Updated",
        "description": "User permissions updated - {{userName}} changed {{whatsllyUserName}} permissions"
      },
      "edit_user": {
        "event_name": "User Updated",
        "description": "User updated - {{userName}} edited {{whatsllyUserName}}"
      },
      "disabled_user": {
        "event_name": "User Disabled",
        "description": "User Disabled - {{userName}} disabled {{whatsllyUserName}}"
      },
      "activate_user": {
        "event_name": "User Activated",
        "description": "User Activated - {{userName}} activated {{whatsllyUserName}}"
      },
      "users_invited": {
        "event_name": "Users Invited",
        "description": "Users invited - {{userName}} invited {{emails}}"
      },
      "user_invited": {
        "event_name": "User Invited",
        "description": "{{inviterName}} invited {{recipientName}} to connect with Tuvis"
      },
      "user_was_invited": {
        "event_name": "Invited to Connect",
        "description": "{{recipientName}} was invited by {{inviterName}} to connect with Tuvis"
      },
      "invite_deleted": {
        "event_name": "User Invite Deleted",
        "description": "User invite deleted - {{userName}} deleted {{emails}} invitation"
      },
      "download_csv": {
        "event_name": "Users CSV Downloaded",
        "description": "Users CSV Downloaded - {{userName}} downloaded users csv"
      },
      "new_user": {
        "event_name": "New User Created",
        "description": "New user created - {{userName}} ({{emails}})"
      },
      "read_messages": {
        "event_name": "User Read Messages",
        "description": "User '{{userName}}' has read '{{viewedUserName}}' messages"
      },
      "assign_user": {
        "event_name": "Users Assigned to Group",
        "description": "{{userName}} added {{count}} users to {{groupName}}"
      },
      "unassign_user": {
        "event_name": "Users Removed from Group",
        "description": "{{userName}} removed {{count}} users from {{groupName}}"
      },
      "create_group": {
        "event_name": "Group Created",
        "description": "Group created - {{userName}} created {{groupName}}"
      },
      "update_group": {
        "event_name": "Group Updated",
        "description": "Group updated - {{userName}} updated {{groupName}}"
      },
      "remove_group": {
        "event_name": "Group Deleted",
        "description": "Group deleted - {{userName}} deleted {{groupName}}"
      },
      "set_global_layout": {
        "event_name": "Global Layout Updated",
        "description": "Global Layout updated"
      },
      "set_hide_edit_layout": {
        "event_name": "Hide Edit Layout Updated",
        "description": "Hide Edit Layout updated - {{configValue}}"
      },
      "reset_user_layouts": {
        "event_name": "User Layouts Reset",
        "description": "User Layouts Reset"
      },
      "org_configs_updated": {
        "event_name": "Organization Configs Updated",
        "description": "{{userName}} changed organization configs {{orgConfigsUpdateds}} {{reason}}"
      },
      "elite_token_generated": {
        "event_name": "Elite Security Token Generated",
        "description": "{{userName}} generated a new elite security token"
      },
      "elite_token_updated": {
        "event_name": "Elite Security Token Updated",
        "description": "{{userName}} updated the elite security token"
      },
      "change_org_name": {
        "event_name": "Organization Profile Updated",
        "description": "{{userName}} updated organization profile {{orgConfigsUpdateds}}"
      },
      "create_org": {
        "event_name": "Organization Created",
        "description": "Organization created by to {{metadata.userName}}"
      },
      "create_api_key": {
        "event_name": "Public API Key Created",
        "description": "Public api key created with id {{entityId}}"
      },
      "revoke_api_key": {
        "event_name": "Public API Key Revoked",
        "description": "Public api key revoked with id {{entityId}}"
      },
      "connected_to_waba": {
        "event_name": "WhatsApp Business API Connected",
        "description": "WhatsApp Business API connected - {{metadata.userName}}"
      },
      "disconnected_from_waba": {
        "event_name": "WhatsApp Business API Disconnected",
        "description": "WhatsApp Business API disconnected - {{userName}}"
      },
      "connected_to_twilio": {
        "event_name": "Twilio Connected",
        "description": "Twilio connected - {{metadata.userName}}"
      },
      "disconnect_from_twilio": {
        "event_name": "Twilio Disconnected",
        "description": "Twilio disconnected"
      },
      "purchase-phone": {
        "event_name": "Twilio Phone Number Purchased",
        "description": "Phone number purchased - {{metadata.userName}} purchased {{metadata.phone_number}}"
      },
      "update-phone": {
        "event_name": "Twilio Phone Number Updated",
        "description": "Phone number updated - {{metadata.userName}} updated {{metadata.phone_number}}"
      },
      "release-phone": {
        "event_name": "Twilio Phone Number Released",
        "description": "Phone number released - {{metadata.userName}} released {{metadata.phone_number}}"
      },
      "create_campaign": {
        "event_name": "Campaign Created",
        "description": "Campaign created - {{metadata.userName}} created {{metadata.campaign.name}}"
      },
      "update_campaign": {
        "event_name": "Campaign Updated",
        "description": "Campaign updated - {{metadata.userName}} updated {{metadata.campaign.name}}"
      },
      "delete_campaign": {
        "event_name": "Campaign Deleted",
        "description": "Campaign deleted - {{metadata.userName}} deleted {{metadata.campaign.name}}"
      },
      "add_blocklist_phones": {
        "event_name": "Private Phone Numbers Added",
        "description": "Private Phone Numbers Added - {{metadata.userName}} added {{metadata.addedCount}} phone numbers"
      },
      "delete_blocklist_phone": {
        "event_name": "Private Phone Number Deleted",
        "description": "Private Phone Number Deleted - {{metadata.userName}} deleted {{metadata.phone}}"
      },
      "add_blocked_phones": {
        "event_name": "Blocked Phones (chat) Added",
        "description": "Blocked Phones (chat) Added - {{metadata.userName}} added {{metadata.addedCount}} phone numbers"
      },
      "delete_blocked_phone": {
        "event_name": "Blocked Phones (chat) Deleted",
        "description": "Blocked Phones (chat) Deleted - {{metadata.userName}} deleted {{metadata.phone}}"
      },
      "add_whitelist_phones": {
        "event_name": "Phone Allowlist Added",
        "description": "Phone Allowlist Added - {{metadata.userName}} added {{metadata.addedCount}} phone numbers"
      },
      "delete_whitelist_phone": {
        "event_name": "Phone Allowlist Deleted",
        "description": "Phone Allowlist Deleted - {{metadata.userName}} deleted {{metadata.phone}}"
      },
      "new_tuvis_contact": {
        "event_name": "Tuvis Contact Created",
        "description": "Tuvis Contact Created - {{metadata.userName}} created {{entityId}}"
      },
      "update_tuvis_contact": {
        "event_name": "Tuvis Contact Updated",
        "description": "Tuvis Contact Updated - {{metadata.userName}} updated {{entityId}}"
      },
      "delete_tuvis_contact": {
        "event_name": "Tuvis Contact Deleted",
        "description": "Tuvis Contact Deleted - {{metadata.userName}} deleted {{entityId}}"
      },
      "import_tuvis_contacts": {
        "event_name": "Tuvis Contacts Imported",
        "description": "Tuvis Contacts Imported - {{metadata.userName}} imported {{metadata.contacts.length}} contacts"
      },
      "add_malicious_hashes": {
        "event_name": "Malicious Hashes Added",
        "description": "Malicious Hashes Added - {{metadata.userName}} added {{metadata.addedCount}} hashes"
      },
      "delete_malicious_hashes": {
        "event_name": "Malicious Hashes Deleted",
        "description": "Malicious Hashes Deleted - {{metadata.userName}} deleted {{metadata.hashes.length}} hashes"
      },
      "add_malicious_urls": {
        "event_name": "Malicious URLs Added",
        "description": "Malicious URLs Added - {{metadata.userName}} added {{metadata.addedCount}} URLs"
      },
      "delete_malicious_urls": {
        "event_name": "Malicious URLs Deleted",
        "description": "Malicious URLs Deleted - {{metadata.userName}} deleted {{metadata.urls.length}} URLs"
      },
      "create_account": {
        "event_name": "Account Created",
        "description": "Account created - {{metadata.name}}"
      },
      "update_account": {
        "event_name": "Account Updated",
        "description": "Account updated - {{metadata.name}}"
      },
      "unassign_org": {
        "event_name": "Organization Unassigned from Account",
        "description": "Organization unassigned from account"
      },
      "update_user_permissions": {
        "event_name": "Account User Permissions Updated",
        "description": "Account user permissions updated"
      },
      "delete_account_users": {
        "event_name": "Users Removed from Account",
        "description": "Users removed from account - {{metadata.count}} user(s)"
      },
      "invite_external_user": {
        "event_name": "External User Invited to Account",
        "description": "External user invited to account - {{metadata.email}} by {{metadata.userName}}"
      },
      "resend_invite": {
        "event_name": "Account Invite Resent",
        "description": "Account invite resent - {{metadata.count}} invite(s)"
      },
      "install_platform": {
        "event_name": "Platform Installed",
        "description": "Platform installed - {{metadata.platformType}} ({{metadata.platformWorkspaceName}})"
      },
      "uninstall_platform": {
        "event_name": "Platform Uninstalled",
        "description": "Platform uninstalled - {{metadata.platformType}}"
      },
      "update_platform_metadata": {
        "event_name": "Platform Metadata Updated",
        "description": "Platform metadata updated"
      },
      "create_platform": {
        "event_name": "Archive Platform Created",
        "description": "Archive platform created - {{metadata.platform}}"
      },
      "update_platform": {
        "event_name": "Archive Platform Updated",
        "description": "Archive platform updated - {{metadata.platform}}"
      },
      "delete_platform": {
        "event_name": "Archive Platform Deleted",
        "description": "Archive platform deleted - {{metadata.platform}}"
      },
      "scim_create_group": {
        "event_name": "Group Created (SCIM)",
        "description": "Group created via SCIM - {{metadata.displayName}}"
      },
      "scim_update_group": {
        "event_name": "Group Updated (SCIM)",
        "description": "Group updated via SCIM - {{metadata.displayName}}"
      },
      "scim_patch_group": {
        "event_name": "Group Patched (SCIM)",
        "description": "Group patched via SCIM - {{metadata.displayName}}"
      },
      "scim_delete_group": {
        "event_name": "Group Deleted (SCIM)",
        "description": "Group deleted via SCIM - {{metadata.displayName}}"
      },
      "scim_create_user": {
        "event_name": "User Created (SCIM)",
        "description": "User created via SCIM - {{metadata.userName}}"
      },
      "scim_update_user": {
        "event_name": "User Updated (SCIM)",
        "description": "User updated via SCIM - {{metadata.userName}}"
      },
      "scim_patch_user": {
        "event_name": "User Patched (SCIM)",
        "description": "User patched via SCIM - {{metadata.userName}}"
      },
      "scim_deactivate_user": {
        "event_name": "User Deactivated (SCIM)",
        "description": "User deactivated via SCIM - {{metadata.userName}}"
      },
      "scim_reactivate_user": {
        "event_name": "User Reactivated (SCIM)",
        "description": "User reactivated via SCIM - {{metadata.userName}}"
      },
      "install_saml": {
        "event_name": "SAML Installed",
        "description": "SAML configured for organization"
      },
      "remove_saml": {
        "event_name": "SAML Removed",
        "description": "SAML configuration removed from organization"
      },
      "save_notifications": {
        "event_name": "Device Notifications Saved",
        "description": "Device notification settings saved"
      },
      "save_flow": {
        "event_name": "Bot Flow Saved",
        "description": "Bot flow version {{metadata.version}} saved by {{metadata.userName}}"
      },
      "publish_flow": {
        "event_name": "Bot Flow Published",
        "description": "Bot flow version {{metadata.version}} published by {{metadata.userName}}"
      },
      "unpublish_flow": {
        "event_name": "Bot Flow Unpublished",
        "description": "Bot flow unpublished by {{metadata.userName}}"
      },
      "stop_session": {
        "event_name": "Bot Session Stopped",
        "description": "Bot session for {{metadata.senderNumber}} stopped by {{metadata.userName}}"
      },
      "clone_flow": {
        "event_name": "Bot Flow Cloned",
        "description": "Bot flow \"{{metadata.flowName}}\" cloned by {{metadata.userName}}"
      },
      "update_flow_metadata": {
        "event_name": "Bot Flow Metadata Updated",
        "description": "Bot flow \"{{metadata.flowName}}\" metadata updated by {{metadata.userName}}"
      },
      "create_flow": {
        "event_name": "Bot Flow Created",
        "description": "Bot flow \"{{metadata.flowName}}\" created by {{metadata.userName}}"
      },
      "assign_phones": {
        "event_name": "Bot Flow Phones Assigned",
        "description": "Bot flow phone assignments updated by {{metadata.userName}}"
      }
    }
  },
  "default_channels": {
    "whatsapp-web": "WhatsApp (Tuvis desktop App)",
    "imessage": "iMessage",
    "telegram": "Telegram"
  },
  "saml_settings": {
    "sign_auth_res": "Sign Auth Response",
    "sign_auth_res_tooltip": "Determines whether the SAML authentication response message is digitally signed by the IDP or not, make sure this configuration match your IDP.",
    "sign_assertion": "Sign Assertion",
    "sign_assertion_tooltip": "Determines whether the SAML assertion is digitally signed or not, make sure this configuration match your IDP.",
    "disable_requested_authn_context": "Disable Requested Authn Context",
    "disable_requested_authn_context_tooltip": "If checked, do not request a specific authentication context",
    "use_browser": "Open authentication in browser",
    "use_browser_tooltip": "If checked, SAML authentication will open in the user's default browser instead of within the application",
    "default_channel_title": "Set default channel for new users:",
    "default_permission_title": "Set default permissions for new users:",
    "default_groups_title": "Set default groups for new users:",
    "provisioning": "Provisioning",
    "scim_url": "Tenant URL",
    "scim_token": "Secret Token",
    "disable_scim_invite_email": "Disable invitation email",
    "disable_scim_invite_email_tooltip": "When enabled, users created through SCIM provisioning will not receive the platform invitation email.",
    "scim_list_active_only": "Exclude deactivated users from SCIM listings",
    "scim_list_active_only_tooltip": "When enabled, unfiltered SCIM `GET /Users` responses return only active users. Required for IdPs that treat the list as the managed user set (e.g. JumpCloud). Leave off for SCIM-compliant behavior (RFC 7644 §3.4.2) — IdPs that need only active users should send `filter=active eq true`.",
    "attribute_mapping_title": "Attribute mapping",
    "attribute_mapping_tooltip": "Map incoming SCIM attributes to your custom fields. Standard fields are mapped automatically and shown for reference. For each custom field, enter the source SCIM attribute path — for example 'title', or an extension path such as the enterprise 'employeeNumber' or Entra 'extensionAttribute1' attributes.",
    "attribute_mapping_placeholder": "SCIM attribute path (e.g. title)",
    "attribute_mapping_empty": "Create custom fields first (Platform > Custom Fields) to map SCIM attributes to them.",
    "attribute_mapping_col_tuvis": "Tuvis User",
    "attribute_mapping_col_scim": "SCIM Source User",
    "save_changes": "Save changes",
    "save_changes_confirm": "Are you sure you want to save changes?",
    "title": "SSO Settings",
    "invite_to_platform_tooltip": "Invite a new user to the platform. this will create a new organizations when they sign up. inviting to an existing organization can be done from the \"Users\" page.",
    "saml_settings": "SSO Settings for Org",
    "force_saml_only": "Allow Login Only Using SSO",
    "drop_xml": "Drop XML file here or click to browse",
    "import_xml": "Import Metadata XML",
    "xml_url": "Import from URL",
    "invalid_url": "Invalid XML URL",
    "import_xml_placeholder": "https://login.microsoftonline.com/<tenant_id>/FederationMetadata/2007-06/FederationMetadata.xml?appid=<app_id>",
    "add_to_provider": "Add The following to your identity provider:",
    "sp_entity_id": "SP Entity ID",
    "acs_url": "SP ACS URL",
    "curreny_saml_settings": "Current SSO Settings",
    "domains_usage": " is used by {{organizations}} organization(s)",
    "friendly_org_name": "Organization Name",
    "friendly_org_name_tooltip": "Displayed at login to help users select the correct organization when multiple organizations are associated with the same SAML domain.",
    "org_email_domain": "Organization Email Domain",
    "idp_entity_id": "IdP Entity ID",
    "idp_sso_url": "IdP SSO URL",
    "idp_certificates": "IdP Certificate",
    "save_saml_settings": "Save SSO Settings"
  },
  "search_person": {
    "loading": "Loading..."
  },
  "file_invalid": {
    "size": "Unable to sync due to file size limit",
    "mimeType": "File type not supported",
    "messageType": "Message type not supported"
  },
  "destinations_page": {
    "target_index": "Target Data Stream / Index",
    "pipeline_id": "Ingest Pipeline ID",
    "tags": {
      "all_users": "All users"
    },
    "table_actions": {
      "edit_connection": "Edit Connection",
      "edit_details": "Edit Details"
    },
    "table_headers": {
      "name": "Name",
      "logo": "Logo",
      "integration": "Integration",
      "type": "Type",
      "user_groups": "User Groups"
    },
    "edit_integration": {
      "header": "Edit Integration"
    },
    "edit_details": {
      "header": "Edit Details",
      "view_only_label": "View only"
    },
    "add_integration": {
      "header": "Add Integration",
      "name": "Name",
      "name_placeholder": "e.g., S3 for Sales",
      "user_groups": "User Groups",
      "all_users": "All users"
    },
    "available_fields": "Available Fields",
    "language": "Language",
    "all_types": "All types",
    "type": "Type",
    "tabs": {
      "messages": "Messages",
      "auditLogs": "Audit Logs",
      "dlpIncidents": "Incidents",
      "audioTranscribes": "Audio Transcribe",
      "dlpDetectors": "DLP Detectors",
      "security": "Security",
      "fileScanning": "Fraud Detection",
      "llmProvider": "AI Providers",
      "platforms": "Platforms",
      "channels": "Channels",
      "archive": "Archive"
    },
    "incident_types": {
      "label": "Incident Types",
      "dlp": "DLP",
      "surveillance": "Surveillance",
      "fraud": "Fraud Detection"
    },
    "security": {
      "add": "Add",
      "remove": "Remove",
      "disclaimer": "Select your infrastructure to receive the correct network enforcement guide from Tuvis. Adding a platform identifies your environment; it does not establish a live data connection to these systems."
    },
    "pipedrive": {
      "text": "Connect your PipeDrive account to sync messages\n",
      "connect": "Connect",
      "reconnect": "Reconnect"
    },
    "hubspot": {
      "connect": "Connect",
      "reconnect": "Reconnect",
      "text": "Connect your HubSpot account to sync messages"
    },
    "crm": {
      "lead": "Lead",
      "contact": "Contact",
      "field_value": "Field Value",
      "field_name": "Field Name",
      "enableObjectSettingsCheckbox": "Create object if not find"
    },
    "global_relay": {
      "description": "To enable the integration, contact your account manager or support team at GlobalRelay (also put provisioning@globalrelay.net in cc), and ask for your account's custom SMTP details:",
      "subDescription": {
        "host": {
          "subject": "SMTP Server Host",
          "desc": ": should look like this: feeds-xyz.globalrelay.com"
        },
        "username_password": "Custom SMTP username and password",
        "smtp_destination": {
          "subject": "Journaling SMTP Destination",
          "desc": ": an email address that should look like this: feed-########@feeds.globalrelay.com"
        },
        "msg_type": {
          "subject": "X-GlobalRelay-MsgType",
          "desc": ": which will usually be \"TuvisWhatsApp\""
        }
      }
    },
    "title": "Integrations",
    "revoke_destination": "Disconnect Integration",
    "revoke_destination_confirmation": "Are you sure you want to disconnect {{destinationName}}?",
    "revoke_destination_with_batch_mode_on_confirmation": "Are you sure you want to disconnect {{destinationName}}? Turning batch mode off will leave unsynced messages unsynchronized. Are you certain you want to proceed?",
    "revoke_button_text": "Disconnect {{destinationName}}",
    "enable_destination_confirmation": "Are you sure you want to enable {{destinationName}}?",
    "disable_destination_confirmation": "Are you sure you want to disable {{destinationName}}?",
    "cancel_button_text": "Cancel",
    "format": "Format",
    "bucket": "Bucket",
    "iam_role_name": "Role ARN",
    "external_id": "External ID",
    "openid_provider_url": "OpenId Provider Url",
    "access_key_auth": "Access Key Auth",
    "identity_provider_auth": "Identity Provider Auth",
    "file_name_template": "Filename Template",
    "file_name_upload_date": "Include Upload Date in Filenames",
    "media_file_name_template": "Media Filename Template",
    "store_media": "Store Media",
    "client_encryption_key": "Client-Side Encryption Key",
    "client_encryption": "Client-Side Encryption",
    "flat": "Save files flat on base path root",
    "zipped": "Save media file zipped",
    "msg_date_timezone": "Date timezone",
    "file_name_date_timezone": "File name timezone",
    "yes": "Yes",
    "no": "No",
    "save_base_path": "Save Base Path",
    "read_base_path": "Read Base Path",
    "region": "Region",
    "accesses_key_id": "Access Key ID",
    "secret_access_key": "Secret Access Key",
    "enable_long_audio_transcription": "Enable transcription for audio longer than 3 minutes",
    "enable_long_audio_transcription_tooltip": "To transcribe audio files longer than 3 minutes, Tuvis needs access to an S3 bucket with write and delete permissions.",
    "temporary_s3_bucket": "Temporary S3 Bucket",
    "temporary_s3_region": "Temporary S3 Region",
    "temporary_s3_prefix": "Temporary S3 Prefix (Optional)",
    "account_name": "Account Name",
    "account_key": "Account Key",
    "sas_url": "SAS URL",
    "container_name": "Container Name",
    "storage_url": "Storage URL",
    "api_key": "Api Key",
    "google_api_key": "Google Api Key",
    "webhook_access_key": "Webhook Access Key",
    "llm_enabled_models": "Allowed models",
    "llm_enabled_models_placeholder": "Leave empty to allow all models",
    "llm_default_model": "Default model",
    "llm_default_model_placeholder": "Select default model for new chats",
    "connection_string": "Connection String",
    "host": "Host",
    "port": "Port",
    "user": "User",
    "password": "Password",
    "rcpt": "SMTP Destination",
    "secure": "Secure",
    "true": "True",
    "false": "False",
    "server_url": "Server Url",
    "api_url": "Api Url",
    "blob_storage": "Blob Storage",
    "file_scanning_category": "File Scanning",
    "compliance": "Compliance",
    "dlp": "Data Loss Protection",
    "sftp_password_or_privateKeyError": "You must enter either password or private key",
    "create_destination_in_progress": "Create destination in progress",
    "destination_created_successfully": "Destination created successfully",
    "failed_to_create_destination": "Failed to create destination",
    "revoke_destination_in_progress": "Disconnect integration in progress",
    "destination_revoked_successfully": "Integration disconnected successfully",
    "failed_to_revoke_destination": "Failed to disconnect integration",
    "do_you_want_store_media": "Do you want to store media in your Salesforce instance?",
    "update_destination_in_progress": "Update destination in progress",
    "destination_updated_successfully": "Destination updated successfully",
    "failed_to_update_destination": "Failed to update destination",
    "salesforce_user": "Salesforce User",
    "failed_to_get_integrations": "Failed to get integrations",
    "save": "Save",
    "download_certificate": "Download certificate",
    "generate_certificate": "Generate certificate",
    "generate_certificate_failed_toast": "Failed to generate certificate file. Please try again.",
    "connected_app_consumer_key": "Connected App Consumer Key",
    "connector_name": "Connector Name",
    "object_name": "Object Name",
    "ingestion_endpoint": "Ingestion Endpoint",
    "client_id": "Client ID",
    "client_secret": "Client Secret",
    "url": "URL",
    "tenant_id": "Tenant ID",
    "user_id": "User ID",
    "username": "Username",
    "test_connection": "Test connection",
    "test_connection_failed_toast": "Connection test failed. Please check your settings.",
    "test_connection_s3_validation_failed_toast": "There was a problem with the S3 validation. Please check role permissions.",
    "test_connection_transcribe_validation_failed_toast": "There was a problem with the Transcribe validation. Please check role permissions.",
    "project_id": "Project ID",
    "client_email": "Client Email",
    "private_key": "Private Key",
    "sentinel": {
      "tenant_id": "Azure Tenant ID",
      "client_id": "Client ID",
      "client_secret": "Client Secret",
      "dce_endpoint": "Data Collection Endpoint URL",
      "dcr_immutable_id": "DCR Immutable ID",
      "stream_name": "Stream Name (optional)"
    },
    "batch": {
      "title": "Run as batch job",
      "batch_sync_turn_off_title": "Turn off 'run as Batch' mode",
      "batch_sync_turn_off_desc": "Turning batch mode off will leave unsynced messages unsynchronized. Are you certain you want to proceed?"
    },
    "connected_integrations": "Connected Integrations",
    "empty_state": {
      "title": "No {{destinationName}} integrations connected",
      "description": "Add a {{destinationName}} integration to get started"
    },
    "aws_region": "AWS Region",
    "aws_access_key_id": "AWS Access Key ID",
    "aws_secret_access_key": "AWS Secret Access Key",
    "aws_session_token": "AWS Session Token"
  },
  "dlp_incident_page": {
    "header": "Incident Details",
    "channel": "Channel",
    "incident_id": "Incident Id",
    "refresh": "Refresh",
    "details": "Details",
    "attachments_match_details": {
      "title": "Attachments Match Details",
      "description": "Details on how the attachments matched the rule"
    },
    "source": "Source",
    "image_unappropriate": "Image Inappropriate",
    "triggered_rule": "Rule",
    "match_source": {
      "content": "File Content",
      "metadata": "File Metadata",
      "filename": "File Name",
      "image": "Image"
    }
  },
  "campaigns": {
    "title": "Campaigns",
    "campaigns_tab": "Campaigns",
    "templates_tab": "Templates",
    "new_campaign": "New Campaign",
    "search_placeholder": "Search",
    "no_campaigns": "No campaigns found",
    "no_search_results": "No campaigns match your search",
    "cols": {
      "template": "Template",
      "date": "Date",
      "status": "Status",
      "sent": "Sent / Audience"
    },
    "create_modal": {
      "assign_to": "Assign conversations to",
      "assign_to_placeholder": "Select agent (optional)",
      "set_conversation_open": "Set conversation to open",
      "success": "Campaign created successfully",
      "error": "Failed to create campaign. Please try again.",
      "file_too_large": "File is too large. Max size: {{maxSize}}",
      "csv_empty": "CSV file is empty",
      "csv_missing_headers": "CSV file missing required headers: {{headers}}",
      "csv_invalid_phones": "CSV file contains invalid phone numbers: {{phones}}",
      "csv_missing_params": "CSV file missing template parameter columns: {{params}}"
    }
  },
  "tuvis_contacts_page": {
    "title": "Tuvis Contacts",
    "name": "Name",
    "phoneNumber": "Phone Number",
    "update_contact": "Edit Contact",
    "create_contact": "New Contact",
    "delete_contact": "Delete Contact",
    "delete_contact_modal_message": "Are you sure you want to delete this Tuvis Contact?",
    "import_contacts_preview": "Preview",
    "import_contacts_csv_button": "Import CSV",
    "import_contacts_csv_template": "Download CSV Template",
    "required": "required",
    "import_button": "Import",
    "drop_csv": "Drop CSV file here or click to browse",
    "import_contacts_modal_text": "Create a CSV File: Ensure your CSV file includes the following columns:",
    "import_contacts_csv_invalid_format": "Invalid CSV format: {{header}}",
    "import_contacts_csv_success": "Import results: {{numOfNewContacts}} new Tuvis contacts added from the CSV file",
    "import_contacts_csv_failure": "Tuvis contacts failed to import {{error}}",
    "csv_errors": {
      "empty_file": "CSV file is empty",
      "missing_required_headers": "CSV file missing required headers: {{missingRequiredHeaders}}",
      "invalid_headers": "CSV file contain invalid headers: {{invalidHeaders}}",
      "invalid_phone": "CSV file contain rows with invalid phones: {{invalidPhones}}",
      "missing_name": "CSV file contain rows with missing name: {{missingName}}"
    },
    "assignedUser": "Assigned Users",
    "assignedUserId": "Assigned User IDs",
    "assignedUserPlaceholder": "Select Users",
    "create_contact_failure": "Failed to create Tuvis contact",
    "contacts": "Contacts",
    "delete_selected": "Delete Selected",
    "delete_selected_contacts": "Delete Selected Contacts",
    "delete_selected_contacts_modal_message": "Are you sure you want to delete {{count}} selected contacts? This action cannot be undone.",
    "bulk_delete_success": "Successfully deleted {{count}} contacts",
    "bulk_delete_failure": "Failed to delete selected contacts",
    "search_placeholder": "Search contacts",
    "download_csv": "Download CSV",
    "download_csv_failure": "Failed to download CSV",
    "createdAt": "Created Date"
  },
  "url_policies_page": {
    "title": "Desktop Policies",
    "name": "Name",
    "url": "URL",
    "type": "Type",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "update_policy": "Edit Policy",
    "create_policy": "New Policy",
    "delete_policy": "Delete Policy",
    "delete_policy_modal_message": "Are you sure you want to delete this URL policy?",
    "watermark": "Watermark",
    "action_ON": "ON",
    "action_OFF": "OFF",
    "protect_download": "Protect download",
    "password": "Password",
    "watermark_tooltip": "Adds user-identifying watermarks across the viewport to deter unauthorized sharing while enabling leak tracing",
    "protect_download_tooltip": "Every downloaded file will be zipped and protected by the given password.",
    "dlp": "DLP",
    "dlp_tooltip": "Monitor and apply DLP policies to content on this website",
    "surveillance": "Surveillance",
    "surveillance_tooltip": "Monitor content on this website against your surveillance rules and log matching incidents",
    "wizard": {
      "new_title": "New Policy",
      "edit_title": "Edit Policy",
      "back_to_list": "Back to Policies",
      "step_type": "Type",
      "step_configuration": "Configuration",
      "step_summary": "Summary",
      "select_type_heading": "Select Policy Type",
      "select_type_sub": "Choose the type of policy you want to create.",
      "configure_heading": "Configure Policy",
      "configure_sub": "Fill in the details, URLs, scope, and features.",
      "summary_heading": "Review policy",
      "summary_sub": "Confirm the details below before saving.",
      "type_applications_title": "Applications",
      "type_applications_desc": "Allow supported instant messaging applications inside Tuvis Desktop App.",
      "type_managed_title": "Managed URLs",
      "type_managed_desc": "Apply DLP rules and monitoring to predefined integrations by Tuvis.",
      "type_network_title": "Network",
      "type_network_desc": "Allow access for any external website or custom URL inside Tuvis Desktop App.",
      "next": "Next",
      "back": "Back",
      "submit_create": "Create policy",
      "submit_update": "Save changes",
      "managed_url_placeholder": "Select a managed site (e.g. Slack, ChatGPT)",
      "application_placeholder": "Select an application…",
      "application_whatsapp": "WhatsApp",
      "application_telegram": "Telegram",
      "application_tuvis": "Tuvis messages",
      "error_select_policy_type": "Select a policy type before continuing.",
      "error_complete_required_fields": "Complete all required fields before continuing.",
      "error_invalid_url": "Enter a valid URL (for example https://example.com).",
      "summary_empty_value": "None"
    }
  },
  "dlp_page": {
    "bulk_update": {
      "success": "Successfully updated {{numOfIncidents}} incidents",
      "failed": "Failed to update incidents"
    },
    "unassigned": "Unassigned",
    "is_group": "Is Group",
    "true": "True",
    "false": "False",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "final_action": "Final Action",
    "sent": "Sent",
    "blocked": "Blocked",
    "filters": {
      "title": "Filter Incidents",
      "show_incidents_related_to_me": "Show incidents related to me",
      "file_only_corrupted_or_encrypted": "Show incidents with file corrupted or encrypted",
      "hide_incidents_with_keyword_campaigns": "Hide incidents matching keywords"
    },
    "pii_categories": {
      "AuthToken": "Authentication token",
      "AwsCredentials": "Amazon Web Services (AWS) account access keys",
      "AzureAuthToken": "Microsoft Azure authentication token",
      "BasicAuthHeader": "HTTP Basic Authentication header",
      "EncryptionKey": "Encryption key",
      "GcpApiKey": "Google Cloud Platform (GCP) API key",
      "GcpCredentials": "Google Cloud Platform (GCP) service account credentials",
      "HttpCookie": "HTTP cookie",
      "JsonWebToken": "JSON Web Token (JWT)",
      "OauthClientSecret": "OAuth client secret",
      "Password": "Password",
      "SslCertificate": "SSL certificate",
      "StorageSignedPolicyDocument": "Cloud storage signed policy document",
      "StorageSignedUrl": "Cloud storage signed URL",
      "WeakPasswordHash": "Weak password hash",
      "XsrfToken": "Cross-Site Request Forgery (CSRF) token",
      "Age": "Age",
      "Email": "Email",
      "Date": "Date",
      "Organization": "Organization",
      "Person": "Person",
      "PhoneNumber": "PhoneNumber",
      "Address": "Address",
      "IPAddress": "IPAddress",
      "URL": "URL",
      "CreditCardNumber": "Credit Card Number",
      "SwiftCode": "SWIFT Code",
      "InternationalBankingAccountNumber": "International Banking Account Number (IBAN)",
      "ABARoutingNumber": "ABA Routing Number",
      "ARNationalIdentityNumber": "Argentina National Identity (DNI) Number",
      "ATIdentityCard": "Austria identity card",
      "ATTaxIdentificationNumber": "Austria tax identification number",
      "ATValueAddedTaxNumber": "Austria Value Added Tax (VAT) number",
      "AUBankAccountNumber": "Australia bank account number",
      "AUBusinessNumber": "Australian business number",
      "AUCompanyNumber": "Australia Company Number",
      "AUDriversLicenseNumber": "Australia driver's license",
      "AUMedicalAccountNumber": "Australia medical account number",
      "AUPassportNumber": "Australia passport number",
      "AUTaxFileNumber": "Australia tax file number",
      "AzureDocumentDBAuthKey": "Azure DocumentDB Auth Key",
      "AzureIaasDatabaseConnectionAndSQLString": "Azure IAAS Database Connection String and Azure SQL Connection String",
      "AzureIoTConnectionString": "Azure IoT Connection String",
      "AzurePublishSettingPassword": "Azure Publish Setting Password",
      "AzureRedisCacheString": "Azure Redis Cache Connection String",
      "AzureSAS": "Azure SAS",
      "AzureServiceBusString": "Azure Service Bus Connection String",
      "AzureStorageAccountGeneric": "Azure Storage Account Key (Generic)",
      "AzureStorageAccountKey": "Azure Storage Account Key",
      "BENationalNumber": "Belgium national number",
      "BENationalNumberV2": "Belgium national number V2",
      "BEValueAddedTaxNumber": "Belgium Value Added Tax (VAT) number",
      "BGUniformCivilNumber": "Bulgaria Uniform Civil Number",
      "BrcpfNumber": "Brazil CPF number",
      "BRLegalEntityNumber": "Brazil legal entity number (CNPJ)",
      "BRNationalIdrg": "Brazil National ID Card (RG)",
      "CABankAccountNumber": "Canada bank account number",
      "CADriversLicenseNumber": "Canada driver's license number",
      "CAHealthServiceNumber": "Canada health service number",
      "CAPassportNumber": "Canada passport number",
      "CAPersonalHealthIdentification": "Canada Personal Health Identification Number (PHIN)",
      "CASocialInsuranceNumber": "Canada social insurance number",
      "CHSocialSecurityNumber": "Chile social security number",
      "CLIdentityCardNumber": "Chile identity card number",
      "CNResidentIdentityCardNumber": "China Resident Identity Card (PRC) number",
      "CYIdentityCard": "Cyprus identity card",
      "CYTaxIdentificationNumber": "Cyprus tax identification number",
      "CZPersonalIdentityNumber": "Chzech Republic Personal Identity Number",
      "CZPersonalIdentityV2": "Chzech Republic Personal Identity Number V2",
      "DEDriversLicenseNumber": "German Driver's License Number",
      "DEIdentityCardNumber": "Germany Identity Card Number",
      "DEPassportNumber": "Germany passport number",
      "DETaxIdentificationNumber": "Germany Tax Identification Number",
      "DEValueAddedNumber": "Germany Value Added Tax Number",
      "DKPersonalIdentificationNumber": "Denmark Personal Identification Number",
      "DKPersonalIdentificationV2": "Denmark Personal Identification Number V2",
      "DrugEnforcementAgencyNumber": "U.S. Drug Enforcement Agency (DEA) Number",
      "EEPersonalIdentificationCode": "EEPersonalIdentificationCode",
      "Esdni": "Spain DNI",
      "PeruDni": "Peru DNI",
      "ESSocialSecurityNumber": "Spain Social Security Number (SSN)",
      "ESTaxIdentificationNumber": "Spain Tax Identification Number",
      "EUDebitCardNumber": "EU debit card number",
      "EUDriversLicenseNumber": "EU driver's license number",
      "EugpsCoordinates": "EU GPS coordinates",
      "EUNationalIdentificationNumber": "EU national identification number",
      "EUPassportNumber": "EU passport number",
      "EUSocialSecurityNumber": "EU Social Security Number (SSN) or equivalent ID",
      "EUTaxIdentificationNumber": "EU Tax Identification Number (TIN)",
      "FIEuropeanHealthNumber": "Finland European Health Number",
      "FINationalID": "Finland national ID card",
      "FINationalIDV2": "Finland national ID card V2",
      "FIPassportNumber": "Finland passport number",
      "FRDriversLicenseNumber": "France driver's license number",
      "FRHealthInsuranceNumber": "France health insurance number",
      "FRNationalID": "France national ID card (CNI)",
      "FRPassportNumber": "France passport number",
      "FRSocialSecurityNumber": "France Social Security Number (INSEE)",
      "FRTaxIdentificationNumber": "France tax identification number (Numéro SPI)",
      "FRValueAddedTaxNumber": "France Value Added Tax (VAT) number",
      "GRNationalIDCard": "Greek National ID Card",
      "GRNationalIDV2": "Greek National ID Card V2",
      "GRTaxIdentificationNumber": "Greek Tax Identification Number",
      "HKIdentityCardNumber": "Hong Kong Identity Card (HKID) Number",
      "HRIdentityCardNumber": "Croatia Identity Card Number",
      "HRNationalIDNumber": "Croatia National ID Number",
      "HRPersonalIdentificationNumber": "Croatia Personal Identification Number",
      "HRPersonalIdentificationOIBNumberV2": "Croatia Personal Identification Number (OIB) V2",
      "HUPersonalIdentificationNumber": "Hungary Personal Identification Number",
      "HUTaxIdentificationNumber": "Hungary Tax identification Number",
      "HUValueAddedNumber": "Hungary Value Added Tax Number",
      "IDIdentityCardNumber": "Indonesia Identity Card (KTP) Number",
      "IEPersonalPublicServiceNumber": "Ireland Personal Public Service (PPS) Number",
      "IEPersonalPublicServiceNumberV2": "Ireland Personal Public Service (PPS) Number v2",
      "ILBankAccountNumber": "Israel Bank Account Number",
      "ILNationalID": "Israel National ID",
      "INPermanentAccount": "India Permanent Account Number (PAN)",
      "INUniqueIdentificationNumber": "India Unique Identification (Aadhaar) Number",
      "ITDriversLicenseNumber": "Italy Driver's License ID",
      "ITFiscalCode": "Italy Fiscal Code",
      "ITValueAddedTaxNumber": "Italy Value Added Tax Number",
      "JPBankAccountNumber": "Japan Bank Account Number",
      "JPDriversLicenseNumber": "Japan Driver's License Number",
      "JPMyNumberCorporate": "Japan \"My Number\" (Corporate)",
      "JPMyNumberPersonal": "Japan \"My Number\" (Personal)",
      "JPPassportNumber": "Japan Passport Number",
      "JPResidenceCardNumber": "Japan Residence Card Number",
      "JPResidentRegistrationNumber": "Japan Resident Registration Number",
      "JPSocialInsuranceNumber": "Japan Social Insurance Number (SIN)",
      "KRResidentRegistrationNumber": "South Korea Resident Registration Number",
      "LTPersonalCode": "Lituanian Personal Code",
      "LUNationalIdentificationNumberNatural": "Luxembourg National Identification Number (Natural persons)",
      "LUNationalIdentificationNumberNonNatural": "Luxembourg National Identification Number (Non-natural persons)",
      "LVPersonalCode": "Latvian Personal Code",
      "MTIdentityCardNumber": "Malta Identity Card Number",
      "MTTaxIDNumber": "Malta Tax Identification Number",
      "MYIdentityCardNumber": "Malaysia Identity Card Number",
      "NLCitizensServiceNumber": "Netherlands Citizens Service Number",
      "NLCitizensServiceNumberV2": "Netherlands Citizens Service Number V2",
      "NLTaxIdentificationNumber": "Netherlands Tax Identification Number",
      "NLValueAddedTaxNumber": "Netherlands Value Added Tax Number",
      "NOIdentityNumber": "Norway Identity Number",
      "NZBankAccountNumber": "New Zealand Bank Account Number",
      "NZDriversLicenseNumber": "New Zealand Driver's License Number",
      "NZInlandRevenueNumber": "New Zealand Inland Revenue Number",
      "NZMinistryOfHealthNumber": "New Zealand Ministry of Health Number",
      "NZSocialWelfareNumber": "New Zealand Social Welfare Number",
      "PHUnifiedMultiPurposeIDNumber": "Philippines Unified Multi-Purpose ID Number",
      "PLIdentityCard": "Poland Identity Card",
      "PLNationalID": "Poland National ID",
      "PLNationalIDV2": "Poland National ID V2",
      "PLPassportNumber": "Poland Passport Number",
      "PlregonNumber": "Poland REGON Number",
      "PLTaxIdentificationNumber": "Poland Tax Identification Number",
      "PTCitizenCardNumber": "Portugal Citizen Card Number",
      "PTCitizenCardNumberV2": "Portugal Citizen Card Number V2",
      "PTTaxIdentificationNumber": "Portugal Tax Identification Number",
      "ROPersonalNumericalCode": "Romania Personal Numerical Code (CNP)",
      "RUPassportNumberDomestic": "RUPassportNumberDomestic",
      "RUPassportNumberInternational": "RUPassportNumberInternational",
      "SANationalID": "South Africa National ID",
      "SENationalID": "Sweden National ID",
      "SENationalIDV2": "Sweden National ID V2",
      "SEPassportNumber": "Sweden Passport Number",
      "SETaxIdentificationNumber": "Sweden Tax Identification Number",
      "SGNationalRegistrationIdentityCardNumber": "Singapore National Registration Identity Card Number",
      "SITaxIdentificationNumber": "Slowenia Tax Identification Number",
      "SIUniqueMasterCitizenNumber": "Slowenia Unique Master Citizen Number",
      "SKPersonalNumber": "Slowakia Personal Number",
      "SQLServerConnectionString": "SQL Server Connection String",
      "THPopulationIdentificationCode": "Thailand Population Identification Code",
      "TRNationalIdentificationNumber": "Turkey National Identification Number",
      "TWNationalID": "Taiwan National ID",
      "TWPassportNumber": "Taiwan Passport Number",
      "TWResidentCertificate": "Taiwan Resident Certificate (ARC/TARC)",
      "UAPassportNumberDomestic": "Ukraine Passport Number (Domestic)",
      "UAPassportNumberInternational": "Ukraine Passport Number (International)",
      "UKDriversLicenseNumber": "U.K. Driver's License Number",
      "UKElectoralRollNumber": "U.K. Electoral Roll Number",
      "UKNationalHealthNumber": "U.K. National Health Service (NHS) Number",
      "UKNationalInsuranceNumber": "U.K. National Insurance Number (NINO)",
      "UKUniqueTaxpayerNumber": "U.K. Unique Taxpayer Reference Number",
      "USBankAccountNumber": "U.S. Bank Account Number",
      "USDriversLicenseNumber": "U.S. Driver's License Number",
      "USIndividualTaxpayerIdentification": "U.S. Individual Taxpayer Identification Number (ITIN)",
      "USSocialSecurityNumber": "U.S. Social Security Number (SSN)",
      "UsukPassportNumber": "U.S. or U.K. Passport Number",
      "ZAIdentificationNumber": "South Africa Identification Number"
    },
    "search_placeholder": "Search...",
    "title": "Data Loss Protection",
    "include": "Include",
    "exclude": "Exclude",
    "policy_name": "Policy name",
    "export_yes": "Yes",
    "export_no": "No",
    "export_rule_id": "Rule ID",
    "export_expressions": "Expressions",
    "export_pii": "PII Categories",
    "export_metadata": "Metadata",
    "export_create_incident": "Create Incident",
    "export_scope": "Scope",
    "export_message_type": "Message Type",
    "export_file_conditions": "File Conditions",
    "export_rules": "Rules",
    "rule_name": "Rule name",
    "priority": "Priority",
    "severity": "Severity",
    "file_warning": "File Warning",
    "create_an_incident": "Create an incident",
    "incident_severity": "Incident Severity",
    "should_attach_msg_content": "Attach message content or/and file",
    "custom_alert_message": "Custom Alert Message",
    "custom_alert_message_placeholder": "Enter a custom message to display when this policy blocks a message",
    "description": "Description",
    "comment": "Comment",
    "action": "Action",
    "action_taken": "Action Taken",
    "update_incident_status": "Incident Status",
    "update_incident_status_desc": "Please explain why this incident is {{ status }}:",
    "low": "Low",
    "medium": "Medium",
    "high": "High",
    "critical": "Critical",
    "resolved": "Resolved",
    "dismissed": "Dismissed",
    "new": "New",
    "content": "Message",
    "assignee": "Assignee",
    "created_by": "Created by",
    "sender": "Sender",
    "senderEmail": "Sender Email",
    "senderLogin": "Sender Username",
    "senderPhone": "Sender Phone Number",
    "recipient": "Recipient",
    "status": "Status",
    "createdAt": "Incident Created At",
    "messageSentAt": "Message Sent At",
    "recipientPhone": "Recipient Phone Number",
    "attachment": "Attachments",
    "file_corrupted_or_encrypted": "File corrupted or encrypted",
    "matched_expressions": "Matched Expressions",
    "unique_matches_identified": "Unique Matches Identified",
    "fileName": "File Name",
    "fileSize": "File Size",
    "fileType": "File Type",
    "enabled": "Enabled",
    "action_ALLOW": "Allow",
    "action_BLOCK": "Block",
    "delete_rule": "Delete Rule",
    "delete_rule_modal_message": "Are you sure you want to delete this DLP rule?",
    "rule_in_use": "Rule in use",
    "rule_in_use_description": "This rule is currently in use by {{policies}} policies and cannot be deleted.",
    "update_rule": "Edit Rule",
    "create_rule": "New Rule",
    "delete_policy": "Delete Policy",
    "delete_policy_modal_message": "Are you sure you want to delete this DLP policy?",
    "update_policy": "Edit Policy",
    "create_policy": "New Policy",
    "catch_all_policy_description": "Catch all",
    "search_policies": "Search policies",
    "no_policies_found": "No policies found",
    "search_rules": "Search rules",
    "no_rules_found": "No rules found",
    "subscriptions": "Notification recipients, delimited by \",\"",
    "notify_by_email_when_policy_is_triggered": "Notify by email when policy is triggered",
    "email_attachment_size_limit_tooltip": "Attachment limit by e-mail: 5MB.",
    "tabs": {
      "policies": "Policies",
      "rules": "Rules"
    },
    "incidents": "Incidents",
    "conditions": {
      "title": "Conditions",
      "expressions": "Expression",
      "user": "User",
      "user_description": "User == {{user}}",
      "user_all": "All Users",
      "group": "Group",
      "group_description": "Group == {{group}}",
      "mime_type": "File Type",
      "mime_type_description": "File Type == {{mimeType}}",
      "file_size": "File Size",
      "file_size_description": "File Size {{operator}} {{size}}",
      "file_size_placeholder": "Size in Bytes",
      "template": "Message Templates",
      "template_description": "Message templates created from Tuvis",
      "devtools": "DevTools Access",
      "devtools_description": "Developer tools access attempt",
      "and_between_conditions": "AND",
      "direction_all": "All messages",
      "direction_OUTBOUND": "Send Message ⇨",
      "direction_OUTBOUND_description": "Sent message {{msgType}}",
      "direction_INBOUND": "Received Text ⇦",
      "direction_INBOUND_description": "Received message text",
      "direction_DOWNLOAD": "Download attachment ⇩",
      "direction_DOWNLOAD_description": "Downloaded  attachment",
      "direction_UPLOAD": "Upload attachment ⇧",
      "direction_UPLOAD_description": "Upload  attachment",
      "PII": "PII Category",
      "rule": "DLP Rule",
      "image_unappropriate": "Image Inappropriate",
      "has_expression": "Contains Expression",
      "import_expression_csv": "Import Expressions",
      "expression": "Expression",
      "expression_casesensitive": "Case Sensitive",
      "pii_category": "PII Category",
      "max_occurrences": "Max Occurrences",
      "count_unique_values_only": "Count unique values only",
      "metadata": "Metadata",
      "metadata_key": "Metadata Key",
      "metadata_value": "Value",
      "delete_expression": "Delete",
      "test_condition": "Test",
      "or_between_expression": "OR",
      "description": "Description",
      "invalid_expression": "Invalid Expression",
      "internal_users": "Internal Users",
      "internal_users_description": "{{include}} Internal Users"
    },
    "operators": {
      "gt": "greater than (>)",
      "lt": "less than (<)",
      "gte": "greater or equal (≥)",
      "lte": "less or equal (≤)"
    },
    "outbound_message_types": {
      "text": "Text",
      "event": "Event",
      "order": "Order",
      "poll": "Poll",
      "contact": "Contact"
    },
    "builder": {
      "create_title": "Create DLP Policy",
      "edit_title": "Edit DLP Policy",
      "cancel": "Cancel",
      "save_policy": "Save Policy",
      "load_failed": "Failed to load this policy.",
      "aria_clear": "Clear {{label}}",
      "aria_open": "Open {{label}}",
      "steps": {
        "details": {
          "title": "Policy Details",
          "description": "Define the basic information, action, notifications, and incident behavior for this policy."
        },
        "scope": {
          "title": "Scope",
          "description": "Choose who this policy applies to."
        },
        "conditions": {
          "title": "Conditions",
          "description": "Define when this policy should trigger."
        },
        "summary": {
          "title": "Policy Summary",
          "description": "Review the resulting policy before saving."
        }
      },
      "scope": {
        "senderScopeLabel": "Sender scope",
        "contactScopeLabel": "Contact scope",
        "allUsers": {
          "title": "All Users",
          "description": "Apply this policy to everyone in the organization."
        },
        "specificUsers": {
          "title": "Specific Users",
          "description": "Apply this policy to selected users only.",
          "selector": "Select users"
        },
        "specificGroups": {
          "title": "User Groups",
          "description": "Apply this policy to selected groups only.",
          "selector": "Select groups"
        },
        "anyContact": {
          "title": "All Contacts",
          "description": "Apply this policy when talking to any contact."
        },
        "internalUsers": {
          "title": "Internal Users",
          "description": "Apply this policy when talking to internal (Tuvis) users."
        },
        "externalContacts": {
          "title": "External Contacts",
          "description": "Apply this policy when talking to external contacts."
        }
      },
      "message_type": {
        "title": "Message Type",
        "description": "Choose the main message direction this policy should inspect.",
        "outbound_selector": "Outbound message types"
      },
      "file_conditions": {
        "title": "File Conditions",
        "description": "Restrict the policy to specific file types or sizes when relevant."
      },
      "rules": {
        "title": "DLP Rules",
        "description": "Combine existing DLP rules. Rules inside one group are OR. Separate groups are AND.",
        "group_title": "Rule Group {{number}}",
        "group_help": "Selecting multiple rules in one group means OR logic inside that group.",
        "add_group": "Add Rule Group"
      },
      "advanced": {
        "title": "Other Conditions",
        "description": "Apply this policy to additional message contexts, such as templates and DevTools activity."
      },
      "summary": {
        "untitled_policy": "Untitled policy",
        "policy_sentence": "This policy will {{action}} messages for {{scope}} when {{conditions}}.",
        "surveillance_policy_sentence": "This policy will monitor messages for {{scope}} when {{conditions}}.",
        "no_scope_selection": "No users selected yet",
        "no_conditions": "No conditions set - this policy applies to all messages.",
        "no_notifications": "No notification emails",
        "outbound_types": "Sent message types: {{types}}",
        "file_types": "File types: {{types}}",
        "file_size": "File size {{operator}} {{size}}"
      }
    },
    "rule_modal": {
      "steps": {
        "details": {
          "title": "Rule Details",
          "description": "Define the basic information for this rule."
        },
        "conditions": {
          "title": "Conditions",
          "description": "Choose and configure the checks this rule should run."
        }
      },
      "condition_types": {
        "add_label": "Add condition types",
        "empty": "Select a condition type to get started.",
        "has_expression": "Match text using regular expressions.",
        "PII": "Detect built-in personal or sensitive data categories.",
        "metadata": "Match messages using metadata key-value pairs.",
        "image_unappropriate": "Flag inappropriate images in shared content."
      }
    },
    "required": "Required",
    "rules_load_failed": "Failed to load rules"
  },
  "submit": "Submit",
  "download_tuvispace_page": {
    "description": "Download tuvis® and ensure the security, efficiency, and compliance of your communications.",
    "download_mac": "Download for MacOS ({{appleType}})",
    "download_windows": "Or download for Windows",
    "download_for": "Or download for",
    "already_installed": "tuvis® app installed? Jump into your workspace now!",
    "open_tuvispace": "Open tuvis®",
    "title": "tuvis®"
  },
  "sidecarNotifications": {
    "sidecar_disconnected": "Device disconnected",
    "sidecar_paired": "Device paired",
    "sidecar_invited": "Device invited",
    "sidecar_phone_mismatch": "Phone number mismatch",
    "title": "Notifications",
    "saveSettings": "Save settings",
    "subHeader": "Notify me about...",
    "recipients": "Recipients:",
    "recipients_text": "Add by typing email address or searching by name (Use “,” to add multiple members)",
    "saved_successfully": "Device notifications settings were successfully saved",
    "saved_failed": "Device notifications settings failed to save",
    "customInviteEmail": {
      "title": "Customize your email invitation",
      "description": "Customize the email invitation to your team. You can use the following variables in the email body. Variables marked with * are required.",
      "preview": "Preview Email",
      "dropzone": "Drop or select an HTML file",
      "variables": {
        "invite_link": "Invite Link",
        "inviter_name": "Inviter Name",
        "inviter_email": "Inviter Email",
        "channel_name": "Channel Name",
        "expected_phone": "Expected Phone"
      },
      "errors": {
        "invalid_html": "Invalid HTML",
        "missing_variables": "Your email is missing the following required variables: {{variables}}"
      }
    },
    "invite_email_first_connection_template": {
      "title": "Invite Email First Connection Template",
      "description": "Select an HTML file to use as the email template sent as the first connection invite email."
    },
    "invite_email_reconnection_template": {
      "title": "Invite Email Reconnection Template",
      "description": "Select an HTML file to use as the email template sent as the reconnection invite email."
    },
    "invite_email_first_connection_subject": {
      "title": "Invite Email First Connection Subject",
      "description": "Set the subject for the first time invite email."
    },
    "invite_email_reconnection_subject": {
      "title": "Invite Email Reconnection Subject",
      "description": "Set the subject for the reconnection invite email."
    },
    "remove": "Remove",
    "select_file": "Select File",
    "default_support_email": {
      "title": "Default Remote Sync Support Email",
      "description": "If defined, this email will be used as the default support email for Remote Sync invitations instead of the inviter's email"
    },
    "orgConfigs": {
      "inviter_name": {
        "title": "Inviter name",
        "description": "Display name shown as the inviter in Remote Sync invitation emails. Leave empty to use the inviting user's name."
      }
    }
  },
  "sidecarCustomizations": {
    "title": "Customizations",
    "saveSettings": "Save settings",
    "saved_successfully": "Customizations were successfully saved",
    "saved_failed": "Customizations failed to save",
    "remote_sync_custom_error_text": {
      "title": "Custom sync error message",
      "description": "If set, this text is shown below the standard Remote Sync error (e.g. Sync Failed) so you can direct users to your compliance or support contact (e.g. email or extension)."
    }
  },
  "sf_email_domain": {
    "update_successfully": "Update successfully",
    "duplicate_domains_error": "Email domain already exists. Please use a different domain.",
    "update_failure": "Failed to update",
    "partial_success": "{{insertedCount}} domain(s) added successfully, {{duplicateCount}} duplicate(s) were skipped"
  },
  "users_management": {
    "user_messages": "View messages",
    "invite_to_remote_sync": "Invite to Tuvis Remote Sync",
    "invite_to_platform": "Invite to Tuvis Platform",
    "invite_to_platform_tooltip": "When enabled, users will receive an email invitation to join the platform",
    "invite_to_desktop_and_extensions": "Invite to Tuvis Desktop and Extensions applications",
    "invite_to_desktop_and_extensions_tooltip": "When enabled, users will receive an email invitation to join the Tuvis desktop app and browser extensions"
  },
  "actions_find_accounts": "Find Account",
  "actions_create_new": "Create New",
  "actions_create_button": "Create",
  "super_admin_org_configs": {
    "generate": "Generate",
    "last_updated_at": "Last updated at",
    "title": {
      "autoSyncCases": "Auto Sync Cases",
      "autoSyncActivities": "Auto Sync Activities",
      "entity": "Entity",
      "autoSync": "Auto Sync",
      "search": "Search",
      "layout": "Layout",
      "layoutLimits": "Layout Limits",
      "actions": "Actions",
      "apps": "Apps",
      "notifications": "Notifications",
      "security": "Security",
      "analytics": "Dashboard",
      "sidecars": "Remote Sync",
      "superAdmin": "Super Admin",
      "page_title": "Organization Settings",
      "general": "General Settings",
      "incidents_summary_email": "Incidents summary",
      "org_admin": "Org Admin",
      "orgAdminMessageSync": "Message Sync",
      "orgAdminRules": "Rules",
      "orgAdminUserManagement": "User Management",
      "tuvisAdminChannels": "Channels",
      "tuvisAdminFeatures": "Features",
      "tuvisAdminMessagesSync": "Messages Sync",
      "tuvisAdminSecurity": "Security"
    },
    "confirm_changes": "Are you sure you want to apply the following changes?",
    "reason_label": "Reason for changes",
    "reason_placeholder": "e.g., Testing feature for customer X, Performance improvement...",
    "who_requested_label": "Who requested",
    "who_requested_placeholder": "e.g., Customer name, Ticket ID...",
    "one_change_at_a_time_toast": "Only one setting can be changed at a time. Please revert other changes and try again.",
    "view_opportunity_link": "View opportunity",
    "view_opportunity_link_url": "#",
    "opportunity_link_label": "Opportunity link",
    "opportunity_link_placeholder": "Paste the Salesforce opportunity URL",
    "import_configuration": "Import Configuration",
    "importing_configuration": "Importing Configuration from {{ orgName }}",
    "import_configuration_failed": "Failed to import configuration",
    "import_configuration_success": "Configuration imported successfully, click 'Save' to apply changes",
    "conflicts_with": "Conflicts with",
    "conflict_banner": {
      "title": "Configuration Conflicts Detected",
      "description": "By enabling {{enabled}}, the following configs have been disabled:"
    },
    "configs": {
      "names": {
        "sf": "Salesforce",
        "msd": "Microsoft Dynamics",
        "allow_bot_builder": "Allow bot builder",
        "allow_elite_token": "Allow Elite Security Token",
        "allow_im_templates": "Allow IM Templates",
        "show_only_wap_channels_in_desktop": "Show only WhatsApp channels in desktop",
        "hide_meta_ai_button_in_desktop": "Hides the 'Meta AI' button from WhatsApp",
        "hide_wap_channels_button_in_desktop": "Hides the 'Channels' button from WhatsApp",
        "hide_delete_conversation_button": "Hides the 'Delete Conversation' button from WhatsApp",
        "hide_block_contact_button": "Hides the 'Block Contact' button from WhatsApp",
        "limit_date_range_of_messages": "Date range of history messages",
        "telegram_sidecars_enabled": "Telegram - Enable Remote Sync",
        "whatsapp_sidecars_enabled": "WhatsApp - Enable Remote Sync",
        "line_sidecars_enabled": "Line - Enable Remote Sync",
        "signal_sidecars_enabled": "Signal - Enable Remote Sync",
        "phones_blocked_from_sync": "Block specific phone numbers",
        "activeUsersCount": "Active users count (30 Days)",
        "available_crm": "Available CRM",
        "organizationName": "Organization name",
        "orgType": "Organization Type",
        "description": "Description",
        "allow_audio_transcribes": "Audio Transcription",
        "load_record_type_on_find_account": "Others - Load accounts related to a record type",
        "find_account_record_types": "Contacts - Search Accounts that are related to a Record Type",
        "hide_create_account_option_under_create_contact": "Contacts - Disable Create Account under Create Contact",
        "org_partner": "Organization partner",
        "isActive": "Is Organization Active",
        "paidLicences": "Desktop Licences - Purchased",
        "exceededLicences": "Desktop Licences - Allowed",
        "isPOC": "Is In POC Trial",
        "POCExpiration": "POC Trial Expiration Date",
        "leadsdisplay": "Leads - Display",
        "leadscreate": "Leads - Create",
        "contactscreate": "Contacts - Create",
        "contactsdisplay": "Contacts - Display",
        "casesdisplay": "Cases - Display",
        "activitiesdisplay": "Activities - Display",
        "hideleadprogresstopbar": "Leads - Hide Progress Top Bar",
        "enableautosynchidebutton": "Chat Sync - Hide button",
        "enableautosyncfiles": "Files - Enable Auto-Sync",
        "autosynclimittomaxfilesize": "Files - Sync max size",
        "activitiescreate": "Activities - Create",
        "hidesearchonmessenger": "Hide Search on Messenger",
        "tasksdisplay": "Tasks - Display",
        "appshidegooglemeet": "Hide Google Meet",
        "appshidemsteams": "Hide MS Teams",
        "taskscreate": "Tasks - Create",
        "casescreate": "Cases - Create",
        "hideopportunitytopbar": "Opportunities - Hide Progress Top Bar",
        "hidesearchongoogle": "Hide Search on Google",
        "hidesearchonlinkedin": "Hide Search on LinkedIn",
        "appshidedocusign": "Hide DocuSign",
        "enableautosyncalwayson": "Chat Sync - Always On",
        "appshideall": "Hide Apps Directory",
        "appshideallvideoapps": "Hide all video apps",
        "allowuserstograntsupportaccess": "Allow users to grant support access",
        "appshidezoom": "Hide Zoom",
        "serverlocation": "Server Location",
        "hideedittemplatesbuttons": "Dynamic Templates - Hide Edit",
        "hidenewtemplatebutton": "Dynamic Templates - Hide Create",
        "sendalertsuserloggedout": "Send Alerts - USER_LOGGED_OUT",
        "sendalertsuseruninstalledextension": "Send Alerts - USER_UNINSTALLED_EXTENSION",
        "sentalertsuserturnedautosyncoff": "Send Alerts - USER_TURNED_AUTO_SYNC_OFF",
        "sentalertsuserturnedautosyncon": "Sent Alerts - USER_TURNED_AUTO_SYNC_ON",
        "sentalertsapicurrentlydisabled": "Send Alerts - API_CURRENTLY_DISABLED",
        "sentalertsapexrestservicesdisabled": "Send Alerts - APEX_REST_SERVICES_DISABLED",
        "fileuploadshidecompletely": "File Uploads to CRM - Hide Option Completely",
        "hideaccountbox": "Contacts - Hide Account box",
        "hidetemplatesbutton": "Dynamic Templates - Hide",
        "multichannellimitchannels": "Multi Channels Limit",
        "hidenavigatetoaddress": "Hide Navigate to Location button",
        "hidesearchonfacebook": "Hide Search on Facebook",
        "hidecallbutton": "Hide Call button",
        "auto_sync_groups_default": "Groups - Auto-Sync Always On",
        "hide_whatsapp_filters": "Hide WhatsApp Filters",
        "block_unknown_person_per_role": "Block Unknown Person Per Role",
        "allow_inviting_users": "Allow Inviting Users",
        "show_chat_now_action": "Chat Now - Enable",
        "auto_sync_activities__enabled": "Auto Sync Activities - Enabled",
        "auto_sync_activities__show_run_now_button": "Auto Sync Activities - Show \"Run now\" button",
        "auto_sync_activities__task_completed_status": "Auto Sync Activities - Change Status",
        "auto_sync_activities__task_subject": "Auto Sync Activities - Task Subject",
        "auto_sync_cases_enabled": "Auto Sync Cases - Enabled",
        "auto_sync_cases_show_run_now_button": "Auto Sync Cases - Show \"Run now\" button",
        "auto_sync_cases_case_completed_status": "Auto Sync Cases - Change Completed Status",
        "auto_sync_cases_case_subject": "Auto Sync Cases - Case Subject",
        "auto_sync_cases_hide_message_content": "Auto Sync Cases - Hide Message Content",
        "auto_sync_cases_limit_to_profile": "Auto Sync Cases - Limit to Profile",
        "show_auto_sync_button_per_profile": "Show Auto Sync Button Per Profile",
        "show_edit_layout_per_profile": "Show Edit Layout Per Profile",
        "show_email_attachment": "Email Attachment",
        "taskshideuserassignmentfield": "Tasks - Hide User Assigned",
        "activitieshideuserassignmentfield": "Activities - Hide User Assigned",
        "multiple_records_extra_fields": "Others - Extra fields for records",
        "show_chat_summarize_action": "Summarize with VIS",
        "enable_widget_ai_assistant": "VIS AI Assistant",
        "create_case_opportunity_field_name": "Cases -  Related Opportunity",
        "allow_edit_layout_drag_and_drop": "Allow edit layout drag and drop",
        "show_admin_notifications_tab": "Admin Notifications Tab",
        "disable_save_as_at_desktop": "Restrict File Downloads",
        "allow_desktop_lite": "Desktop Lite",
        "allow_mobile_call_recording": "Allow mobile call recordings",
        "block_whatsapp_calls": "WhatsApp - Block Calls on Android",
        "delete_crm_session_on_logout_in_desktop": "Others - Delete CRM Session On Logout In Desktop",
        "layout_limits_case": "Layout Limits - Case",
        "layout_limits_lead": "Layout Limits - Lead",
        "layout_limits_contact": "Layout Limits - Contact",
        "layout_limits_task": "Layout Limits - Task",
        "layout_limits_activity": "Layout Limits - Activity",
        "layout_limits_account": "Layout Limits - Account",
        "layout_limits_person_account": "Layout Limits - Person Account",
        "layout_limits_event": "Layout Limits - Event",
        "layout_limits_opportunity": "Layout Limits - Opportunity",
        "layout_limits__new_activity": "Layout Limits - New Activity",
        "layout_limits__new_case": "Layout Limits - New Case",
        "set_whatid__accountid__new_task_and_activity": "Others - Set AccountId as WhatId",
        "allow_platform_integrations": "Integrations",
        "layout_limits__new_event": "Layout Limits - New Event",
        "layoutlimitsnewopportunity": "Layout Limits - New Opportunity",
        "layout_limits__new_person_account": "Layout Limits - New Person Account",
        "opps__display__per_profile": "Opps - Display - Per Profile",
        "enable_auto_sync__always_on__per_profile": "Enable Auto-Sync - Always On - Per Profile",
        "contacts__create__per_profile": "Contacts - Create - Per Profile",
        "enable_groups_auto_sync__always_on__per_profile": "Enable Groups Auto-Sync - Always On - Per Profile",
        "leads__display__per_profile": "Leads - Display - Per Profile",
        "leads__create__per_profile": "Leads - Create - Per Profile",
        "contacts__display__per_profile": "Contacts - Display - Per Profile",
        "activities__display__per_profile": "Activities - Display - Per Profile",
        "activities__create__per_profile": "Activities - Create - Per Profile",
        "create_person_account__per_profile": "Create Person Account - Per Profile",
        "tasks__display__per_profile": "Tasks - Display - Per Profile",
        "tasks__create__per_profile": "Tasks - Create - Per Profile",
        "cases__create__per_profile": "Cases - Create - Per Profile",
        "cases__display__per_profile": "Cases - Display - Per Profile",
        "show_person_account__per_profile": "Show Person Account - Per Profile",
        "auto_sync_files__allow_message_types": "Files - Sync by Message Types",
        "auto_sync_files__allow_media_mime_types": "Files - Sync by Mime Types",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "Files - Do not sync if not pass validation",
        "use_new_message_sync_code": "Use New Message Sync Code",
        "ignore_chat_now_logic": "Chat Now - Ignore prefix auto-complete",
        "auto_sync_message_updates": "Sync message updates",
        "auto_sync_message_on_status_change": "Sync message on status change",
        "default_notifications_over_due_only": "WhatsApp Tasks - Over Due Only",
        "prefix_phone_number_to_remove": "Others - Remove Prefix Phone Number",
        "chat_now_modal_no_contact": "Chat Now - Modal for unknown contact",
        "allow_platform_settings": "Allow Platform Settings",
        "allow_create_support_case": "Allow Create Support Case",
        "blur_contact_on_block_unknown_person": "Blur on Block Unknown Person",
        "allow_platform_global_layout": "Global Layout",
        "allow_platform_admin_notifications": "Admin Notifications",
        "show_chat_now_action_per_profile": "Show Chat Now Action Per Profile",
        "show_add_to_phone_action_per_profile": "Show Add To Phone Action Per Profile",
        "show_new_event_action_per_profile": "Show New Event Action Per Profile",
        "show_calendar_per_profile": "Show Calendar Per Profile",
        "extra_search_account_name_field": "Contacts - Search Account by extra field",
        "auto_sync_activities__limit_to_profile": "Auto Sync Activities - Limit to Profile",
        "allow_link_unknown_person": "Contacts - Allow Link Unknown Person",
        "access_audit_log": "Audit logs",
        "auto_sync_activities__hide_message_content": "Auto Sync Activities - Hide Message Content",
        "force_saml_login": "Force SAML Login",
        "elite_security_token__user_agent_header": "Elite Security Token - User Agent Header",
        "layoutlimitsnewtask": "Layout Limits - New Task",
        "layoutlimitsnewaccount": "Layout Limits - New Account",
        "layoutlimitsnewcontact": "Layout Limits - New Contact",
        "layoutlimitsnewlead": "Layout Limits - New Lead",
        "hidesaveasmobilecontact": "Hide Save as Mobile Contact button",
        "appshidemsoutlook": "Hide MS Outlook",
        "showselectivechatsync": "Chat Sync - Show Selective option",
        "sendalertsnewusercreated": "Send Alerts - NEW_USER_CREATED",
        "hidesendemail": "Hide Send Email button",
        "hidescheduleeventsaction": "Hide Schedule Event button",
        "hidecalendar": "Hide Calendar",
        "sendalertsuserloggedin": "Send Alerts - USER_LOGGED_IN",
        "hideglobalsearch": "Hide Global Search",
        "hidecrmlinks": "Others - Hide CRM Links",
        "oppsdisplay": "Opportunities - Display",
        "showwhatsllytask": "WhatsApp Tasks - Create",
        "showwhatsllytasksicon": "WhatsApp Tasks - Show menu icon",
        "showblurmode": "Blur all messages",
        "ignoreaddleadsourcecreatecontact": "Contacts - Ignore \"Add LeadSource\"",
        "ignoreaddleadsourcecreatelead": "Leads - Ignore \"Add LeadSource\"",
        "trackanalytics": "Dashboards - Allow Track Analytics",
        "track_filter_analytics": "Dashboards - Filter Analytics",
        "contactoppsdisplay": "Contacts - Display Contacts Opps",
        "hide_create_business_account": "Business Accounts - Hide Create",
        "search_business_account__name_field": "Business Accounts - Search",
        "status_bar__allow_change_opp_stage": "Opportunities - Allow Change Stage in Statusbar",
        "hide_mark_task_as_completed": "Tasks - Hide Mark As Completed",
        "new_lead__phone_field": "Leads - Override Phone Field",
        "new_contact__phone_field": "Contacts - Override Phone Field",
        "allow_to_sync_group": "Groups - Allow to sync group",
        "sent_alerts__user_turned_group_auto_sync_on": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_ON",
        "sent_alerts__user_turned_group_auto_sync_off": "Sent Alerts - USER_TURNED_GROUP_AUTO_SYNC_OFF",
        "new_lead__phone_field_prefix": "Leads - Create with custom phone prefix",
        "new_contact__phone_field_prefix": "Contacts - Create with custom phone prefix",
        "block_browser_extension": "Block Browser Extension",
        "elite_security_token": "Elite Security Token",
        "show_favorite_templates": "Dynamic Templates - Select Favorite",
        "block_unknown_person": "Block Unknown Person",
        "block_groups_with_unknown_contacts": "Block Groups With Unknown Contacts",
        "enable_dependent_picklist": "Enable Dependent Picklist",
        "disable_generate_reminder_params": "Others - Disable activity/task date and reminder date",
        "allow_only_invited_users": "Allow only invited users",
        "limit_sf_open_url": "Others - Block Non-Salesforce URLs",
        "limit_open_external_url": "External Link Restriction",
        "show_person_account": "Person Account - Display",
        "create_person_account": "Person Account - Create",
        "limit_login_via_sf_mobile_phone": "CRM/SSO phone validation",
        "block_change_profile_image": "Block Change Profile Image",
        "sidecars_enabled": "Remote Sync Enabled",
        "inviter_name": "Inviter Name",
        "max_sidecars": "Max amount of sidecar devices",
        "max_devices_whatsapp": "WhatsApp - Max Devices",
        "max_devices_telegram": "Telegram - Max Devices",
        "max_devices_line": "Line - Max Devices",
        "max_devices_signal": "Signal - Max Devices",
        "default_sidecar_frequency": "Remote Sync - Frequency",
        "show_analytics_ui": "Dashboards - Conversations",
        "show_dashboards_ui": "Custom View in Desktop",
        "show_custom_filters_ui": "Show Custom Filters",
        "show_im_groups_ui": "WhatsApp Groups - Metadata",
        "use_sf_mega_describe": "Use SF Mega Describe",
        "custom_error_failed_to_query": "Others - Custom Error Failed To Query",
        "show_record_type_layout": "Others - Show Record Type Layout",
        "auto_sync_to_duplicate_records": "Sync to duplicate records",
        "multi_channel_limit_channels_per_profile": "Multi-Channel Limit Channels Per Profile",
        "block_unknown_person_per_profile": "Block Unknown Person Per Profile",
        "hide_all_create_actions_per_profile": "Hide All Create Actions Per Profile",
        "show_global_search_per_profile": "Show Global Search Per Profile",
        "enable_record_types_pick_list": "Others - Enable Record Types Pick List",
        "enable_create_entities_to_not_focused_contact": "Others - Create Tasks/Activities To Not Pre-Selected Record",
        "show_saml_settings": "SAML Settings",
        "filter_analytics_by_profile": "Dashboards - Filter Analytics By Profile",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Global Layout Per Profile",
        "return_selective_to_prev": "Chat Sync - Return from Selective to previous state",
        "business_account__create": "Business Accounts - Create",
        "disable_retroactive_synchronization": "Disable Retroactive synchronization",
        "syncronizeLastDays": "Synchronize messages within last days",
        "scroll_to_earliest_message": "Scroll to earliest message",
        "contact__allow_add_to_campaign_button": "Contact - Allow Add to Campaign Button",
        "disable_contact_require_account": "Contacts - Disable Mandatory Account",
        "edit_lead": "Leads - Edit",
        "edit_contact": "Contacts - Edit",
        "edit_task": "Tasks - Edit",
        "edit_activity": "Activities - Edit",
        "edit_case": "Cases - Edit",
        "edit_person_account": "Person Account - Edit",
        "edit_business_account": "Business Accounts - Edit",
        "edit_opportunity": "Opportunities - Edit",
        "show_create_account_under_create_contact": "Contacts - Create Contact with Account",
        "show_create_account_under_edit_contact": "Contacts - Show Create Account",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Notification Recipients",
        "enabledNotifications": "Enabled Notifications",
        "use_only_wap_special_link": "Chat Now - Use native WhatsApp link",
        "query_cache_ttl": "Cache Query results TTL",
        "allow_dlp": "DLP - Enable",
        "enable_surveillance": "Surveillance",
        "allow_dlp_ai": "DLP with AI",
        "dlp_audio": "DLP with Audio",
        "allow_waba": "WhatsApp Business API",
        "allow_messages_analytics": "Conversations in platform",
        "allow_twilio": "Call Recording - Enable",
        "allow_imessage": "iMessage",
        "allow_telegram": "Telegram - Enable Desktop",
        "new_agent_mode": "Agent Mode",
        "hide_widget_close_button": "Hide Close widget",
        "hide_forward_button": "Hide WhatsApp forward message button",
        "hide_bulk_messages": "Hide bulk messages button",
        "block_extension_sidebar_in_desktop": "CRM for login only",
        "defaultLanguage": "Default Language for new users",
        "allow_embedded_signup_with_partner": "WhatsApp Business API via Smarters",
        "hide_intro_video": "Hide Intro Video",
        "default_favorite_actions": "Default Favorite Actions",
        "use_apex_upload_files": "Others - Use SF Apex upload file",
        "periodicAutoSync": "Periodicly Sync all messages",
        "periodicAutoSyncInterval": "Periodicly sync all messages interval",
        "periodicGroupSync": "Groups - Periodicly sync all groups metadata",
        "periodicGroupSyncInterval": "Groups - Periodicly sync all groups metadata interval",
        "allow_customer_facing_settings": "Customer Facing Settings",
        "allow_public_api": "Public API Tuvis",
        "allow_url_policy": "Desktop Policies - Enable",
        "force_user_phone": "Platform phone validation",
        "desktop_add_paired_phone_on_login": "Add paired phone on login",
        "max_paired_phones_on_login": "Max paired phones",
        "replace_phone_on_limit_exceeded": "Replace phone on limit exceeded",
        "created_entities_title_prefix": "Others - Create Entities with Title Prefix",
        "enable_limit_number_of_contacts_engaged": "Enable a limit on contacts engaged per day",
        "limit_number_of_contacts_engaged": "Limit of engaged contacts per day",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Enable a limit of messages to unresponsive contact",
        "limit_number_of_msgs_to_unresponsive_contact": "Limit of messages to unresponsive contact",
        "show_default_auto_sync_config": "Show default auto sync config",
        "hide_logout": "Hide logout button",
        "hide_edit_user": "Hide edit user button in user menu",
        "desktopForceNewTab": "Desktop force new tab",
        "fraud_detection": "Fraud Detection - Enable",
        "fraud_detection_mode": "Fraud Detection Mode",
        "allow_keyword_insights": "Keyword Tracker",
        "allow_keyword_insights_report_message_content": "Keyword Tracker - Display message content",
        "allow_user_analytics": "Dashboards - User Analytics",
        "analytics_compliance": "Dashboards - Compliance",
        "enable_call_recording_disclaimer": "Call Recording - Disclaimer",
        "allow_phones_whitelist": "Phones Allow List",
        "allow_phones_blocklist": "Private phones numbers list",
        "allow_blocked_phones": "Block Phones (chat)",
        "allow_tuvis_contacts": "Tuvis Contacts",
        "custom_user_fields": "User profile custom fields",
        "collect_messages_group_participants": "Collect group participants phones",
        "disable_opportunities_default_layout_field_for_entities": "Others - Hide Related Opportunity",
        "dlp_show_false_positive_incidents": "DLP Incidents - Show false positive",
        "dlp_notify_email_on_false_positive": "DLP Incidents - Notify by email on false positive",
        "query_cache_ttl_per_user": "Query Cache TTL Per User",
        "allow_whatsapp_channels": "WhatsApp Channels - Sync messages",
        "sidecar_ebs_size_in_gb": "Remote Sync - Size total",
        "incidents_filter_matched_keyword_campaigns_default_value": "DLP -  Hide incidents matching keywords",
        "sidecar_ebs_size_in_gb_per_user": "Remote Sync - Size per user",
        "collect_whatsapp_status_messages": "WhatsApp - Collect status messages",
        "sync_whatsapp_voice_video": "WhatsApp - Voice/Video Sync",
        "enable_whatsapp_voice_video": "WhatsApp - Enable Calls on Desktop",
        "block_copy_paste": "Block Copy Paste in Tuvis App",
        "salesforce_use_browser": "Others - Open Salesforce authentication in default browser",
        "sidecar_snapshot_keep_count": "Remote Sync - Snapshots count",
        "sidecar_snapshot_ttl_days": "Remote Sync - Snapshots days",
        "sidecar_invite_from_address": "Remote Sync - Email address",
        "sidecar_invite_from_name": "Remote Sync - Invitation name",
        "remote_sync_custom_error_text": "Remote Sync custom error message",
        "restrict_to_direct_reports": "Restrict data scope to direct reports",
        "restrict_to_direct_reports_bypass_list": "Restrict to direct reports Bypass list",
        "view_only_own_messages": "View only own messages",
        "phishing_fraud_detection": "Fraud Detection - Phishing URLs",
        "enable_virustotal_scan_url": "Fraud Detection - VirusTotal",
        "enable_hybrid_analysis_scan_url": "Fraud Detection - Hybrid Analysis",
        "fraud_detection_create_incidents": "Create Fraud Detection Incidents",
        "fraud_detection_incident_email_recipients": "Fraud Detection Incident Email Recipients",
        "allow_slack_platform": "WhatsApp Business API with Slack",
        "allow_teams_platform": "WhatsApp Business API with MS Teams",
        "allow_archive": "Enable Archive",
        "allow_teams_archive": "Enable Teams Archive",
        "disable_internal_messages_sync": "Disable Internal Messages Sync",
        "analytics_filter_show_related_to_me": "Dashboards - Show only data related to me"
      },
      "options": {
        "default_sidecar_frequency": {
          "0 * * * *": "Every hour",
          "0 */3 * * *": "Every 3 hours",
          "0 */6 * * *": "Every 6 hours",
          "0 */12 * * *": "Every 12 hours",
          "permanent": "Permanent"
        },
        "default_favorite_actions": {
          "view": "View",
          "call": "Call",
          "meeting": "Meeting",
          "messenger": "Messenger",
          "email": "Email",
          "navigate": "Navigate",
          "refresh": "Refresh",
          "facebook": "Facebook",
          "linkedin": "Linkedin",
          "google": "Google",
          "find": "Find",
          "addToPhone": "Add to phone",
          "createCustomObject": "Create custom object",
          "createCase": "Create case",
          "createTask": "Create task",
          "createActivity": "Create activity",
          "createLead": "Create lead",
          "createContact": "Create contact",
          "createPersonAccount": "Create person account",
          "chatNow": "Chat now",
          "showChatSummarizeAction": "Show chat summarize action",
          "createBusinessAccount": "Create business account",
          "showAiChat": "Chat with VIS"
        },
        "showselectivechatsync": {
          "Hide": "Hide",
          "Enabled": "Enabled",
          "Disabled": "Disabled",
          "Enable_Without_Auto": "Enable without auto sync option"
        }
      },
      "help_text": {
        "multiple_records_extra_fields": "When the phone number matches with multiple Leads, Contacts or Person Accounts, specify the API_names of more fields to be displayed.",
        "show_only_wap_channels_in_desktop": "Hides all tabs except for WhatsApp Channels, and prevents the user from switching to other tabs",
        "periodicAutoSyncInterval": "Automatically sync all messages every X milliseconds (1000ms = 1 second). Default is 86400000ms (24 hours)",
        "periodicGroupSyncInterval": "Automatically sync all groups metadata every X milliseconds (1000ms = 1 second). Default is 3600000ms (1 hour)",
        "limit_date_range_of_messages": "Limit message history to the past X months. Users will only see messages within this timeframe",
        "phones_blocked_from_sync": "Phone numbers seperated by commas",
        "force_user_phone": "Restricts WhatsApp login based on the specific phone number defined in the Tuvis user management page.",
        "desktop_add_paired_phone_on_login": "Upon login, automatically saves the user's paired WhatsApp number to their User profile Phone field.",
        "max_paired_phones_on_login": "Maximum number of unique WhatsApp accounts a single user is permitted to pair.",
        "replace_phone_on_limit_exceeded": "Automatically replaces the oldest paired phone with the newest one once the device limit is exceeded.",
        "leadsdisplay": "Display default Lead object in the panel",
        "contactsdisplay": "Display default Contacts object in the panel",
        "casesdisplay": "Display default Case object in the panel",
        "activitiesdisplay": "Display default Activities object in the panel",
        "autosynclimittomaxfilesize": "Change maximum upload size for auto sync Note: Salesforce does not support more than 4.4mb",
        "tasksdisplay": "Display default Tasks object in the panel",
        "hidesearchongoogle": "Hide \"Search on Google\" action from panel",
        "hidesearchonlinkedin": "Hide \"Search on Linkedin\" action in panel",
        "fileuploadshidecompletely": "Hide upload file from create task/activity/case page",
        "hidesearchonfacebook": "Hide \"Search on Facebook\" action in panel",
        "hidecallbutton": "Hide Call button from Actions panel",
        "allow_inviting_users": "Show Users management page, allowing to send invites and give permissions and licences to users.",
        "show_chat_now_action": "Show Chat Now in the Actions panel",
        "use_only_wap_special_link": "When activated, the \"Chat now\" button will use native WhatsApp links to start the conversation, instead of automatically normalizing the number.",
        "auto_sync_activities__enabled": "Enable \"Auto Sync Activities\" in Salesforce",
        "auto_sync_activities__show_run_now_button": "Show \"Run now\" button in \"Auto Sync Activities\" tab",
        "auto_sync_activities__task_completed_status": "By default the task created with Auto-Sync Activities has the status \"Completed\". Define another status below:",
        "auto_sync_activities__task_subject": "Define the subject of activities automatically created by conversation synchronization. By default, we use \"Tuvis Chat\" to differentiate these activities from those created manually.",
        "show_chat_summarize_action": "Show Chat Summarize in the Actions panel",
        "enable_widget_ai_assistant": "Enable VIS AI Assistant action in the widget panel",
        "create_case_opportunity_field_name": "Add a select field \"Related Opportunity\" under create case page. Need to define the CRM API field name.",
        "allow_edit_layout_drag_and_drop": "Allow to change edit layout field order by drag and drop",
        "show_admin_notifications_tab": "Show admin notifications tab in Salesforce Tuvis Settings Salesforce tab",
        "allow_desktop_lite": "Enables a lightweight version of Tuvis Desktop for organizations that do not require CRM integrations or the side panel.",
        "delete_crm_session_on_logout_in_desktop": "If the flag is ON, all the CRM session is deleted on user logout. If the flag is OFF, all the CRM session will be shared between sessions",
        "layout_limits_case": "Change maximum number of fields for case",
        "layout_limits_lead": "Change maximum number of fields for lead",
        "layout_limits_contact": "Change maximum number of fields for contact",
        "layout_limits_task": "Change maximum number of fields for task",
        "layout_limits_activity": "Change maximum number of fields for activity",
        "layout_limits_account": "Change maximum number of fields for account",
        "layout_limits_person_account": "Change maximum number of fields for person account (Salesforce Only)",
        "layout_limits_event": "Change maximum number of fields for event",
        "layout_limits_opportunity": "Change maximum number of fields for opportunity",
        "layout_limits__new_activity": "Change maximum number of fields for new activity",
        "layout_limits__new_case": "Change maximum number of fields for new case",
        "set_whatid__accountid__new_task_and_activity": "When a task/activity is created, by default we allow to select an Opportunity and save it in the WhatId. With this flag we use the AccoundId for this WhatId fiel",
        "allow_platform_integrations": "Activates the platform Integrations page to view and manage connected services.",
        "layout_limits__new_event": "Change maximum number of fields for new event",
        "layoutlimitsnewopportunity": "Change maximum number of fields for new opportunity",
        "layout_limits__new_person_account": "Change maximum number of fields for new person account",
        "auto_sync_files__allow_message_types": "Only sync files that match specific media message type. If more than one, separate by ;\ne.g image;document\n\nTypes: sticker, video,  image, document",
        "auto_sync_files__allow_media_mime_types": "Only sync files that match specific media mime type. If more than one, separate by ;\n\ne.g audio/ogg;application/vnd.openxmlformats-officedocument.wordprocessingml.document;application/msword\n\nCommon mime types: https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types",
        "auto_sync_files__ignore_media_file_message_if_not_pass_validation": "Do not sync media messages if it fails to validate by Media mime type or Media message type",
        "ignore_chat_now_logic": "Usually, when you click on Chat now inside Widget or CRM, the phone prefix is auto-completed. If this flag is on, we attempt to open the chat with the phone number as is",
        "auto_sync_message_updates": "This will cause a message that has updates (edited or deleted) to sync the updates again",
        "auto_sync_message_on_status_change": "Auto sync new message if message status (sent, received, read) change",
        "default_notifications_over_due_only": "Change WhatsApp task notifications filter to show over due only",
        "prefix_phone_number_to_remove": "When creating Lead/Contact/Person Account in the CRM, define a phone prefix that must be removed from auto insert (e.g. remove country code 972, 55)",
        "default_favorite_actions": "Select the default favorite actions for quick shortcuts in the panel",
        "chat_now_modal_no_contact": "When searching for a number that was not found in the WhatsApp contact list, show Chat Now modal.",
        "allow_platform_settings": "Allow access to instance to platform settings page",
        "allow_create_support_case": "Allow Create Support Case In JIra",
        "blur_contact_on_block_unknown_person": "When Block Unknown Person is enabled, automatically also blurs the message preview on the contacts list.",
        "block_groups_with_unknown_contacts": "Prevents interaction with WhatsApp groups if no members are identified as existing records in the CRM.",
        "allow_platform_global_layout": "Allow instance to use global layout inside Tuvis Platform",
        "allow_platform_admin_notifications": "Enables system alerts and updates",
        "extra_search_account_name_field": "When creating a new Contact, display an extra information to Search Account dropdown. Need to define the field API name that you want to show.",
        "auto_sync_activities__limit_to_profile": "The automatic sync of activitivies will only be applied for specific profiles",
        "allow_link_unknown_person": "If the whatsapp is unknown it can be linked to contact or lead",
        "access_audit_log": "Enable Audit log page in Tuvis Platform.",
        "auto_sync_activities__hide_message_content": "Hide message content when creating Auto Sync Activities",
        "force_saml_login": "Decline any login method besides SAML",
        "elite_security_token__user_agent_header": "Add elite token to user agent",
        "new_lead__phone_field": "Override default Phone filed in new lead layout Format: Field API Name,Field Label (separated by comma) E.g. MobilePhone,Mobile Phone",
        "new_contact__phone_field": "When creatimg contact, the default is Phone. With this flag, you can save whatsapp in another field (eg: Mobile Phone)",
        "block_browser_extension": "Block Tuvis browser extension and allow only to use Tuvis via desktop app",
        "elite_security_token": "Generate a unique string with at least 25 characters  via https://1password.com/password-generator/ website (without special symbols)",
        "limit_login_via_sf_mobile_phone": "Restricts WhatsApp login based on the phone number stored in Salesforce (Mobile Phone field) or Active Directory (Phone attribute).",
        "sidecars_enabled": "Enable sync of messages in mobile apps.",
        "show_analytics_ui": "Show Conversation tab in the Tuvis platform Dashboard",
        "show_dashboards_ui": "Allow instance to show Custom View Dashboards (CRM reports and widgets) as homepage in Tuvis Desktop",
        "show_custom_filters_ui": "Allow instance to show Custom Filters (filter conversations by Salesforce report results) in the platform and desktop",
        "show_im_groups_ui": "Collects WhatsApp group information, such as members and invitation settings.",
        "show_record_type_layout": "Show the top dropdown when you create record.",
        "enable_record_types_pick_list": "Enable to get picklist options according to the selected record type. If false, the selection is disabled",
        "enable_create_entities_to_not_focused_contact": "When creating task/activity, the user must select a contact/lead/person account.",
        "show_saml_settings": "Activates the SSO settings page for managing SAML-based identity authentication.",
        "filter_analytics_by_profile": "Filter analytics data to users only from specific Salesforce profiles.",
        "show_chat_groups_ui": "Show Chat Groups UI",
        "global_layout_per_profile": "Allow to define global layout per profile",
        "return_selective_to_prev": "Return Chat sync state to the previous status if you choose the option \"Selective\" instead of \"Off.",
        "business_account__create": "Enable to create Business Account",
        "disable_retroactive_synchronization": "Synchronizate only messages that were sent after the user was created in Tuvis",
        "syncronizeLastDays": "Messages will be synced if they are within the last X days (max: 90 days)",
        "scroll_to_earliest_message": "Scroll back to load all desktop or browser extension messages in the last configured days.",
        "contact__allow_add_to_campaign_button": "Show \"Add to Campaign\" button under contact object - SF only",
        "disable_contact_require_account": "During Contact creation,the Account selection will not be mandatory.",
        "edit_lead": "Enable to edit Lead even without \"Create lead\" feature",
        "edit_contact": "Enable to edit Contact even without \"Create contact\" feature",
        "edit_task": "Enable to edit Task even without \"Create task\" feature",
        "edit_activity": "Enable to edit Activity even without \"Create activity\" feature",
        "edit_case": "Enable to edit Case even without \"Create case\" feature",
        "edit_person_account": "Enable to edit Person Account even without \"Create person account\" feature",
        "edit_business_account": "Enable to edit Business Account, even without \"Create business account\" feature",
        "edit_opportunity": "Enable to edit opportunity even without \"create opportunity\" feature",
        "show_create_account_under_edit_contact": "When editing Contact, enable to create account dropdown",
        "hideEditLayout": "Hide Edit Layout",
        "notificationRecipients": "Insert email addresses (comma separated)",
        "enabledNotifications": "Insert email addresses (comma separated)",
        "allow_dlp_ai": "Allow using AI for identifying Personal Identifiable Information and extracting attachment data using OCR",
        "dlp_audio": "Data Loss Protection policies can also be applied to audios sent via Desktop (requires integration).",
        "desktopForceNewTab": "In-app links will be forced to open as a new tab within Tuvis Desktop App",
        "enable_call_recording_disclaimer": "Play a call recording disclaimer when outgoing call is answered or when incoming call is dialed",
        "allow_tuvis_contacts": "Allow Tuvis Contacts as the client's CRM (SAML only)",
        "custom_user_fields": "Enables up to five custom text fields in the user profile section, by comma-separated values.",
        "collect_messages_group_participants": "If this is enabled, the group participant phones will be collected for every group message",
        "disable_opportunities_default_layout_field_for_entities": "Hide the \"Related Opportunity\" field under create task, activity and case pages. Select the entities that you want to disable the field for.",
        "dlp_show_false_positive_incidents": "The false positive DLP incidents will be shown in the incidents list",
        "dlp_notify_email_on_false_positive": "Send an email to the email addresses defined in the notification recipients field when a false positive DLP incident is created",
        "query_cache_ttl_per_user": "If this is enabled, the query cache will be enabled for the user",
        "allow_whatsapp_channels": "If this is enabled, the users will start to sync and run DLP on Whatsapp channels if sync and DLP are enabled",
        "new_agent_mode": "When enabled, users in this organization will use the agent and assignment queues in Tuvis Messaging.",
        "sidecar_ebs_size_in_gb": "The size of the EBS volume for the sidecar in GB",
        "incidents_filter_matched_keyword_campaigns_default_value": "If this is enabled, the DLP incidents matching keywords will be hidden by default",
        "sidecar_ebs_size_in_gb_per_user": "The size of the EBS volume for the sidecar in GB per user",
        "collect_whatsapp_status_messages": "Collect statuses published by the user",
        "sync_whatsapp_voice_video": "If enabled, WhatsApp voice and video messages will be synced via Desktop.",
        "enable_whatsapp_voice_video": "If enabled, WhatsApp voice and video calls will be available for 1-1 chats only (not in groups) via Desktop",
        "block_copy_paste": "When enabled, copy and paste will be blocked in the Tuvis app",
        "salesforce_use_browser": "If checked, Salesforce authentication will open in the user's default browser instead of within Tuvis desktop application. This setting has no effect on web with extension or mobile clients.",
        "sidecar_snapshot_keep_count": "The number of backup copies (snapshots) stored for each user's remote sync process.",
        "sidecar_snapshot_ttl_days": "The number of days a snapshot is kept before being automatically deleted",
        "remote_sync_custom_error_text": "If set, this text is shown below the standard Remote Sync error (e.g. Sync Failed) so you can direct users to your compliance or support contact (e.g. email or extension).",
        "restrict_to_direct_reports": "Limits the user's data visibility across the platform exclusively to their direct reports' information.",
        "restrict_to_direct_reports_bypass_list": "Defines users exempt from the direct reports data visibility restriction.",
        "view_only_own_messages": "Restricts users to viewing only their own message history within the platform.",
        "enable_hybrid_analysis_scan_url": "Scan URLs using Hybrid Analysis API for malware and phishing detection.",
        "fraud_detection_create_incidents": "When enabled, incidents are automatically created when malicious hashes or URLs are detected in messages.",
        "fraud_detection_incident_email_recipients": "Select users who should receive email alerts when a fraud detection incident is created.",
        "allow_slack_platform": "Enables the Tuvis app within Slack Channels, allowing the organization to link a WhatsApp API number for centralized communication via Slack.",
        "allow_teams_platform": "Enables the Tuvis app within Microsoft Teams, allowing the organization to link a WhatsApp API number for centralized communication via Teams.",
        "allow_archive": "Turn on to allow message archiving features",
        "allow_teams_archive": "Turn on to allow Teams archiving",
        "disable_internal_messages_sync": "Prevents the sync of messages sent between internal team members.",
        "track_filter_analytics": "Enable hourly tracking of WhatsApp filter usage (Unread, Awaiting Reply, Needs Reply) on desktop. Data is stored in the Users Conversations Status dashboard.",
        "activitiescreate": "Enable to create Activities",
        "activitieshideuserassignmentfield": "Hide field Activity Owner (assign to user)",
        "auto_sync_cases_case_subject": "Define the subject of Cases automatically created by conversation synchronization. By default, we use \"Tuvis Chat\" to differentiate these Cases from those created manually.",
        "auto_sync_cases_case_completed_status": "Change the default task status from completed to another custom status",
        "auto_sync_cases_enabled": "Enable Cases to be created automatically",
        "auto_sync_cases_hide_message_content": "Hide message content when creating Auto Sync Cases",
        "auto_sync_cases_limit_to_profile": "List of profile names that we only collect the messages for them e.g. System Admin;Demo User;Prr",
        "auto_sync_cases_show_run_now_button": "Show \"Run now\" button in \"Auto Sync Cases\" tab",
        "hide_create_business_account": "Disable the Create Business Account",
        "search_business_account__name_field": "Default search is Account name, other fields can be added below",
        "casescreate": "Enable to create Cases",
        "contactscreate": "Enable to create Contacts",
        "show_create_account_under_create_contact": "Show create account dropdown in create contact",
        "new_contact__phone_field_prefix": "By default, we copy the whatsapp number to create a New Contact in the CRM. With this flag, we can add a prefix (example: +)",
        "hide_create_account_option_under_create_contact": "When creating a new Contact, disable the Create Account",
        "contactoppsdisplay": "Display Contact Opportunities, besides standard Account Opportunities.",
        "hideaccountbox": "Hide the account card from view contact",
        "ignoreaddleadsourcecreatecontact": "By default LeadSource: \"WhatsApp Web\"i. With this flag we dont fill this field",
        "find_account_record_types": "When creating new Contact, the Account field will only load accounts that are also related to a specific record type, by Id or DeveloperName",
        "layoutlimitsnewaccount": "Change maximum number of fields for new account",
        "layoutlimitsnewcontact": "Change maximum number of fields for new contact",
        "layoutlimitsnewlead": "Change maximum number of fields for new lead",
        "layoutlimitsnewtask": "Change maximum number of fields for new task",
        "leadscreate": "Enable to create Leads",
        "new_lead__phone_field_prefix": "By default, we copy the whatsapp number to create a New Lead in the CRM. With this flag, we can add a prefix (example: +)",
        "hideleadprogresstopbar": "Hide Lead Progress Top Bar",
        "ignoreaddleadsourcecreatelead": "Ignore \"Add LeadSource\" when creating a Contact",
        "status_bar__allow_change_opp_stage": "Allow to change the status in the Opps",
        "oppsdisplay": "Display default Opportunity object in the panel",
        "hideopportunitytopbar": "Hide Opportunity Progress Top Bar",
        "limit_sf_open_url": "When using the Tuvis Desktop, any link that is not Salesforce will be restricted",
        "created_entities_title_prefix": "When any record is created, the title starts with [Tuvis]. The title prefix can be changed with this flag.",
        "disable_generate_reminder_params": "Do not add the fields ReminderDateTime and IsReminderSet",
        "load_record_type_on_find_account": "First the user chooses the Record type in the CRM Widget, and then Account search will only load the accounts according to that selection",
        "use_apex_upload_files": "When a task/activity/case is createdy, by default we use the official Salesforce attachment API . If enabled, we will use Tuvis Salesforce Apex.",
        "create_person_account": "Enable to create Person Account",
        "show_person_account": "Display default Person Account object in the panel",
        "taskscreate": "Enable to create Tasks",
        "hide_mark_task_as_completed": "Prevents users from marking the Task as Completed",
        "taskshideuserassignmentfield": "Hide field Task Owner (assign to user)",
        "auto_sync_to_duplicate_records": "Auto sync chat to all matching CRM records if a contact is associated with multiple entries.",
        "enableautosyncalwayson": "Ensures that the Auto Chat sync remains active by default and users cannot change it.",
        "enableautosynchidebutton": "Hide the buttons turn on and off for Chat sync.",
        "enableautosyncfiles": "Allows automatic synchronization of user files, including audios, documents and other medias.",
        "allow_to_sync_group": "Allows synchronization of group chats.",
        "auto_sync_groups_default": "Ensures that the auto-sync remains active by default for groups and users cannot change it.",
        "showselectivechatsync": "The user can manually choose which messages should be stored in the CRM.",
        "block_unknown_person": "Restricts users from messaging any contact that does not have a corresponding record in the CRM.",
        "block_unknown_person_per_role": "Restricts users with specific Salesforce roles from messaging any contact that does not have a corresponding record in the CRM.",
        "showblurmode": "Blurs all message content within the chat interface, revealing text only when the user hovers over the message.",
        "enable_limit_number_of_msgs_to_unresponsive_contact": "Enables a restriction on how many messages can be sent to a contact who has not replied.",
        "enable_limit_number_of_contacts_engaged": "Enable a cap on the number of unique contacts a user can engage with per day to prevent spamming.",
        "limit_open_external_url": "Prevents users from opening external URLs directly from Tuvis Desktop",
        "hideglobalsearch": "Removes the global search bar from the top panel to prevent users from searching for CRM contacts.",
        "allow_keyword_insights_report_message_content": "In the Keyword occurences, allow to show the original message in the details.",
        "limit_number_of_contacts_engaged": "Sets the maximum number of unique contacts a user can engage with every 24 hours.",
        "limit_number_of_msgs_to_unresponsive_contact": "Set the maximum number of outbound messages allowed to a contact before receiving a response.",
        "disable_save_as_at_desktop": "Disables the \"Save As\" option for files within the platform to prevent users from downloading them.",
        "allow_only_invited_users": "Users can only login in Tuvis after invitation. It must be set as TRUE if the same email domain is used for SSO in different orgs.",
        "block_extension_sidebar_in_desktop": "Uses CRM credentials only for authentication, but hides the CRM side panel from Tuvis Desktop application.",
        "hide_logout": "Removes the logout button from the user menu.",
        "allow_twilio": "Enable Call Recording in Tuvis mobile app and display the dashboard in platform.",
        "exceededLicences": "Sets the hard limit for users, which can either match the exact number of purchased licenses or include an overage margin.",
        "paidLicences": "Licences purchased by the organization. By default, we grant a 10% grace margin above the seat limit",
        "line_sidecars_enabled": "Enable Remote Sync for Line. Note: Line does not have Desktop.",
        "max_devices_line": "Licences of Remote Sync for Line.",
        "default_sidecar_frequency": "Frequency of sync",
        "signal_sidecars_enabled": "Enable Remote Sync for Signal mobile app. Note: Signal does not have Desktop.",
        "max_devices_signal": "Licences of Remote Sync for Signal.",
        "allow_telegram": "Enable Telegram on Tuvis Desktop",
        "telegram_sidecars_enabled": "Enable Remote Sync for Telegram mobile app",
        "max_devices_telegram": "Licences of Remote Sync for Telegram.",
        "whatsapp_sidecars_enabled": "Enable Remote Sync for WhatsApp mobile app",
        "max_devices_whatsapp": "Licences of Remote Sync for WhatsApp.",
        "allow_waba": "Allow WhasApp Business API integration",
        "allow_embedded_signup_with_partner": "Enable Embedded Signup when connecting an API WhatsApp number",
        "allow_audio_transcribes": "Requires Audio Transcribe integration (Amazon or Azure)",
        "allow_messages_analytics": "Show Conversation page in the main menu, to monitor synced Messages and Call recordings",
        "allow_customer_facing_settings": "Enables organization admins to manage specific platform configurations.",
        "trackanalytics": "Allow collecting data from conversations for the dashboards",
        "analytics_compliance": "Show Compliance tab in the Tuvis platform Dashboard.",
        "analytics_filter_show_related_to_me": "Disables the filter buttons in the dashboards and automatically selects only groups related to the selected user",
        "allow_user_analytics": "Show User Analytics tab in the Tuvis platform Dashboard",
        "allow_keyword_insights": "Enable Keyword Tracker and show Keyword Analytics tab in the platform Dashboard",
        "multichannellimitchannels": "Limit the max number of channels that can be connected by users",
        "periodicAutoSync": "Triggers a scheduled, comprehensive synchronization of all chat history for active users",
        "allow_phones_whitelist": "Enables a restricted monitoring mode where only conversations with specifically whitelisted phone numbers are synchronized.",
        "allow_phones_blocklist": "Exempts specific phone numbers from all platform tracking and synchronization to ensure user privacy.",
        "allow_blocked_phones": "Blocks the conversation in the extension for specific phone numbers, showing a blocked-contact overlay.",
        "allow_public_api": "Permits the organization to connect and exchange data with the Tuvis Public API.",
        "block_whatsapp_calls": "Prevents users from initiating or receiving WhatsApp calls on Android app.",
        "periodicGroupSync": "Enable to sync groups metadata.",
        "allow_dlp": "Shows the Data Loss Protection page for users with the respective permissions to create security monitoring policies.",
        "fraud_detection": "Enable Fraud Detection page in Tuvis Platform to identify phishing URLs and malicious hashes in attached files.",
        "enable_virustotal_scan_url": "Enable VirusTotal to scan Urls",
        "allow_url_policy": "Activate the Desktop Policies page on the Tuvis platform to configure features applicable to channels, managed sites, and other links."
      }
    },
    "show_changed_configs": "Show changed configs",
    "changes": "Changes",
    "nav": {
      "system_notifications": "System notifications",
      "api_keys": "API Keys",
      "sso_settings": "SSO Settings",
      "incidents_summary_email": "Incidents summary email",
      "elite_token": "Elite Security Token"
    }
  },
  "auto_sync": {
    "on": "On",
    "off": "Off",
    "inherent": "Global"
  },
  "user_page": {
    "remove_waba": "Are you sure you want to remove WhatsApp Business API phone number?",
    "remove_twilio": "Are you sure you want to remove Twilio phone number?",
    "assign_phone": "Assign phone number",
    "unassign_phone": "Unassign phone",
    "assign_sidecar": "Assign device",
    "unassign_sidecar": "Unassign device",
    "choose_phone": "Choose phone number",
    "enabled": "Enabled",
    "waba": "WhatsApp Business API (desktop app)"
  },
  "incidents_summary_email": {
    "title": "Incident summary email",
    "discription_text": "Configure who receives email summaries and which incidents each recipient is notified about.",
    "send_summary_to": "Send summary to",
    "which_incidents": "Which incidents?",
    "scope_all": "All platform incidents",
    "scope_user": "Specific user's incidents",
    "scope_manager": "Specific manager's incidents",
    "for": "for",
    "select_user": "Select user",
    "select_manager": "Select manager",
    "add_recipient": "Add recipient",
    "remove_row": "Remove recipient",
    "saved_successfully": "Incident summary email settings were successfully saved",
    "saved_failed": "Incident summary email failed to save",
    "validation_email_required": "Email is required for each recipient",
    "validation_reference_required": "Select a user or manager for this recipient",
    "loading": "Loading...",
    "saveSettings": "Save settings"
  },
  "incidents_page": {
    "change_assignee": "Change Assignee",
    "assignee": "Assignee",
    "change_status": "Change Status",
    "select_status": "Select Status",
    "matched_keyword_campaigns": "Matched Keyword Criteria"
  },
  "messages_analytics_page": {
    "title": "Conversations",
    "sent_date": "Sent Date",
    "type": "Type",
    "sender": "Sender",
    "receiver": "Receiver",
    "message": "Message",
    "attachment": "Attachment",
    "fileName": "File name",
    "fileType": "File type",
    "no_valid_integrations": "No valid integrations was found (S3, Azure, SFTP, GCP)",
    "no_messages": "No messages was found",
    "tabs": {
      "messages": "Messages",
      "calls": "Calls"
    },
    "edited": "Edited",
    "deleted": "Deleted",
    "message_history": "Message History"
  },
  "test_regex_modal": {
    "test_regex_modal_title": "Test Regex",
    "test_regex_settings": "Regex Settings",
    "test_regex_expression": "Expression",
    "text_to_test_placeholder": "Text To Test",
    "test_button": "Test",
    "not_case_sensitive": "Not Case Sensitive",
    "failed_to_test_regex": "Failed to test regex"
  },
  "test_pii_modal": {
    "test_pii_modal_title": "Test PII",
    "test_pii_settings": "PII Settings",
    "pii_category": "PII Category",
    "text_to_test_placeholder": "Text To Test",
    "test_button": "Test",
    "failed_to_test_pii": "Failed to test PII"
  },
  "test_rule_modal": {
    "failed_to_test": "Failed to test",
    "texts_to_test": "Texts To Test",
    "test_metadata_title": "Test Metadata",
    "upload_file_to_test_metadata": "Upload a file, then click Load to extract its metadata",
    "load": "Load",
    "test_metadata_phase": "Test the metadata condition against the extracted metadata above",
    "metadata_match": "Match",
    "metadata_no_match": "No match",
    "extracted_metadata": "Extracted metadata"
  },
  "account_admin": {
    "title": "Account Admin",
    "users_page": {
      "title": "Account Users",
      "add_button": "Add User",
      "from_user": "From organization user",
      "from_external": "From external user",
      "assign_permissions_modal": {
        "button": "Assign Permissions",
        "title": "Assign User Permissions",
        "description": "Assign organization permissions for <1>{{name}}</1>.",
        "select_user": "Select User",
        "search_users": "Search Users",
        "permissions_for_in": "Permissions for <1>{{name}}</1> in <1>{{orgName}}</1>",
        "indication": {
          "own_org": "{{name}} is part of this organization",
          "has_permission": "{{name}} can view this organization because he has at least one permission assigned"
        },
        "error_message": "Could not assign permissions to user",
        "no_instance_configs": "No instance configs found",
        "no_instance_configs_description": "No instance configs found for this organization. Please contact your administrator."
      },
      "account_admin_modal": {
        "assign_title": "Assign Account Admin",
        "assign_description": "Are you sure you want to assign <1>{{name}}</1> as Account Admin?",
        "assign_confirm": "Yes, assign",
        "remove_title": "Remove Account Admin",
        "remove_description": "Are you sure you want to remove <1>{{name}}</1> as Account Admin?",
        "remove_confirm": "Yes, remove",
        "error_message": "Could not change user admin status"
      },
      "cannot_change_own_admin": "You cannot change your own admin status",
      "is_account_admin": "Is Account Admin",
      "invite_external_user_success": "Invitation sent successfully",
      "invite_external_user_error": "Failed to send invitation"
    },
    "overview_page": {
      "title": "Account Overview",
      "account_name": "Account Name",
      "account_id": "Account ID"
    },
    "no_access_overlay": {
      "title": "No Account Selected",
      "text": "Please select an account from the dropdown above to view this page.",
      "button": "Go Back"
    },
    "account_orgs": {
      "title": "Account Organizations",
      "columns": {
        "registered_users": "Registered Users",
        "consumed_licences": "Consumed Licences"
      },
      "summary": {
        "purchased_licences": "Purchased Licences"
      },
      "assign_orgs_modal": {
        "title": "Assign Organizations",
        "description": "Select the organizations you want to assign to this account.",
        "trigger": "Assign Organizations",
        "success_message": "Organizations assigned to account",
        "error_message": "Could not assign organizations to account"
      },
      "remove_org_modal": {
        "title": "Remove Organization from Account",
        "description": "Are you sure you want to remove the organization from the account?",
        "success_message": "Organization removed from account",
        "error_message": "Could not remove organization from account",
        "trigger": "Unassign"
      },
      "view_org": "View Organization",
      "create_org": "Create Organization"
    }
  },
  "keyword_insights_occurrence": {
    "header": "Occurrence details"
  },
  "keyword_insights": {
    "title": "Keyword Tracker",
    "dashboard_page": {
      "title": "Keywords Analytics",
      "date_range": "Date Range",
      "kpis": {
        "active_agents": {
          "label": "Active Agents",
          "tooltip": "Total number of connected users"
        },
        "campaigns_created": {
          "label": "Criterias Created",
          "tooltip": "How many different # of criteria were created"
        },
        "campaigns_sent": {
          "label": "Criterias Sent",
          "tooltip": "How many different # of criterias were sent"
        },
        "reach": {
          "label": "Reach",
          "tooltip": "How many contacts received at least one of the criterias"
        },
        "impressions": {
          "label": "Total Impressions",
          "tooltip": "How many messages containing criterias were sent. Same person can receive multiple criterias or the same criteria more than once"
        },
        "avg_impressions_per_agent": {
          "label": "Avg Impressions Per Agent",
          "tooltip": "Total Impressions / Active Agents"
        },
        "avg_reach_per_agent": {
          "label": "Avg Reach Per Agent",
          "tooltip": "Reach / Active Agents"
        },
        "avg_reach_per_sent_campaign": {
          "label": "Avg Reach Per Criteria",
          "tooltip": "Reach / Criterias Sent"
        }
      },
      "charts": {
        "impressions": {
          "title": "Impressions Over Time",
          "legend": "Impressions"
        },
        "campaigns": {
          "title": "Criterias vs Criterias Sent",
          "legendCampaigns": "Criterias",
          "legendCampaignsSent": "Criterias Sent"
        },
        "period": "Last {{months}} months"
      },
      "export_kpis": "Export KPIs",
      "export_charts": "Export Charts"
    },
    "campaigns_page": {
      "title": "Criterias",
      "upsert_campaign_modal": {
        "create_trigger": "Create Criteria",
        "create_title": "Create Keyword Criteria",
        "create_loading_message": "Creating criteria...",
        "create_error_message": "Error! Could not create criteria",
        "create_success_message": "Criteria created",
        "update_trigger": "Update Criteria",
        "update_title": "Update Keyword Criteria",
        "update_loading_message": "Updating criteria...",
        "update_error_message": "Error! Could not update criteria",
        "update_success_message": "Criteria updated",
        "name": "Criteria Name",
        "description": "Description",
        "conditions": "Criteria Conditions",
        "conditions_description": "If any of the expressions below are met, the criteria will be triggered.",
        "add_condition_tooltip": "Add Condition",
        "delete_condition_tooltip": "Delete Condition"
      },
      "delete_campaign_modal": {
        "trigger": "Delete Criteria",
        "title": "Delete Criteria",
        "description": "Are you sure you want to delete this criteria?",
        "confirm": "Yes, delete",
        "success_message": "Criteria deleted",
        "error_message": "Could not delete criteria",
        "loading_message": "Deleting criteria..."
      },
      "cols": {
        "name": "Criteria Name",
        "description": "Description",
        "conditions": "Conditions",
        "created_at": "Created At",
        "updated_at": "Updated At"
      },
      "search_campaigns_placeholder": "Search criterias..."
    },
    "occurrences_page": {
      "title": "Occurrences",
      "date_range": "Record Created Date",
      "yes": "Yes",
      "no": "No",
      "cols": {
        "created_at": "Created At",
        "campaign_name": "Criteria Name",
        "campaign_id": "Criteria ID",
        "content": "Message",
        "matched_keywords": "Matched Keywords",
        "sender": "Sender",
        "sender_phone": "Sender Phone",
        "receiver": "Receiver",
        "recipient_phone": "Recipient Phone",
        "is_group": "Is Group"
      }
    }
  },
  "search_accounts": {
    "search_accounts": "Search Accounts",
    "create_new_account": "Create New Account",
    "create_new_account_success": "Successfully created an account: {{accountName}}",
    "create_new_account_error": "Could not create an account",
    "change_account_name": "Change Account Name",
    "change_account_name_success": "Successfully changed account name to: {{accountName}}",
    "change_account_name_error": "Could not change account name"
  },
  "surveillance_page": {
    "title": "Surveillance",
    "tabs": {
      "policies": "Policies",
      "rules": "Rules",
      "incidents": "Incidents"
    },
    "create_policy": "Create Policy",
    "create_rule": "Create Rule",
    "update_policy": "Edit Policy",
    "update_rule": "Edit Rule",
    "delete_policy": "Delete Policy",
    "delete_policy_modal_message": "Are you sure you want to delete this policy?",
    "delete_rule": "Delete Rule",
    "delete_rule_modal_message": "Are you sure you want to delete this rule?",
    "rule_in_use": "Rule In Use",
    "rule_in_use_description": "This rule is being used in the following policies: {{policies}}",
    "incident_header": "Surveillance Incident",
    "builder": {
      "create_title": "Create Surveillance Policy",
      "edit_title": "Edit Surveillance Policy",
      "rules": {
        "title": "Surveillance Rules"
      }
    }
  },
  "field_is_required": "Field is required",
  "im_templates": {
    "title": "Templates",
    "create_template": "New Template",
    "edit_template": "Edit Template",
    "delete_template": "Delete Template",
    "delete_template_confirm": "Are you sure you want to delete this template?",
    "name": "Name",
    "content": "Message",
    "status": "Status",
    "status_active": "Active",
    "status_stopped": "Stopped",
    "created_at": "Created At",
    "updated_at": "Updated At",
    "attachments": "Attachments",
    "attachment_size_error": "Total attachment size must not exceed 10MB"
  }
}
